import He, { useState as Qe, useEffect as at, useId as Bi, forwardRef as zi, useRef as cn, useContext as Hi, createElement as Na, Component as Ia, createContext as Pa, useImperativeHandle as La, useCallback as In } from "react";
import Ma from "react-dom";
function Vi(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var ys = { exports: {} }, Xn = {};
var ko;
function Da() {
  if (ko) return Xn;
  ko = 1;
  var e = He, t = Symbol.for("react.element"), n = Symbol.for("react.fragment"), r = Object.prototype.hasOwnProperty, i = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, a = { key: !0, ref: !0, __self: !0, __source: !0 };
  function d(h, m, p) {
    var b, S = {}, E = null, P = null;
    p !== void 0 && (E = "" + p), m.key !== void 0 && (E = "" + m.key), m.ref !== void 0 && (P = m.ref);
    for (b in m) r.call(m, b) && !a.hasOwnProperty(b) && (S[b] = m[b]);
    if (h && h.defaultProps) for (b in m = h.defaultProps, m) S[b] === void 0 && (S[b] = m[b]);
    return { $$typeof: t, type: h, key: E, ref: P, props: S, _owner: i.current };
  }
  return Xn.Fragment = n, Xn.jsx = d, Xn.jsxs = d, Xn;
}
ys.exports = Da();
var f = ys.exports, xs = { exports: {} }, si, To;
function Fa() {
  if (To) return si;
  To = 1;
  var e = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  return si = e, si;
}
var ai, _o;
function $a() {
  if (_o) return ai;
  _o = 1;
  var e = Fa();
  function t() {
  }
  function n() {
  }
  return n.resetWarningCache = t, ai = function() {
    function r(d, h, m, p, b, S) {
      if (S !== e) {
        var E = new Error(
          "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
        );
        throw E.name = "Invariant Violation", E;
      }
    }
    r.isRequired = r;
    function i() {
      return r;
    }
    var a = {
      array: r,
      bigint: r,
      bool: r,
      func: r,
      number: r,
      object: r,
      string: r,
      symbol: r,
      any: r,
      arrayOf: i,
      element: r,
      elementType: r,
      instanceOf: i,
      node: r,
      objectOf: i,
      oneOf: i,
      oneOfType: i,
      shape: i,
      exact: i,
      checkPropTypes: n,
      resetWarningCache: t
    };
    return a.PropTypes = a, a;
  }, ai;
}
xs.exports = $a()();
var Ba = xs.exports;
const l = /* @__PURE__ */ Vi(Ba), za = () => {
  const [e, t] = Qe(null), [n, r] = Qe(!1), [i, a] = Qe(null), [d, h] = Qe("");
  return at(() => {
    if (!d) return;
    (() => {
      a(null), r(!0);
      try {
        fetch(d).then((p) => p.json()).then((p) => {
          t(p), r(!1);
        }).catch((p) => {
          a(p), r(!1);
        });
      } catch (p) {
        a(p);
      }
    })();
  }, [d]), [{ data: e, loading: n, error: i }, h];
};
function Ha(e) {
  const [t, n] = Qe(!1);
  return at(() => {
    const r = window.matchMedia(e);
    r.matches !== t && n(r.matches);
    const i = () => {
      n(r.matches);
    };
    return r.addEventListener("change", i), () => r.removeEventListener("change", i);
  }, [t, e]), t;
}
const Eo = (e, t, n) => e ? t : n, Or = (e) => (e || []).join(" ");
const {
  entries: bs,
  setPrototypeOf: Co,
  isFrozen: Va,
  getPrototypeOf: Wa,
  getOwnPropertyDescriptor: Ua
} = Object;
let {
  freeze: ct,
  seal: kt,
  create: jr
} = Object, {
  apply: yi,
  construct: xi
} = typeof Reflect < "u" && Reflect;
ct || (ct = function(t) {
  return t;
});
kt || (kt = function(t) {
  return t;
});
yi || (yi = function(t, n) {
  for (var r = arguments.length, i = new Array(r > 2 ? r - 2 : 0), a = 2; a < r; a++)
    i[a - 2] = arguments[a];
  return t.apply(n, i);
});
xi || (xi = function(t) {
  for (var n = arguments.length, r = new Array(n > 1 ? n - 1 : 0), i = 1; i < n; i++)
    r[i - 1] = arguments[i];
  return new t(...r);
});
const Sr = ut(Array.prototype.forEach), qa = ut(Array.prototype.lastIndexOf), Ro = ut(Array.prototype.pop), Kn = ut(Array.prototype.push), Ya = ut(Array.prototype.splice), Nr = ut(String.prototype.toLowerCase), li = ut(String.prototype.toString), ci = ut(String.prototype.match), Zn = ut(String.prototype.replace), Ga = ut(String.prototype.indexOf), Xa = ut(String.prototype.trim), bt = ut(Object.prototype.hasOwnProperty), st = ut(RegExp.prototype.test), Jn = Ka(TypeError);
function ut(e) {
  return function(t) {
    t instanceof RegExp && (t.lastIndex = 0);
    for (var n = arguments.length, r = new Array(n > 1 ? n - 1 : 0), i = 1; i < n; i++)
      r[i - 1] = arguments[i];
    return yi(e, t, r);
  };
}
function Ka(e) {
  return function() {
    for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++)
      n[r] = arguments[r];
    return xi(e, n);
  };
}
function pe(e, t) {
  let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : Nr;
  Co && Co(e, null);
  let r = t.length;
  for (; r--; ) {
    let i = t[r];
    if (typeof i == "string") {
      const a = n(i);
      a !== i && (Va(t) || (t[r] = a), i = a);
    }
    e[i] = !0;
  }
  return e;
}
function Za(e) {
  for (let t = 0; t < e.length; t++)
    bt(e, t) || (e[t] = null);
  return e;
}
function Ft(e) {
  const t = jr(null);
  for (const [n, r] of bs(e))
    bt(e, n) && (Array.isArray(r) ? t[n] = Za(r) : r && typeof r == "object" && r.constructor === Object ? t[n] = Ft(r) : t[n] = r);
  return t;
}
function Qn(e, t) {
  for (; e !== null; ) {
    const r = Ua(e, t);
    if (r) {
      if (r.get)
        return ut(r.get);
      if (typeof r.value == "function")
        return ut(r.value);
    }
    e = Wa(e);
  }
  function n() {
    return null;
  }
  return n;
}
const Ao = ct(["a", "abbr", "acronym", "address", "area", "article", "aside", "audio", "b", "bdi", "bdo", "big", "blink", "blockquote", "body", "br", "button", "canvas", "caption", "center", "cite", "code", "col", "colgroup", "content", "data", "datalist", "dd", "decorator", "del", "details", "dfn", "dialog", "dir", "div", "dl", "dt", "element", "em", "fieldset", "figcaption", "figure", "font", "footer", "form", "h1", "h2", "h3", "h4", "h5", "h6", "head", "header", "hgroup", "hr", "html", "i", "img", "input", "ins", "kbd", "label", "legend", "li", "main", "map", "mark", "marquee", "menu", "menuitem", "meter", "nav", "nobr", "ol", "optgroup", "option", "output", "p", "picture", "pre", "progress", "q", "rp", "rt", "ruby", "s", "samp", "search", "section", "select", "shadow", "slot", "small", "source", "spacer", "span", "strike", "strong", "style", "sub", "summary", "sup", "table", "tbody", "td", "template", "textarea", "tfoot", "th", "thead", "time", "tr", "track", "tt", "u", "ul", "var", "video", "wbr"]), ui = ct(["svg", "a", "altglyph", "altglyphdef", "altglyphitem", "animatecolor", "animatemotion", "animatetransform", "circle", "clippath", "defs", "desc", "ellipse", "enterkeyhint", "exportparts", "filter", "font", "g", "glyph", "glyphref", "hkern", "image", "inputmode", "line", "lineargradient", "marker", "mask", "metadata", "mpath", "part", "path", "pattern", "polygon", "polyline", "radialgradient", "rect", "stop", "style", "switch", "symbol", "text", "textpath", "title", "tref", "tspan", "view", "vkern"]), di = ct(["feBlend", "feColorMatrix", "feComponentTransfer", "feComposite", "feConvolveMatrix", "feDiffuseLighting", "feDisplacementMap", "feDistantLight", "feDropShadow", "feFlood", "feFuncA", "feFuncB", "feFuncG", "feFuncR", "feGaussianBlur", "feImage", "feMerge", "feMergeNode", "feMorphology", "feOffset", "fePointLight", "feSpecularLighting", "feSpotLight", "feTile", "feTurbulence"]), Ja = ct(["animate", "color-profile", "cursor", "discard", "font-face", "font-face-format", "font-face-name", "font-face-src", "font-face-uri", "foreignobject", "hatch", "hatchpath", "mesh", "meshgradient", "meshpatch", "meshrow", "missing-glyph", "script", "set", "solidcolor", "unknown", "use"]), fi = ct(["math", "menclose", "merror", "mfenced", "mfrac", "mglyph", "mi", "mlabeledtr", "mmultiscripts", "mn", "mo", "mover", "mpadded", "mphantom", "mroot", "mrow", "ms", "mspace", "msqrt", "mstyle", "msub", "msup", "msubsup", "mtable", "mtd", "mtext", "mtr", "munder", "munderover", "mprescripts"]), Qa = ct(["maction", "maligngroup", "malignmark", "mlongdiv", "mscarries", "mscarry", "msgroup", "mstack", "msline", "msrow", "semantics", "annotation", "annotation-xml", "mprescripts", "none"]), Oo = ct(["#text"]), jo = ct(["accept", "action", "align", "alt", "autocapitalize", "autocomplete", "autopictureinpicture", "autoplay", "background", "bgcolor", "border", "capture", "cellpadding", "cellspacing", "checked", "cite", "class", "clear", "color", "cols", "colspan", "controls", "controlslist", "coords", "crossorigin", "datetime", "decoding", "default", "dir", "disabled", "disablepictureinpicture", "disableremoteplayback", "download", "draggable", "enctype", "enterkeyhint", "exportparts", "face", "for", "headers", "height", "hidden", "high", "href", "hreflang", "id", "inert", "inputmode", "integrity", "ismap", "kind", "label", "lang", "list", "loading", "loop", "low", "max", "maxlength", "media", "method", "min", "minlength", "multiple", "muted", "name", "nonce", "noshade", "novalidate", "nowrap", "open", "optimum", "part", "pattern", "placeholder", "playsinline", "popover", "popovertarget", "popovertargetaction", "poster", "preload", "pubdate", "radiogroup", "readonly", "rel", "required", "rev", "reversed", "role", "rows", "rowspan", "spellcheck", "scope", "selected", "shape", "size", "sizes", "slot", "span", "srclang", "start", "src", "srcset", "step", "style", "summary", "tabindex", "title", "translate", "type", "usemap", "valign", "value", "width", "wrap", "xmlns", "slot"]), pi = ct(["accent-height", "accumulate", "additive", "alignment-baseline", "amplitude", "ascent", "attributename", "attributetype", "azimuth", "basefrequency", "baseline-shift", "begin", "bias", "by", "class", "clip", "clippathunits", "clip-path", "clip-rule", "color", "color-interpolation", "color-interpolation-filters", "color-profile", "color-rendering", "cx", "cy", "d", "dx", "dy", "diffuseconstant", "direction", "display", "divisor", "dur", "edgemode", "elevation", "end", "exponent", "fill", "fill-opacity", "fill-rule", "filter", "filterunits", "flood-color", "flood-opacity", "font-family", "font-size", "font-size-adjust", "font-stretch", "font-style", "font-variant", "font-weight", "fx", "fy", "g1", "g2", "glyph-name", "glyphref", "gradientunits", "gradienttransform", "height", "href", "id", "image-rendering", "in", "in2", "intercept", "k", "k1", "k2", "k3", "k4", "kerning", "keypoints", "keysplines", "keytimes", "lang", "lengthadjust", "letter-spacing", "kernelmatrix", "kernelunitlength", "lighting-color", "local", "marker-end", "marker-mid", "marker-start", "markerheight", "markerunits", "markerwidth", "maskcontentunits", "maskunits", "max", "mask", "mask-type", "media", "method", "mode", "min", "name", "numoctaves", "offset", "operator", "opacity", "order", "orient", "orientation", "origin", "overflow", "paint-order", "path", "pathlength", "patterncontentunits", "patterntransform", "patternunits", "points", "preservealpha", "preserveaspectratio", "primitiveunits", "r", "rx", "ry", "radius", "refx", "refy", "repeatcount", "repeatdur", "restart", "result", "rotate", "scale", "seed", "shape-rendering", "slope", "specularconstant", "specularexponent", "spreadmethod", "startoffset", "stddeviation", "stitchtiles", "stop-color", "stop-opacity", "stroke-dasharray", "stroke-dashoffset", "stroke-linecap", "stroke-linejoin", "stroke-miterlimit", "stroke-opacity", "stroke", "stroke-width", "style", "surfacescale", "systemlanguage", "tabindex", "tablevalues", "targetx", "targety", "transform", "transform-origin", "text-anchor", "text-decoration", "text-rendering", "textlength", "type", "u1", "u2", "unicode", "values", "viewbox", "visibility", "version", "vert-adv-y", "vert-origin-x", "vert-origin-y", "width", "word-spacing", "wrap", "writing-mode", "xchannelselector", "ychannelselector", "x", "x1", "x2", "xmlns", "y", "y1", "y2", "z", "zoomandpan"]), No = ct(["accent", "accentunder", "align", "bevelled", "close", "columnsalign", "columnlines", "columnspan", "denomalign", "depth", "dir", "display", "displaystyle", "encoding", "fence", "frame", "height", "href", "id", "largeop", "length", "linethickness", "lspace", "lquote", "mathbackground", "mathcolor", "mathsize", "mathvariant", "maxsize", "minsize", "movablelimits", "notation", "numalign", "open", "rowalign", "rowlines", "rowspacing", "rowspan", "rspace", "rquote", "scriptlevel", "scriptminsize", "scriptsizemultiplier", "selection", "separator", "separators", "stretchy", "subscriptshift", "supscriptshift", "symmetric", "voffset", "width", "xmlns"]), kr = ct(["xlink:href", "xml:id", "xlink:title", "xml:space", "xmlns:xlink"]), el = kt(/\{\{[\w\W]*|[\w\W]*\}\}/gm), tl = kt(/<%[\w\W]*|[\w\W]*%>/gm), nl = kt(/\$\{[\w\W]*/gm), rl = kt(/^data-[\-\w.\u00B7-\uFFFF]+$/), il = kt(/^aria-[\-\w]+$/), ws = kt(
  /^(?:(?:(?:f|ht)tps?|mailto|tel|callto|sms|cid|xmpp|matrix):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i
  // eslint-disable-line no-useless-escape
), ol = kt(/^(?:\w+script|data):/i), sl = kt(
  /[\u0000-\u0020\u00A0\u1680\u180E\u2000-\u2029\u205F\u3000]/g
  // eslint-disable-line no-control-regex
), Ss = kt(/^html$/i), al = kt(/^[a-z][.\w]*(-[.\w]+)+$/i);
var Io = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  ARIA_ATTR: il,
  ATTR_WHITESPACE: sl,
  CUSTOM_ELEMENT: al,
  DATA_ATTR: rl,
  DOCTYPE_NAME: Ss,
  ERB_EXPR: tl,
  IS_ALLOWED_URI: ws,
  IS_SCRIPT_OR_DATA: ol,
  MUSTACHE_EXPR: el,
  TMPLIT_EXPR: nl
});
const er = {
  element: 1,
  text: 3,
  // Deprecated
  progressingInstruction: 7,
  comment: 8,
  document: 9
}, ll = function() {
  return typeof window > "u" ? null : window;
}, cl = function(t, n) {
  if (typeof t != "object" || typeof t.createPolicy != "function")
    return null;
  let r = null;
  const i = "data-tt-policy-suffix";
  n && n.hasAttribute(i) && (r = n.getAttribute(i));
  const a = "dompurify" + (r ? "#" + r : "");
  try {
    return t.createPolicy(a, {
      createHTML(d) {
        return d;
      },
      createScriptURL(d) {
        return d;
      }
    });
  } catch {
    return console.warn("TrustedTypes policy " + a + " could not be created."), null;
  }
}, Po = function() {
  return {
    afterSanitizeAttributes: [],
    afterSanitizeElements: [],
    afterSanitizeShadowDOM: [],
    beforeSanitizeAttributes: [],
    beforeSanitizeElements: [],
    beforeSanitizeShadowDOM: [],
    uponSanitizeAttribute: [],
    uponSanitizeElement: [],
    uponSanitizeShadowNode: []
  };
};
function ks() {
  let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : ll();
  const t = (X) => ks(X);
  if (t.version = "3.3.2", t.removed = [], !e || !e.document || e.document.nodeType !== er.document || !e.Element)
    return t.isSupported = !1, t;
  let {
    document: n
  } = e;
  const r = n, i = r.currentScript, {
    DocumentFragment: a,
    HTMLTemplateElement: d,
    Node: h,
    Element: m,
    NodeFilter: p,
    NamedNodeMap: b = e.NamedNodeMap || e.MozNamedAttrMap,
    HTMLFormElement: S,
    DOMParser: E,
    trustedTypes: P
  } = e, A = m.prototype, k = Qn(A, "cloneNode"), N = Qn(A, "remove"), j = Qn(A, "nextSibling"), D = Qn(A, "childNodes"), V = Qn(A, "parentNode");
  if (typeof d == "function") {
    const X = n.createElement("template");
    X.content && X.content.ownerDocument && (n = X.content.ownerDocument);
  }
  let W, M = "";
  const {
    implementation: Z,
    createNodeIterator: le,
    createDocumentFragment: je,
    getElementsByTagName: $e
  } = n, {
    importNode: Ue
  } = r;
  let Se = Po();
  t.isSupported = typeof bs == "function" && typeof V == "function" && Z && Z.createHTMLDocument !== void 0;
  const {
    MUSTACHE_EXPR: ye,
    ERB_EXPR: J,
    TMPLIT_EXPR: he,
    DATA_ATTR: Ie,
    ARIA_ATTR: dt,
    IS_SCRIPT_OR_DATA: Be,
    ATTR_WHITESPACE: ze,
    CUSTOM_ELEMENT: qe
  } = Io;
  let {
    IS_ALLOWED_URI: ft
  } = Io, xe = null;
  const G = pe({}, [...Ao, ...ui, ...di, ...fi, ...Oo]);
  let z = null;
  const q = pe({}, [...jo, ...pi, ...No, ...kr]);
  let U = Object.seal(jr(null, {
    tagNameCheck: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: null
    },
    attributeNameCheck: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: null
    },
    allowCustomizedBuiltInElements: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: !1
    }
  })), O = null, ue = null;
  const $ = Object.seal(jr(null, {
    tagCheck: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: null
    },
    attributeCheck: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: null
    }
  }));
  let me = !0, ie = !0, oe = !1, Q = !0, se = !1, ke = !0, re = !1, Ne = !1, fe = !1, we = !1, Je = !1, Ce = !1, wt = !0, Ye = !1;
  const Re = "user-content-";
  let K = !0, be = !1, nt = {}, Ge = null;
  const Xe = pe({}, ["annotation-xml", "audio", "colgroup", "desc", "foreignobject", "head", "iframe", "math", "mi", "mn", "mo", "ms", "mtext", "noembed", "noframes", "noscript", "plaintext", "script", "style", "svg", "template", "thead", "title", "video", "xmp"]);
  let dn = null;
  const fn = pe({}, ["audio", "video", "img", "source", "image", "track"]);
  let pn = null;
  const Kt = pe({}, ["alt", "class", "for", "id", "label", "name", "pattern", "placeholder", "role", "summary", "title", "value", "style", "xmlns"]), Tt = "http://www.w3.org/1998/Math/MathML", Zt = "http://www.w3.org/2000/svg", ht = "http://www.w3.org/1999/xhtml";
  let Lt = ht, hn = !1, mn = null;
  const pt = pe({}, [Tt, Zt, ht], li);
  let Mt = pe({}, ["mi", "mo", "mn", "ms", "mtext"]), _t = pe({}, ["annotation-xml"]);
  const Te = pe({}, ["title", "style", "font", "a", "script"]);
  let mt = null;
  const Jt = ["application/xhtml+xml", "text/html"], Bt = "text/html";
  let _e = null, gt = null;
  const Et = n.createElement("form"), gn = function(w) {
    return w instanceof RegExp || w instanceof Function;
  }, zt = function() {
    let w = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    if (!(gt && gt === w)) {
      if ((!w || typeof w != "object") && (w = {}), w = Ft(w), mt = // eslint-disable-next-line unicorn/prefer-includes
      Jt.indexOf(w.PARSER_MEDIA_TYPE) === -1 ? Bt : w.PARSER_MEDIA_TYPE, _e = mt === "application/xhtml+xml" ? li : Nr, xe = bt(w, "ALLOWED_TAGS") ? pe({}, w.ALLOWED_TAGS, _e) : G, z = bt(w, "ALLOWED_ATTR") ? pe({}, w.ALLOWED_ATTR, _e) : q, mn = bt(w, "ALLOWED_NAMESPACES") ? pe({}, w.ALLOWED_NAMESPACES, li) : pt, pn = bt(w, "ADD_URI_SAFE_ATTR") ? pe(Ft(Kt), w.ADD_URI_SAFE_ATTR, _e) : Kt, dn = bt(w, "ADD_DATA_URI_TAGS") ? pe(Ft(fn), w.ADD_DATA_URI_TAGS, _e) : fn, Ge = bt(w, "FORBID_CONTENTS") ? pe({}, w.FORBID_CONTENTS, _e) : Xe, O = bt(w, "FORBID_TAGS") ? pe({}, w.FORBID_TAGS, _e) : Ft({}), ue = bt(w, "FORBID_ATTR") ? pe({}, w.FORBID_ATTR, _e) : Ft({}), nt = bt(w, "USE_PROFILES") ? w.USE_PROFILES : !1, me = w.ALLOW_ARIA_ATTR !== !1, ie = w.ALLOW_DATA_ATTR !== !1, oe = w.ALLOW_UNKNOWN_PROTOCOLS || !1, Q = w.ALLOW_SELF_CLOSE_IN_ATTR !== !1, se = w.SAFE_FOR_TEMPLATES || !1, ke = w.SAFE_FOR_XML !== !1, re = w.WHOLE_DOCUMENT || !1, we = w.RETURN_DOM || !1, Je = w.RETURN_DOM_FRAGMENT || !1, Ce = w.RETURN_TRUSTED_TYPE || !1, fe = w.FORCE_BODY || !1, wt = w.SANITIZE_DOM !== !1, Ye = w.SANITIZE_NAMED_PROPS || !1, K = w.KEEP_CONTENT !== !1, be = w.IN_PLACE || !1, ft = w.ALLOWED_URI_REGEXP || ws, Lt = w.NAMESPACE || ht, Mt = w.MATHML_TEXT_INTEGRATION_POINTS || Mt, _t = w.HTML_INTEGRATION_POINTS || _t, U = w.CUSTOM_ELEMENT_HANDLING || {}, w.CUSTOM_ELEMENT_HANDLING && gn(w.CUSTOM_ELEMENT_HANDLING.tagNameCheck) && (U.tagNameCheck = w.CUSTOM_ELEMENT_HANDLING.tagNameCheck), w.CUSTOM_ELEMENT_HANDLING && gn(w.CUSTOM_ELEMENT_HANDLING.attributeNameCheck) && (U.attributeNameCheck = w.CUSTOM_ELEMENT_HANDLING.attributeNameCheck), w.CUSTOM_ELEMENT_HANDLING && typeof w.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements == "boolean" && (U.allowCustomizedBuiltInElements = w.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements), se && (ie = !1), Je && (we = !0), nt && (xe = pe({}, Oo), z = jr(null), nt.html === !0 && (pe(xe, Ao), pe(z, jo)), nt.svg === !0 && (pe(xe, ui), pe(z, pi), pe(z, kr)), nt.svgFilters === !0 && (pe(xe, di), pe(z, pi), pe(z, kr)), nt.mathMl === !0 && (pe(xe, fi), pe(z, No), pe(z, kr))), bt(w, "ADD_TAGS") || ($.tagCheck = null), bt(w, "ADD_ATTR") || ($.attributeCheck = null), w.ADD_TAGS && (typeof w.ADD_TAGS == "function" ? $.tagCheck = w.ADD_TAGS : (xe === G && (xe = Ft(xe)), pe(xe, w.ADD_TAGS, _e))), w.ADD_ATTR && (typeof w.ADD_ATTR == "function" ? $.attributeCheck = w.ADD_ATTR : (z === q && (z = Ft(z)), pe(z, w.ADD_ATTR, _e))), w.ADD_URI_SAFE_ATTR && pe(pn, w.ADD_URI_SAFE_ATTR, _e), w.FORBID_CONTENTS && (Ge === Xe && (Ge = Ft(Ge)), pe(Ge, w.FORBID_CONTENTS, _e)), w.ADD_FORBID_CONTENTS && (Ge === Xe && (Ge = Ft(Ge)), pe(Ge, w.ADD_FORBID_CONTENTS, _e)), K && (xe["#text"] = !0), re && pe(xe, ["html", "head", "body"]), xe.table && (pe(xe, ["tbody"]), delete O.tbody), w.TRUSTED_TYPES_POLICY) {
        if (typeof w.TRUSTED_TYPES_POLICY.createHTML != "function")
          throw Jn('TRUSTED_TYPES_POLICY configuration option must provide a "createHTML" hook.');
        if (typeof w.TRUSTED_TYPES_POLICY.createScriptURL != "function")
          throw Jn('TRUSTED_TYPES_POLICY configuration option must provide a "createScriptURL" hook.');
        W = w.TRUSTED_TYPES_POLICY, M = W.createHTML("");
      } else
        W === void 0 && (W = cl(P, i)), W !== null && typeof M == "string" && (M = W.createHTML(""));
      ct && ct(w), gt = w;
    }
  }, Qt = pe({}, [...ui, ...di, ...Ja]), vn = pe({}, [...fi, ...Qa]), Rn = function(w) {
    let F = V(w);
    (!F || !F.tagName) && (F = {
      namespaceURI: Lt,
      tagName: "template"
    });
    const Y = Nr(w.tagName), Ae = Nr(F.tagName);
    return mn[w.namespaceURI] ? w.namespaceURI === Zt ? F.namespaceURI === ht ? Y === "svg" : F.namespaceURI === Tt ? Y === "svg" && (Ae === "annotation-xml" || Mt[Ae]) : !!Qt[Y] : w.namespaceURI === Tt ? F.namespaceURI === ht ? Y === "math" : F.namespaceURI === Zt ? Y === "math" && _t[Ae] : !!vn[Y] : w.namespaceURI === ht ? F.namespaceURI === Zt && !_t[Ae] || F.namespaceURI === Tt && !Mt[Ae] ? !1 : !vn[Y] && (Te[Y] || !Qt[Y]) : !!(mt === "application/xhtml+xml" && mn[w.namespaceURI]) : !1;
  }, rt = function(w) {
    Kn(t.removed, {
      element: w
    });
    try {
      V(w).removeChild(w);
    } catch {
      N(w);
    }
  }, Ct = function(w, F) {
    try {
      Kn(t.removed, {
        attribute: F.getAttributeNode(w),
        from: F
      });
    } catch {
      Kn(t.removed, {
        attribute: null,
        from: F
      });
    }
    if (F.removeAttribute(w), w === "is")
      if (we || Je)
        try {
          rt(F);
        } catch {
        }
      else
        try {
          F.setAttribute(w, "");
        } catch {
        }
  }, An = function(w) {
    let F = null, Y = null;
    if (fe)
      w = "<remove></remove>" + w;
    else {
      const ge = ci(w, /^[\r\n\t ]+/);
      Y = ge && ge[0];
    }
    mt === "application/xhtml+xml" && Lt === ht && (w = '<html xmlns="http://www.w3.org/1999/xhtml"><head></head><body>' + w + "</body></html>");
    const Ae = W ? W.createHTML(w) : w;
    if (Lt === ht)
      try {
        F = new E().parseFromString(Ae, mt);
      } catch {
      }
    if (!F || !F.documentElement) {
      F = Z.createDocument(Lt, "template", null);
      try {
        F.documentElement.innerHTML = hn ? M : Ae;
      } catch {
      }
    }
    const Ve = F.body || F.documentElement;
    return w && Y && Ve.insertBefore(n.createTextNode(Y), Ve.childNodes[0] || null), Lt === ht ? $e.call(F, re ? "html" : "body")[0] : re ? F.documentElement : Ve;
  }, Ht = function(w) {
    return le.call(
      w.ownerDocument || w,
      w,
      // eslint-disable-next-line no-bitwise
      p.SHOW_ELEMENT | p.SHOW_COMMENT | p.SHOW_TEXT | p.SHOW_PROCESSING_INSTRUCTION | p.SHOW_CDATA_SECTION,
      null
    );
  }, en = function(w) {
    return w instanceof S && (typeof w.nodeName != "string" || typeof w.textContent != "string" || typeof w.removeChild != "function" || !(w.attributes instanceof b) || typeof w.removeAttribute != "function" || typeof w.setAttribute != "function" || typeof w.namespaceURI != "string" || typeof w.insertBefore != "function" || typeof w.hasChildNodes != "function");
  }, Vt = function(w) {
    return typeof h == "function" && w instanceof h;
  };
  function it(X, w, F) {
    Sr(X, (Y) => {
      Y.call(t, w, F, gt);
    });
  }
  const On = function(w) {
    let F = null;
    if (it(Se.beforeSanitizeElements, w, null), en(w))
      return rt(w), !0;
    const Y = _e(w.nodeName);
    if (it(Se.uponSanitizeElement, w, {
      tagName: Y,
      allowedTags: xe
    }), ke && w.hasChildNodes() && !Vt(w.firstElementChild) && st(/<[/\w!]/g, w.innerHTML) && st(/<[/\w!]/g, w.textContent) || w.nodeType === er.progressingInstruction || ke && w.nodeType === er.comment && st(/<[/\w]/g, w.data))
      return rt(w), !0;
    if (!($.tagCheck instanceof Function && $.tagCheck(Y)) && (!xe[Y] || O[Y])) {
      if (!O[Y] && jn(Y) && (U.tagNameCheck instanceof RegExp && st(U.tagNameCheck, Y) || U.tagNameCheck instanceof Function && U.tagNameCheck(Y)))
        return !1;
      if (K && !Ge[Y]) {
        const Ae = V(w) || w.parentNode, Ve = D(w) || w.childNodes;
        if (Ve && Ae) {
          const ge = Ve.length;
          for (let Ke = ge - 1; Ke >= 0; --Ke) {
            const ot = k(Ve[Ke], !0);
            ot.__removalCount = (w.__removalCount || 0) + 1, Ae.insertBefore(ot, j(w));
          }
        }
      }
      return rt(w), !0;
    }
    return w instanceof m && !Rn(w) || (Y === "noscript" || Y === "noembed" || Y === "noframes") && st(/<\/no(script|embed|frames)/i, w.innerHTML) ? (rt(w), !0) : (se && w.nodeType === er.text && (F = w.textContent, Sr([ye, J, he], (Ae) => {
      F = Zn(F, Ae, " ");
    }), w.textContent !== F && (Kn(t.removed, {
      element: w.cloneNode()
    }), w.textContent = F)), it(Se.afterSanitizeElements, w, null), !1);
  }, Dt = function(w, F, Y) {
    if (ue[F] || wt && (F === "id" || F === "name") && (Y in n || Y in Et))
      return !1;
    if (!(ie && !ue[F] && st(Ie, F))) {
      if (!(me && st(dt, F))) {
        if (!($.attributeCheck instanceof Function && $.attributeCheck(F, w))) {
          if (!z[F] || ue[F]) {
            if (
              // First condition does a very basic check if a) it's basically a valid custom element tagname AND
              // b) if the tagName passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
              // and c) if the attribute name passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.attributeNameCheck
              !(jn(w) && (U.tagNameCheck instanceof RegExp && st(U.tagNameCheck, w) || U.tagNameCheck instanceof Function && U.tagNameCheck(w)) && (U.attributeNameCheck instanceof RegExp && st(U.attributeNameCheck, F) || U.attributeNameCheck instanceof Function && U.attributeNameCheck(F, w)) || // Alternative, second condition checks if it's an `is`-attribute, AND
              // the value passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
              F === "is" && U.allowCustomizedBuiltInElements && (U.tagNameCheck instanceof RegExp && st(U.tagNameCheck, Y) || U.tagNameCheck instanceof Function && U.tagNameCheck(Y)))
            ) return !1;
          } else if (!pn[F]) {
            if (!st(ft, Zn(Y, ze, ""))) {
              if (!((F === "src" || F === "xlink:href" || F === "href") && w !== "script" && Ga(Y, "data:") === 0 && dn[w])) {
                if (!(oe && !st(Be, Zn(Y, ze, "")))) {
                  if (Y)
                    return !1;
                }
              }
            }
          }
        }
      }
    }
    return !0;
  }, jn = function(w) {
    return w !== "annotation-xml" && ci(w, qe);
  }, tn = function(w) {
    it(Se.beforeSanitizeAttributes, w, null);
    const {
      attributes: F
    } = w;
    if (!F || en(w))
      return;
    const Y = {
      attrName: "",
      attrValue: "",
      keepAttr: !0,
      allowedAttributes: z,
      forceKeepAttr: void 0
    };
    let Ae = F.length;
    for (; Ae--; ) {
      const Ve = F[Ae], {
        name: ge,
        namespaceURI: Ke,
        value: ot
      } = Ve, St = _e(ge), rn = ot;
      let Pe = ge === "value" ? rn : Xa(rn);
      if (Y.attrName = St, Y.attrValue = Pe, Y.keepAttr = !0, Y.forceKeepAttr = void 0, it(Se.uponSanitizeAttribute, w, Y), Pe = Y.attrValue, Ye && (St === "id" || St === "name") && (Ct(ge, w), Pe = Re + Pe), ke && st(/((--!?|])>)|<\/(style|script|title|xmp|textarea|noscript|iframe|noembed|noframes)/i, Pe)) {
        Ct(ge, w);
        continue;
      }
      if (St === "attributename" && ci(Pe, "href")) {
        Ct(ge, w);
        continue;
      }
      if (Y.forceKeepAttr)
        continue;
      if (!Y.keepAttr) {
        Ct(ge, w);
        continue;
      }
      if (!Q && st(/\/>/i, Pe)) {
        Ct(ge, w);
        continue;
      }
      se && Sr([ye, J, he], (yn) => {
        Pe = Zn(Pe, yn, " ");
      });
      const Rt = _e(w.nodeName);
      if (!Dt(Rt, St, Pe)) {
        Ct(ge, w);
        continue;
      }
      if (W && typeof P == "object" && typeof P.getAttributeType == "function" && !Ke)
        switch (P.getAttributeType(Rt, St)) {
          case "TrustedHTML": {
            Pe = W.createHTML(Pe);
            break;
          }
          case "TrustedScriptURL": {
            Pe = W.createScriptURL(Pe);
            break;
          }
        }
      if (Pe !== rn)
        try {
          Ke ? w.setAttributeNS(Ke, ge, Pe) : w.setAttribute(ge, Pe), en(w) ? rt(w) : Ro(t.removed);
        } catch {
          Ct(ge, w);
        }
    }
    it(Se.afterSanitizeAttributes, w, null);
  }, nn = function X(w) {
    let F = null;
    const Y = Ht(w);
    for (it(Se.beforeSanitizeShadowDOM, w, null); F = Y.nextNode(); )
      it(Se.uponSanitizeShadowNode, F, null), On(F), tn(F), F.content instanceof a && X(F.content);
    it(Se.afterSanitizeShadowDOM, w, null);
  };
  return t.sanitize = function(X) {
    let w = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, F = null, Y = null, Ae = null, Ve = null;
    if (hn = !X, hn && (X = "<!-->"), typeof X != "string" && !Vt(X))
      if (typeof X.toString == "function") {
        if (X = X.toString(), typeof X != "string")
          throw Jn("dirty is not a string, aborting");
      } else
        throw Jn("toString is not a function");
    if (!t.isSupported)
      return X;
    if (Ne || zt(w), t.removed = [], typeof X == "string" && (be = !1), be) {
      if (X.nodeName) {
        const ot = _e(X.nodeName);
        if (!xe[ot] || O[ot])
          throw Jn("root node is forbidden and cannot be sanitized in-place");
      }
    } else if (X instanceof h)
      F = An("<!---->"), Y = F.ownerDocument.importNode(X, !0), Y.nodeType === er.element && Y.nodeName === "BODY" || Y.nodeName === "HTML" ? F = Y : F.appendChild(Y);
    else {
      if (!we && !se && !re && // eslint-disable-next-line unicorn/prefer-includes
      X.indexOf("<") === -1)
        return W && Ce ? W.createHTML(X) : X;
      if (F = An(X), !F)
        return we ? null : Ce ? M : "";
    }
    F && fe && rt(F.firstChild);
    const ge = Ht(be ? X : F);
    for (; Ae = ge.nextNode(); )
      On(Ae), tn(Ae), Ae.content instanceof a && nn(Ae.content);
    if (be)
      return X;
    if (we) {
      if (Je)
        for (Ve = je.call(F.ownerDocument); F.firstChild; )
          Ve.appendChild(F.firstChild);
      else
        Ve = F;
      return (z.shadowroot || z.shadowrootmode) && (Ve = Ue.call(r, Ve, !0)), Ve;
    }
    let Ke = re ? F.outerHTML : F.innerHTML;
    return re && xe["!doctype"] && F.ownerDocument && F.ownerDocument.doctype && F.ownerDocument.doctype.name && st(Ss, F.ownerDocument.doctype.name) && (Ke = "<!DOCTYPE " + F.ownerDocument.doctype.name + `>
` + Ke), se && Sr([ye, J, he], (ot) => {
      Ke = Zn(Ke, ot, " ");
    }), W && Ce ? W.createHTML(Ke) : Ke;
  }, t.setConfig = function() {
    let X = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    zt(X), Ne = !0;
  }, t.clearConfig = function() {
    gt = null, Ne = !1;
  }, t.isValidAttribute = function(X, w, F) {
    gt || zt({});
    const Y = _e(X), Ae = _e(w);
    return Dt(Y, Ae, F);
  }, t.addHook = function(X, w) {
    typeof w == "function" && Kn(Se[X], w);
  }, t.removeHook = function(X, w) {
    if (w !== void 0) {
      const F = qa(Se[X], w);
      return F === -1 ? void 0 : Ya(Se[X], F, 1)[0];
    }
    return Ro(Se[X]);
  }, t.removeHooks = function(X) {
    Se[X] = [];
  }, t.removeAllHooks = function() {
    Se = Po();
  }, t;
}
var Lo = ks();
let Tr = null;
function ul() {
  return Tr || (typeof window < "u" ? Tr = Lo(window) : Tr = Lo), Tr;
}
function dl(e) {
  const t = e ? document.querySelector(e) : document;
  return t ? t.querySelector(
    'button, [href], input, select, textarea, [tabIndex]:not([tabIndex="-1"])'
  ) : null;
}
const lt = (e) => ({ __html: ul().sanitize(e) }), Mo = (e, t, n) => {
  let r = e;
  const i = [];
  for (; r < t; )
    r > 0 && r <= n && i.push(r), r += 1;
  return i;
};
let hi = !1;
const bi = (e, t) => {
  hi || (hi = !0, setTimeout(() => {
    e(), hi = !1;
  }, t));
};
let Do;
const wi = (e, t) => {
  window.clearTimeout(Do), Do = window.setTimeout(e, t);
};
function fl(e) {
  if (e && typeof e.getBoundingClientRect == "function") {
    const { bottom: t, top: n } = e.getBoundingClientRect(), { offsetTop: r } = e;
    if (n < 0 && t > 0) {
      const i = e.style;
      e.style = `${i};transition: height 0s !important; overflow:hidden; height:${t}px!important;max-height:${t}px!important`, window.scrollTo({ behavior: "instant", top: r }), setTimeout(() => {
        e.style = i, window.scrollTo({
          behavior: "smooth",
          top: e.offsetTop - t / 2
        });
      }, 50);
    }
  }
}
l.shape({
  event: l.string,
  action: l.string,
  name: l.string,
  region: l.string,
  section: l.string,
  component: l.string,
  type: l.string,
  text: l.string
});
const Ts = ({
  event: e = "",
  action: t = "",
  name: n = "",
  type: r = "",
  section: i = "",
  text: a = "",
  region: d = "",
  component: h = ""
}) => {
  const { dataLayer: m } = window, p = {
    event: e.toLowerCase(),
    action: t.toLowerCase(),
    name: n.toLowerCase(),
    type: r.toLowerCase(),
    region: d.toLowerCase(),
    section: i.toLowerCase(),
    text: a.toLowerCase(),
    component: h.toLowerCase()
  };
  m && m.push(p);
}, ir = ({ children: e }) => /* @__PURE__ */ f.jsx(f.Fragment, { children: e });
ir.propTypes = {
  children: l.oneOfType([
    l.arrayOf(l.node),
    l.node,
    l.string
  ])
};
var _s = { exports: {} };
(function(e) {
  (function() {
    var t = {}.hasOwnProperty;
    function n() {
      for (var a = "", d = 0; d < arguments.length; d++) {
        var h = arguments[d];
        h && (a = i(a, r(h)));
      }
      return a;
    }
    function r(a) {
      if (typeof a == "string" || typeof a == "number")
        return a;
      if (typeof a != "object")
        return "";
      if (Array.isArray(a))
        return n.apply(null, a);
      if (a.toString !== Object.prototype.toString && !a.toString.toString().includes("[native code]"))
        return a.toString();
      var d = "";
      for (var h in a)
        t.call(a, h) && a[h] && (d = i(d, h));
      return d;
    }
    function i(a, d) {
      return d ? a ? a + " " + d : a + d : a;
    }
    e.exports ? (n.default = n, e.exports = n) : window.classNames = n;
  })();
})(_s);
var pl = _s.exports;
const ve = /* @__PURE__ */ Vi(pl);
({
  ...ir.propTypes
});
const Es = ({ children: e, className: t = "container", ...n }) => /* @__PURE__ */ f.jsx("div", { className: t, ...n, children: /* @__PURE__ */ f.jsx("div", { className: "row", children: e }) });
Es.propTypes = {
  children: ir.propTypes.children
};
({
  ...Es.propTypes
});
ir.propTypes.children, l.oneOf(["0", "3", "4", "6", "8", "9", "12"]);
ir.propTypes.children;
const hl = l.shape({
  url: l.string,
  altText: l.string,
  cssClass: l.arrayOf(l.string),
  size: l.oneOf(["small", "medium", "large"])
}), mi = l.shape({
  text: l.string,
  maxWidth: l.string,
  cssClass: l.arrayOf(l.string),
  highlightColor: l.oneOf(["gold", "black"])
}), Cs = l.shape({
  color: l.oneOf(["gold", "maroon", "gray", "dark"]),
  content: l.shape({
    icon: l.arrayOf(l.string),
    header: l.string,
    body: l.string
  })
}), Wi = l.shape({
  text: l.string,
  name: l.string,
  event: l.string,
  action: l.string,
  type: l.string,
  region: l.string,
  section: l.string,
  component: l.string
});
var Tn = {};
var Fo;
function ml() {
  if (Fo) return Tn;
  Fo = 1;
  var e = He;
  function t(o) {
    for (var u = "https://reactjs.org/docs/error-decoder.html?invariant=" + o, v = 1; v < arguments.length; v++) u += "&args[]=" + encodeURIComponent(arguments[v]);
    return "Minified React error #" + o + "; visit " + u + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
  }
  var n = Object.prototype.hasOwnProperty, r = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, i = {}, a = {};
  function d(o) {
    return n.call(a, o) ? !0 : n.call(i, o) ? !1 : r.test(o) ? a[o] = !0 : (i[o] = !0, !1);
  }
  function h(o, u, v, x, R, T, I) {
    this.acceptsBooleans = u === 2 || u === 3 || u === 4, this.attributeName = x, this.attributeNamespace = R, this.mustUseProperty = v, this.propertyName = o, this.type = u, this.sanitizeURL = T, this.removeEmptyString = I;
  }
  var m = {};
  "children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(o) {
    m[o] = new h(o, 0, !1, o, null, !1, !1);
  }), [["acceptCharset", "accept-charset"], ["className", "class"], ["htmlFor", "for"], ["httpEquiv", "http-equiv"]].forEach(function(o) {
    var u = o[0];
    m[u] = new h(u, 1, !1, o[1], null, !1, !1);
  }), ["contentEditable", "draggable", "spellCheck", "value"].forEach(function(o) {
    m[o] = new h(o, 2, !1, o.toLowerCase(), null, !1, !1);
  }), ["autoReverse", "externalResourcesRequired", "focusable", "preserveAlpha"].forEach(function(o) {
    m[o] = new h(o, 2, !1, o, null, !1, !1);
  }), "allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(o) {
    m[o] = new h(o, 3, !1, o.toLowerCase(), null, !1, !1);
  }), ["checked", "multiple", "muted", "selected"].forEach(function(o) {
    m[o] = new h(o, 3, !0, o, null, !1, !1);
  }), ["capture", "download"].forEach(function(o) {
    m[o] = new h(o, 4, !1, o, null, !1, !1);
  }), ["cols", "rows", "size", "span"].forEach(function(o) {
    m[o] = new h(o, 6, !1, o, null, !1, !1);
  }), ["rowSpan", "start"].forEach(function(o) {
    m[o] = new h(o, 5, !1, o.toLowerCase(), null, !1, !1);
  });
  var p = /[\-:]([a-z])/g;
  function b(o) {
    return o[1].toUpperCase();
  }
  "accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(o) {
    var u = o.replace(
      p,
      b
    );
    m[u] = new h(u, 1, !1, o, null, !1, !1);
  }), "xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(o) {
    var u = o.replace(p, b);
    m[u] = new h(u, 1, !1, o, "http://www.w3.org/1999/xlink", !1, !1);
  }), ["xml:base", "xml:lang", "xml:space"].forEach(function(o) {
    var u = o.replace(p, b);
    m[u] = new h(u, 1, !1, o, "http://www.w3.org/XML/1998/namespace", !1, !1);
  }), ["tabIndex", "crossOrigin"].forEach(function(o) {
    m[o] = new h(o, 1, !1, o.toLowerCase(), null, !1, !1);
  }), m.xlinkHref = new h("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1), ["src", "href", "action", "formAction"].forEach(function(o) {
    m[o] = new h(o, 1, !1, o.toLowerCase(), null, !0, !0);
  });
  var S = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
  }, E = ["Webkit", "ms", "Moz", "O"];
  Object.keys(S).forEach(function(o) {
    E.forEach(function(u) {
      u = u + o.charAt(0).toUpperCase() + o.substring(1), S[u] = S[o];
    });
  });
  var P = /["'&<>]/;
  function A(o) {
    if (typeof o == "boolean" || typeof o == "number") return "" + o;
    o = "" + o;
    var u = P.exec(o);
    if (u) {
      var v = "", x, R = 0;
      for (x = u.index; x < o.length; x++) {
        switch (o.charCodeAt(x)) {
          case 34:
            u = "&quot;";
            break;
          case 38:
            u = "&amp;";
            break;
          case 39:
            u = "&#x27;";
            break;
          case 60:
            u = "&lt;";
            break;
          case 62:
            u = "&gt;";
            break;
          default:
            continue;
        }
        R !== x && (v += o.substring(R, x)), R = x + 1, v += u;
      }
      o = R !== x ? v + o.substring(R, x) : v;
    }
    return o;
  }
  var k = /([A-Z])/g, N = /^ms-/, j = Array.isArray;
  function D(o, u) {
    return { insertionMode: o, selectedValue: u };
  }
  function V(o, u, v) {
    switch (u) {
      case "select":
        return D(1, v.value != null ? v.value : v.defaultValue);
      case "svg":
        return D(2, null);
      case "math":
        return D(3, null);
      case "foreignObject":
        return D(1, null);
      case "table":
        return D(4, null);
      case "thead":
      case "tbody":
      case "tfoot":
        return D(5, null);
      case "colgroup":
        return D(7, null);
      case "tr":
        return D(6, null);
    }
    return 4 <= o.insertionMode || o.insertionMode === 0 ? D(1, null) : o;
  }
  var W = /* @__PURE__ */ new Map();
  function M(o, u, v) {
    if (typeof v != "object") throw Error(t(62));
    u = !0;
    for (var x in v) if (n.call(v, x)) {
      var R = v[x];
      if (R != null && typeof R != "boolean" && R !== "") {
        if (x.indexOf("--") === 0) {
          var T = A(x);
          R = A(("" + R).trim());
        } else {
          T = x;
          var I = W.get(T);
          I !== void 0 || (I = A(T.replace(k, "-$1").toLowerCase().replace(N, "-ms-")), W.set(T, I)), T = I, R = typeof R == "number" ? R === 0 || n.call(S, x) ? "" + R : R + "px" : A(("" + R).trim());
        }
        u ? (u = !1, o.push(' style="', T, ":", R)) : o.push(";", T, ":", R);
      }
    }
    u || o.push('"');
  }
  function Z(o, u, v, x) {
    switch (v) {
      case "style":
        M(o, u, x);
        return;
      case "defaultValue":
      case "defaultChecked":
      case "innerHTML":
      case "suppressContentEditableWarning":
      case "suppressHydrationWarning":
        return;
    }
    if (!(2 < v.length) || v[0] !== "o" && v[0] !== "O" || v[1] !== "n" && v[1] !== "N") {
      if (u = m.hasOwnProperty(v) ? m[v] : null, u !== null) {
        switch (typeof x) {
          case "function":
          case "symbol":
            return;
          case "boolean":
            if (!u.acceptsBooleans) return;
        }
        switch (v = u.attributeName, u.type) {
          case 3:
            x && o.push(" ", v, '=""');
            break;
          case 4:
            x === !0 ? o.push(" ", v, '=""') : x !== !1 && o.push(" ", v, '="', A(x), '"');
            break;
          case 5:
            isNaN(x) || o.push(" ", v, '="', A(x), '"');
            break;
          case 6:
            !isNaN(x) && 1 <= x && o.push(" ", v, '="', A(x), '"');
            break;
          default:
            u.sanitizeURL && (x = "" + x), o.push(" ", v, '="', A(x), '"');
        }
      } else if (d(v)) {
        switch (typeof x) {
          case "function":
          case "symbol":
            return;
          case "boolean":
            if (u = v.toLowerCase().slice(0, 5), u !== "data-" && u !== "aria-") return;
        }
        o.push(" ", v, '="', A(x), '"');
      }
    }
  }
  function le(o, u, v) {
    if (u != null) {
      if (v != null) throw Error(t(60));
      if (typeof u != "object" || !("__html" in u)) throw Error(t(61));
      u = u.__html, u != null && o.push("" + u);
    }
  }
  function je(o) {
    var u = "";
    return e.Children.forEach(o, function(v) {
      v != null && (u += v);
    }), u;
  }
  function $e(o, u, v, x) {
    o.push(ye(v));
    var R = v = null, T;
    for (T in u) if (n.call(u, T)) {
      var I = u[T];
      if (I != null) switch (T) {
        case "children":
          v = I;
          break;
        case "dangerouslySetInnerHTML":
          R = I;
          break;
        default:
          Z(o, x, T, I);
      }
    }
    return o.push(">"), le(o, R, v), typeof v == "string" ? (o.push(A(v)), null) : v;
  }
  var Ue = /^[a-zA-Z][a-zA-Z:_\.\-\d]*$/, Se = /* @__PURE__ */ new Map();
  function ye(o) {
    var u = Se.get(o);
    if (u === void 0) {
      if (!Ue.test(o)) throw Error(t(65, o));
      u = "<" + o, Se.set(o, u);
    }
    return u;
  }
  function J(o, u, v, x, R) {
    switch (u) {
      case "select":
        o.push(ye("select"));
        var T = null, I = null;
        for (ae in v) if (n.call(v, ae)) {
          var H = v[ae];
          if (H != null) switch (ae) {
            case "children":
              T = H;
              break;
            case "dangerouslySetInnerHTML":
              I = H;
              break;
            case "defaultValue":
            case "value":
              break;
            default:
              Z(o, x, ae, H);
          }
        }
        return o.push(">"), le(o, I, T), T;
      case "option":
        I = R.selectedValue, o.push(ye("option"));
        var ee = H = null, ne = null, ae = null;
        for (T in v) if (n.call(v, T)) {
          var De = v[T];
          if (De != null) switch (T) {
            case "children":
              H = De;
              break;
            case "selected":
              ne = De;
              break;
            case "dangerouslySetInnerHTML":
              ae = De;
              break;
            case "value":
              ee = De;
            default:
              Z(o, x, T, De);
          }
        }
        if (I != null) if (v = ee !== null ? "" + ee : je(H), j(I)) {
          for (x = 0; x < I.length; x++)
            if ("" + I[x] === v) {
              o.push(' selected=""');
              break;
            }
        } else "" + I === v && o.push(' selected=""');
        else ne && o.push(' selected=""');
        return o.push(">"), le(o, ae, H), H;
      case "textarea":
        o.push(ye("textarea")), ae = I = T = null;
        for (H in v) if (n.call(v, H) && (ee = v[H], ee != null)) switch (H) {
          case "children":
            ae = ee;
            break;
          case "value":
            T = ee;
            break;
          case "defaultValue":
            I = ee;
            break;
          case "dangerouslySetInnerHTML":
            throw Error(t(91));
          default:
            Z(
              o,
              x,
              H,
              ee
            );
        }
        if (T === null && I !== null && (T = I), o.push(">"), ae != null) {
          if (T != null) throw Error(t(92));
          if (j(ae) && 1 < ae.length) throw Error(t(93));
          T = "" + ae;
        }
        return typeof T == "string" && T[0] === `
` && o.push(`
`), T !== null && o.push(A("" + T)), null;
      case "input":
        o.push(ye("input")), ee = ae = H = T = null;
        for (I in v) if (n.call(v, I) && (ne = v[I], ne != null)) switch (I) {
          case "children":
          case "dangerouslySetInnerHTML":
            throw Error(t(399, "input"));
          case "defaultChecked":
            ee = ne;
            break;
          case "defaultValue":
            H = ne;
            break;
          case "checked":
            ae = ne;
            break;
          case "value":
            T = ne;
            break;
          default:
            Z(o, x, I, ne);
        }
        return ae !== null ? Z(o, x, "checked", ae) : ee !== null && Z(o, x, "checked", ee), T !== null ? Z(o, x, "value", T) : H !== null && Z(o, x, "value", H), o.push("/>"), null;
      case "menuitem":
        o.push(ye("menuitem"));
        for (var At in v) if (n.call(v, At) && (T = v[At], T != null)) switch (At) {
          case "children":
          case "dangerouslySetInnerHTML":
            throw Error(t(400));
          default:
            Z(o, x, At, T);
        }
        return o.push(">"), null;
      case "title":
        o.push(ye("title")), T = null;
        for (De in v) if (n.call(v, De) && (I = v[De], I != null)) switch (De) {
          case "children":
            T = I;
            break;
          case "dangerouslySetInnerHTML":
            throw Error(t(434));
          default:
            Z(o, x, De, I);
        }
        return o.push(">"), T;
      case "listing":
      case "pre":
        o.push(ye(u)), I = T = null;
        for (ee in v) if (n.call(v, ee) && (H = v[ee], H != null)) switch (ee) {
          case "children":
            T = H;
            break;
          case "dangerouslySetInnerHTML":
            I = H;
            break;
          default:
            Z(o, x, ee, H);
        }
        if (o.push(">"), I != null) {
          if (T != null) throw Error(t(60));
          if (typeof I != "object" || !("__html" in I)) throw Error(t(61));
          v = I.__html, v != null && (typeof v == "string" && 0 < v.length && v[0] === `
` ? o.push(`
`, v) : o.push("" + v));
        }
        return typeof T == "string" && T[0] === `
` && o.push(`
`), T;
      case "area":
      case "base":
      case "br":
      case "col":
      case "embed":
      case "hr":
      case "img":
      case "keygen":
      case "link":
      case "meta":
      case "param":
      case "source":
      case "track":
      case "wbr":
        o.push(ye(u));
        for (var Ot in v) if (n.call(v, Ot) && (T = v[Ot], T != null)) switch (Ot) {
          case "children":
          case "dangerouslySetInnerHTML":
            throw Error(t(399, u));
          default:
            Z(o, x, Ot, T);
        }
        return o.push("/>"), null;
      case "annotation-xml":
      case "color-profile":
      case "font-face":
      case "font-face-src":
      case "font-face-uri":
      case "font-face-format":
      case "font-face-name":
      case "missing-glyph":
        return $e(
          o,
          v,
          u,
          x
        );
      case "html":
        return R.insertionMode === 0 && o.push("<!DOCTYPE html>"), $e(o, v, u, x);
      default:
        if (u.indexOf("-") === -1 && typeof v.is != "string") return $e(o, v, u, x);
        o.push(ye(u)), I = T = null;
        for (ne in v) if (n.call(v, ne) && (H = v[ne], H != null)) switch (ne) {
          case "children":
            T = H;
            break;
          case "dangerouslySetInnerHTML":
            I = H;
            break;
          case "style":
            M(o, x, H);
            break;
          case "suppressContentEditableWarning":
          case "suppressHydrationWarning":
            break;
          default:
            d(ne) && typeof H != "function" && typeof H != "symbol" && o.push(" ", ne, '="', A(H), '"');
        }
        return o.push(">"), le(o, I, T), T;
    }
  }
  function he(o, u, v) {
    if (o.push('<!--$?--><template id="'), v === null) throw Error(t(395));
    return o.push(v), o.push('"></template>');
  }
  function Ie(o, u, v, x) {
    switch (v.insertionMode) {
      case 0:
      case 1:
        return o.push('<div hidden id="'), o.push(u.segmentPrefix), u = x.toString(16), o.push(u), o.push('">');
      case 2:
        return o.push('<svg aria-hidden="true" style="display:none" id="'), o.push(u.segmentPrefix), u = x.toString(16), o.push(u), o.push('">');
      case 3:
        return o.push('<math aria-hidden="true" style="display:none" id="'), o.push(u.segmentPrefix), u = x.toString(16), o.push(u), o.push('">');
      case 4:
        return o.push('<table hidden id="'), o.push(u.segmentPrefix), u = x.toString(16), o.push(u), o.push('">');
      case 5:
        return o.push('<table hidden><tbody id="'), o.push(u.segmentPrefix), u = x.toString(16), o.push(u), o.push('">');
      case 6:
        return o.push('<table hidden><tr id="'), o.push(u.segmentPrefix), u = x.toString(16), o.push(u), o.push('">');
      case 7:
        return o.push('<table hidden><colgroup id="'), o.push(u.segmentPrefix), u = x.toString(16), o.push(u), o.push('">');
      default:
        throw Error(t(397));
    }
  }
  function dt(o, u) {
    switch (u.insertionMode) {
      case 0:
      case 1:
        return o.push("</div>");
      case 2:
        return o.push("</svg>");
      case 3:
        return o.push("</math>");
      case 4:
        return o.push("</table>");
      case 5:
        return o.push("</tbody></table>");
      case 6:
        return o.push("</tr></table>");
      case 7:
        return o.push("</colgroup></table>");
      default:
        throw Error(t(397));
    }
  }
  var Be = /[<\u2028\u2029]/g;
  function ze(o) {
    return JSON.stringify(o).replace(Be, function(u) {
      switch (u) {
        case "<":
          return "\\u003c";
        case "\u2028":
          return "\\u2028";
        case "\u2029":
          return "\\u2029";
        default:
          throw Error("escapeJSStringsForInstructionScripts encountered a match it does not know how to replace. this means the match regex and the replacement characters are no longer in sync. This is a bug in React");
      }
    });
  }
  function qe(o, u) {
    return u = u === void 0 ? "" : u, { bootstrapChunks: [], startInlineScript: "<script>", placeholderPrefix: u + "P:", segmentPrefix: u + "S:", boundaryPrefix: u + "B:", idPrefix: u, nextSuspenseID: 0, sentCompleteSegmentFunction: !1, sentCompleteBoundaryFunction: !1, sentClientRenderFunction: !1, generateStaticMarkup: o };
  }
  function ft(o, u, v, x) {
    return v.generateStaticMarkup ? (o.push(A(u)), !1) : (u === "" ? o = x : (x && o.push("<!-- -->"), o.push(A(u)), o = !0), o);
  }
  var xe = Object.assign, G = Symbol.for("react.element"), z = Symbol.for("react.portal"), q = Symbol.for("react.fragment"), U = Symbol.for("react.strict_mode"), O = Symbol.for("react.profiler"), ue = Symbol.for("react.provider"), $ = Symbol.for("react.context"), me = Symbol.for("react.forward_ref"), ie = Symbol.for("react.suspense"), oe = Symbol.for("react.suspense_list"), Q = Symbol.for("react.memo"), se = Symbol.for("react.lazy"), ke = Symbol.for("react.scope"), re = Symbol.for("react.debug_trace_mode"), Ne = Symbol.for("react.legacy_hidden"), fe = Symbol.for("react.default_value"), we = Symbol.iterator;
  function Je(o) {
    if (o == null) return null;
    if (typeof o == "function") return o.displayName || o.name || null;
    if (typeof o == "string") return o;
    switch (o) {
      case q:
        return "Fragment";
      case z:
        return "Portal";
      case O:
        return "Profiler";
      case U:
        return "StrictMode";
      case ie:
        return "Suspense";
      case oe:
        return "SuspenseList";
    }
    if (typeof o == "object") switch (o.$$typeof) {
      case $:
        return (o.displayName || "Context") + ".Consumer";
      case ue:
        return (o._context.displayName || "Context") + ".Provider";
      case me:
        var u = o.render;
        return o = o.displayName, o || (o = u.displayName || u.name || "", o = o !== "" ? "ForwardRef(" + o + ")" : "ForwardRef"), o;
      case Q:
        return u = o.displayName || null, u !== null ? u : Je(o.type) || "Memo";
      case se:
        u = o._payload, o = o._init;
        try {
          return Je(o(u));
        } catch {
        }
    }
    return null;
  }
  var Ce = {};
  function wt(o, u) {
    if (o = o.contextTypes, !o) return Ce;
    var v = {}, x;
    for (x in o) v[x] = u[x];
    return v;
  }
  var Ye = null;
  function Re(o, u) {
    if (o !== u) {
      o.context._currentValue2 = o.parentValue, o = o.parent;
      var v = u.parent;
      if (o === null) {
        if (v !== null) throw Error(t(401));
      } else {
        if (v === null) throw Error(t(401));
        Re(o, v);
      }
      u.context._currentValue2 = u.value;
    }
  }
  function K(o) {
    o.context._currentValue2 = o.parentValue, o = o.parent, o !== null && K(o);
  }
  function be(o) {
    var u = o.parent;
    u !== null && be(u), o.context._currentValue2 = o.value;
  }
  function nt(o, u) {
    if (o.context._currentValue2 = o.parentValue, o = o.parent, o === null) throw Error(t(402));
    o.depth === u.depth ? Re(o, u) : nt(o, u);
  }
  function Ge(o, u) {
    var v = u.parent;
    if (v === null) throw Error(t(402));
    o.depth === v.depth ? Re(o, v) : Ge(o, v), u.context._currentValue2 = u.value;
  }
  function Xe(o) {
    var u = Ye;
    u !== o && (u === null ? be(o) : o === null ? K(u) : u.depth === o.depth ? Re(u, o) : u.depth > o.depth ? nt(u, o) : Ge(u, o), Ye = o);
  }
  var dn = { isMounted: function() {
    return !1;
  }, enqueueSetState: function(o, u) {
    o = o._reactInternals, o.queue !== null && o.queue.push(u);
  }, enqueueReplaceState: function(o, u) {
    o = o._reactInternals, o.replace = !0, o.queue = [u];
  }, enqueueForceUpdate: function() {
  } };
  function fn(o, u, v, x) {
    var R = o.state !== void 0 ? o.state : null;
    o.updater = dn, o.props = v, o.state = R;
    var T = { queue: [], replace: !1 };
    o._reactInternals = T;
    var I = u.contextType;
    if (o.context = typeof I == "object" && I !== null ? I._currentValue2 : x, I = u.getDerivedStateFromProps, typeof I == "function" && (I = I(v, R), R = I == null ? R : xe({}, R, I), o.state = R), typeof u.getDerivedStateFromProps != "function" && typeof o.getSnapshotBeforeUpdate != "function" && (typeof o.UNSAFE_componentWillMount == "function" || typeof o.componentWillMount == "function")) if (u = o.state, typeof o.componentWillMount == "function" && o.componentWillMount(), typeof o.UNSAFE_componentWillMount == "function" && o.UNSAFE_componentWillMount(), u !== o.state && dn.enqueueReplaceState(o, o.state, null), T.queue !== null && 0 < T.queue.length) if (u = T.queue, I = T.replace, T.queue = null, T.replace = !1, I && u.length === 1) o.state = u[0];
    else {
      for (T = I ? u[0] : o.state, R = !0, I = I ? 1 : 0; I < u.length; I++) {
        var H = u[I];
        H = typeof H == "function" ? H.call(o, T, v, x) : H, H != null && (R ? (R = !1, T = xe({}, T, H)) : xe(T, H));
      }
      o.state = T;
    }
    else T.queue = null;
  }
  var pn = { id: 1, overflow: "" };
  function Kt(o, u, v) {
    var x = o.id;
    o = o.overflow;
    var R = 32 - Tt(x) - 1;
    x &= ~(1 << R), v += 1;
    var T = 32 - Tt(u) + R;
    if (30 < T) {
      var I = R - R % 5;
      return T = (x & (1 << I) - 1).toString(32), x >>= I, R -= I, { id: 1 << 32 - Tt(u) + R | v << R | x, overflow: T + o };
    }
    return { id: 1 << T | v << R | x, overflow: o };
  }
  var Tt = Math.clz32 ? Math.clz32 : Lt, Zt = Math.log, ht = Math.LN2;
  function Lt(o) {
    return o >>>= 0, o === 0 ? 32 : 31 - (Zt(o) / ht | 0) | 0;
  }
  function hn(o, u) {
    return o === u && (o !== 0 || 1 / o === 1 / u) || o !== o && u !== u;
  }
  var mn = typeof Object.is == "function" ? Object.is : hn, pt = null, Mt = null, _t = null, Te = null, mt = !1, Jt = !1, Bt = 0, _e = null, gt = 0;
  function Et() {
    if (pt === null) throw Error(t(321));
    return pt;
  }
  function gn() {
    if (0 < gt) throw Error(t(312));
    return { memoizedState: null, queue: null, next: null };
  }
  function zt() {
    return Te === null ? _t === null ? (mt = !1, _t = Te = gn()) : (mt = !0, Te = _t) : Te.next === null ? (mt = !1, Te = Te.next = gn()) : (mt = !0, Te = Te.next), Te;
  }
  function Qt() {
    Mt = pt = null, Jt = !1, _t = null, gt = 0, Te = _e = null;
  }
  function vn(o, u) {
    return typeof u == "function" ? u(o) : u;
  }
  function Rn(o, u, v) {
    if (pt = Et(), Te = zt(), mt) {
      var x = Te.queue;
      if (u = x.dispatch, _e !== null && (v = _e.get(x), v !== void 0)) {
        _e.delete(x), x = Te.memoizedState;
        do
          x = o(x, v.action), v = v.next;
        while (v !== null);
        return Te.memoizedState = x, [x, u];
      }
      return [Te.memoizedState, u];
    }
    return o = o === vn ? typeof u == "function" ? u() : u : v !== void 0 ? v(u) : u, Te.memoizedState = o, o = Te.queue = { last: null, dispatch: null }, o = o.dispatch = Ct.bind(null, pt, o), [Te.memoizedState, o];
  }
  function rt(o, u) {
    if (pt = Et(), Te = zt(), u = u === void 0 ? null : u, Te !== null) {
      var v = Te.memoizedState;
      if (v !== null && u !== null) {
        var x = v[1];
        e: if (x === null) x = !1;
        else {
          for (var R = 0; R < x.length && R < u.length; R++) if (!mn(u[R], x[R])) {
            x = !1;
            break e;
          }
          x = !0;
        }
        if (x) return v[0];
      }
    }
    return o = o(), Te.memoizedState = [o, u], o;
  }
  function Ct(o, u, v) {
    if (25 <= gt) throw Error(t(301));
    if (o === pt) if (Jt = !0, o = { action: v, next: null }, _e === null && (_e = /* @__PURE__ */ new Map()), v = _e.get(u), v === void 0) _e.set(u, o);
    else {
      for (u = v; u.next !== null; ) u = u.next;
      u.next = o;
    }
  }
  function An() {
    throw Error(t(394));
  }
  function Ht() {
  }
  var en = { readContext: function(o) {
    return o._currentValue2;
  }, useContext: function(o) {
    return Et(), o._currentValue2;
  }, useMemo: rt, useReducer: Rn, useRef: function(o) {
    pt = Et(), Te = zt();
    var u = Te.memoizedState;
    return u === null ? (o = { current: o }, Te.memoizedState = o) : u;
  }, useState: function(o) {
    return Rn(vn, o);
  }, useInsertionEffect: Ht, useLayoutEffect: function() {
  }, useCallback: function(o, u) {
    return rt(function() {
      return o;
    }, u);
  }, useImperativeHandle: Ht, useEffect: Ht, useDebugValue: Ht, useDeferredValue: function(o) {
    return Et(), o;
  }, useTransition: function() {
    return Et(), [
      !1,
      An
    ];
  }, useId: function() {
    var o = Mt.treeContext, u = o.overflow;
    o = o.id, o = (o & ~(1 << 32 - Tt(o) - 1)).toString(32) + u;
    var v = Vt;
    if (v === null) throw Error(t(404));
    return u = Bt++, o = ":" + v.idPrefix + "R" + o, 0 < u && (o += "H" + u.toString(32)), o + ":";
  }, useMutableSource: function(o, u) {
    return Et(), u(o._source);
  }, useSyncExternalStore: function(o, u, v) {
    if (v === void 0) throw Error(t(407));
    return v();
  } }, Vt = null, it = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentDispatcher;
  function On(o) {
    return console.error(o), null;
  }
  function Dt() {
  }
  function jn(o, u, v, x, R, T, I, H, ee) {
    var ne = [], ae = /* @__PURE__ */ new Set();
    return u = { destination: null, responseState: u, progressiveChunkSize: x === void 0 ? 12800 : x, status: 0, fatalError: null, nextSegmentId: 0, allPendingTasks: 0, pendingRootTasks: 0, completedRootSegment: null, abortableTasks: ae, pingedTasks: ne, clientRenderedBoundaries: [], completedBoundaries: [], partialBoundaries: [], onError: R === void 0 ? On : R, onAllReady: Dt, onShellReady: I === void 0 ? Dt : I, onShellError: Dt, onFatalError: Dt }, v = nn(u, 0, null, v, !1, !1), v.parentFlushed = !0, o = tn(u, o, null, v, ae, Ce, null, pn), ne.push(o), u;
  }
  function tn(o, u, v, x, R, T, I, H) {
    o.allPendingTasks++, v === null ? o.pendingRootTasks++ : v.pendingTasks++;
    var ee = { node: u, ping: function() {
      var ne = o.pingedTasks;
      ne.push(ee), ne.length === 1 && yn(o);
    }, blockedBoundary: v, blockedSegment: x, abortSet: R, legacyContext: T, context: I, treeContext: H };
    return R.add(ee), ee;
  }
  function nn(o, u, v, x, R, T) {
    return { status: 0, id: -1, index: u, parentFlushed: !1, chunks: [], children: [], formatContext: x, boundary: v, lastPushedText: R, textEmbedded: T };
  }
  function X(o, u) {
    if (o = o.onError(u), o != null && typeof o != "string") throw Error('onError returned something with a type other than "string". onError should return a string and may return null or undefined but must not return anything else. It received something of type "' + typeof o + '" instead');
    return o;
  }
  function w(o, u) {
    var v = o.onShellError;
    v(u), v = o.onFatalError, v(u), o.destination !== null ? (o.status = 2, o.destination.destroy(u)) : (o.status = 1, o.fatalError = u);
  }
  function F(o, u, v, x, R) {
    for (pt = {}, Mt = u, Bt = 0, o = v(x, R); Jt; ) Jt = !1, Bt = 0, gt += 1, Te = null, o = v(x, R);
    return Qt(), o;
  }
  function Y(o, u, v, x) {
    var R = v.render(), T = x.childContextTypes;
    if (T != null) {
      var I = u.legacyContext;
      if (typeof v.getChildContext != "function") x = I;
      else {
        v = v.getChildContext();
        for (var H in v) if (!(H in T)) throw Error(t(108, Je(x) || "Unknown", H));
        x = xe({}, I, v);
      }
      u.legacyContext = x, ge(o, u, R), u.legacyContext = I;
    } else ge(o, u, R);
  }
  function Ae(o, u) {
    if (o && o.defaultProps) {
      u = xe({}, u), o = o.defaultProps;
      for (var v in o) u[v] === void 0 && (u[v] = o[v]);
      return u;
    }
    return u;
  }
  function Ve(o, u, v, x, R) {
    if (typeof v == "function") if (v.prototype && v.prototype.isReactComponent) {
      R = wt(v, u.legacyContext);
      var T = v.contextType;
      T = new v(x, typeof T == "object" && T !== null ? T._currentValue2 : R), fn(T, v, x, R), Y(o, u, T, v);
    } else {
      T = wt(v, u.legacyContext), R = F(o, u, v, x, T);
      var I = Bt !== 0;
      if (typeof R == "object" && R !== null && typeof R.render == "function" && R.$$typeof === void 0) fn(R, v, x, T), Y(o, u, R, v);
      else if (I) {
        x = u.treeContext, u.treeContext = Kt(x, 1, 0);
        try {
          ge(o, u, R);
        } finally {
          u.treeContext = x;
        }
      } else ge(o, u, R);
    }
    else if (typeof v == "string") {
      switch (R = u.blockedSegment, T = J(R.chunks, v, x, o.responseState, R.formatContext), R.lastPushedText = !1, I = R.formatContext, R.formatContext = V(I, v, x), ot(o, u, T), R.formatContext = I, v) {
        case "area":
        case "base":
        case "br":
        case "col":
        case "embed":
        case "hr":
        case "img":
        case "input":
        case "keygen":
        case "link":
        case "meta":
        case "param":
        case "source":
        case "track":
        case "wbr":
          break;
        default:
          R.chunks.push("</", v, ">");
      }
      R.lastPushedText = !1;
    } else {
      switch (v) {
        case Ne:
        case re:
        case U:
        case O:
        case q:
          ge(o, u, x.children);
          return;
        case oe:
          ge(o, u, x.children);
          return;
        case ke:
          throw Error(t(343));
        case ie:
          e: {
            v = u.blockedBoundary, R = u.blockedSegment, T = x.fallback, x = x.children, I = /* @__PURE__ */ new Set();
            var H = { id: null, rootSegmentID: -1, parentFlushed: !1, pendingTasks: 0, forceClientRender: !1, completedSegments: [], byteSize: 0, fallbackAbortableTasks: I, errorDigest: null }, ee = nn(o, R.chunks.length, H, R.formatContext, !1, !1);
            R.children.push(ee), R.lastPushedText = !1;
            var ne = nn(o, 0, null, R.formatContext, !1, !1);
            ne.parentFlushed = !0, u.blockedBoundary = H, u.blockedSegment = ne;
            try {
              if (ot(
                o,
                u,
                x
              ), o.responseState.generateStaticMarkup || ne.lastPushedText && ne.textEmbedded && ne.chunks.push("<!-- -->"), ne.status = 1, Pe(H, ne), H.pendingTasks === 0) break e;
            } catch (ae) {
              ne.status = 4, H.forceClientRender = !0, H.errorDigest = X(o, ae);
            } finally {
              u.blockedBoundary = v, u.blockedSegment = R;
            }
            u = tn(o, T, v, ee, I, u.legacyContext, u.context, u.treeContext), o.pingedTasks.push(u);
          }
          return;
      }
      if (typeof v == "object" && v !== null) switch (v.$$typeof) {
        case me:
          if (x = F(o, u, v.render, x, R), Bt !== 0) {
            v = u.treeContext, u.treeContext = Kt(v, 1, 0);
            try {
              ge(o, u, x);
            } finally {
              u.treeContext = v;
            }
          } else ge(o, u, x);
          return;
        case Q:
          v = v.type, x = Ae(v, x), Ve(o, u, v, x, R);
          return;
        case ue:
          if (R = x.children, v = v._context, x = x.value, T = v._currentValue2, v._currentValue2 = x, I = Ye, Ye = x = { parent: I, depth: I === null ? 0 : I.depth + 1, context: v, parentValue: T, value: x }, u.context = x, ge(o, u, R), o = Ye, o === null) throw Error(t(403));
          x = o.parentValue, o.context._currentValue2 = x === fe ? o.context._defaultValue : x, o = Ye = o.parent, u.context = o;
          return;
        case $:
          x = x.children, x = x(v._currentValue2), ge(o, u, x);
          return;
        case se:
          R = v._init, v = R(v._payload), x = Ae(v, x), Ve(
            o,
            u,
            v,
            x,
            void 0
          );
          return;
      }
      throw Error(t(130, v == null ? v : typeof v, ""));
    }
  }
  function ge(o, u, v) {
    if (u.node = v, typeof v == "object" && v !== null) {
      switch (v.$$typeof) {
        case G:
          Ve(o, u, v.type, v.props, v.ref);
          return;
        case z:
          throw Error(t(257));
        case se:
          var x = v._init;
          v = x(v._payload), ge(o, u, v);
          return;
      }
      if (j(v)) {
        Ke(o, u, v);
        return;
      }
      if (v === null || typeof v != "object" ? x = null : (x = we && v[we] || v["@@iterator"], x = typeof x == "function" ? x : null), x && (x = x.call(v))) {
        if (v = x.next(), !v.done) {
          var R = [];
          do
            R.push(v.value), v = x.next();
          while (!v.done);
          Ke(o, u, R);
        }
        return;
      }
      throw o = Object.prototype.toString.call(v), Error(t(31, o === "[object Object]" ? "object with keys {" + Object.keys(v).join(", ") + "}" : o));
    }
    typeof v == "string" ? (x = u.blockedSegment, x.lastPushedText = ft(u.blockedSegment.chunks, v, o.responseState, x.lastPushedText)) : typeof v == "number" && (x = u.blockedSegment, x.lastPushedText = ft(u.blockedSegment.chunks, "" + v, o.responseState, x.lastPushedText));
  }
  function Ke(o, u, v) {
    for (var x = v.length, R = 0; R < x; R++) {
      var T = u.treeContext;
      u.treeContext = Kt(T, x, R);
      try {
        ot(o, u, v[R]);
      } finally {
        u.treeContext = T;
      }
    }
  }
  function ot(o, u, v) {
    var x = u.blockedSegment.formatContext, R = u.legacyContext, T = u.context;
    try {
      return ge(o, u, v);
    } catch (ee) {
      if (Qt(), typeof ee == "object" && ee !== null && typeof ee.then == "function") {
        v = ee;
        var I = u.blockedSegment, H = nn(o, I.chunks.length, null, I.formatContext, I.lastPushedText, !0);
        I.children.push(H), I.lastPushedText = !1, o = tn(o, u.node, u.blockedBoundary, H, u.abortSet, u.legacyContext, u.context, u.treeContext).ping, v.then(o, o), u.blockedSegment.formatContext = x, u.legacyContext = R, u.context = T, Xe(T);
      } else throw u.blockedSegment.formatContext = x, u.legacyContext = R, u.context = T, Xe(T), ee;
    }
  }
  function St(o) {
    var u = o.blockedBoundary;
    o = o.blockedSegment, o.status = 3, Rt(this, u, o);
  }
  function rn(o, u, v) {
    var x = o.blockedBoundary;
    o.blockedSegment.status = 3, x === null ? (u.allPendingTasks--, u.status !== 2 && (u.status = 2, u.destination !== null && u.destination.push(null))) : (x.pendingTasks--, x.forceClientRender || (x.forceClientRender = !0, o = v === void 0 ? Error(t(432)) : v, x.errorDigest = u.onError(o), x.parentFlushed && u.clientRenderedBoundaries.push(x)), x.fallbackAbortableTasks.forEach(function(R) {
      return rn(R, u, v);
    }), x.fallbackAbortableTasks.clear(), u.allPendingTasks--, u.allPendingTasks === 0 && (x = u.onAllReady, x()));
  }
  function Pe(o, u) {
    if (u.chunks.length === 0 && u.children.length === 1 && u.children[0].boundary === null) {
      var v = u.children[0];
      v.id = u.id, v.parentFlushed = !0, v.status === 1 && Pe(o, v);
    } else o.completedSegments.push(u);
  }
  function Rt(o, u, v) {
    if (u === null) {
      if (v.parentFlushed) {
        if (o.completedRootSegment !== null) throw Error(t(389));
        o.completedRootSegment = v;
      }
      o.pendingRootTasks--, o.pendingRootTasks === 0 && (o.onShellError = Dt, u = o.onShellReady, u());
    } else u.pendingTasks--, u.forceClientRender || (u.pendingTasks === 0 ? (v.parentFlushed && v.status === 1 && Pe(u, v), u.parentFlushed && o.completedBoundaries.push(u), u.fallbackAbortableTasks.forEach(St, o), u.fallbackAbortableTasks.clear()) : v.parentFlushed && v.status === 1 && (Pe(u, v), u.completedSegments.length === 1 && u.parentFlushed && o.partialBoundaries.push(u)));
    o.allPendingTasks--, o.allPendingTasks === 0 && (o = o.onAllReady, o());
  }
  function yn(o) {
    if (o.status !== 2) {
      var u = Ye, v = it.current;
      it.current = en;
      var x = Vt;
      Vt = o.responseState;
      try {
        var R = o.pingedTasks, T;
        for (T = 0; T < R.length; T++) {
          var I = R[T], H = o, ee = I.blockedSegment;
          if (ee.status === 0) {
            Xe(I.context);
            try {
              ge(H, I, I.node), H.responseState.generateStaticMarkup || ee.lastPushedText && ee.textEmbedded && ee.chunks.push("<!-- -->"), I.abortSet.delete(I), ee.status = 1, Rt(H, I.blockedBoundary, ee);
            } catch (vt) {
              if (Qt(), typeof vt == "object" && vt !== null && typeof vt.then == "function") {
                var ne = I.ping;
                vt.then(ne, ne);
              } else {
                I.abortSet.delete(I), ee.status = 4;
                var ae = I.blockedBoundary, De = vt, At = X(H, De);
                if (ae === null ? w(H, De) : (ae.pendingTasks--, ae.forceClientRender || (ae.forceClientRender = !0, ae.errorDigest = At, ae.parentFlushed && H.clientRenderedBoundaries.push(ae))), H.allPendingTasks--, H.allPendingTasks === 0) {
                  var Ot = H.onAllReady;
                  Ot();
                }
              }
            } finally {
            }
          }
        }
        R.splice(0, T), o.destination !== null && Nn(o, o.destination);
      } catch (vt) {
        X(o, vt), w(o, vt);
      } finally {
        Vt = x, it.current = v, v === en && Xe(u);
      }
    }
  }
  function xn(o, u, v) {
    switch (v.parentFlushed = !0, v.status) {
      case 0:
        var x = v.id = o.nextSegmentId++;
        return v.lastPushedText = !1, v.textEmbedded = !1, o = o.responseState, u.push('<template id="'), u.push(o.placeholderPrefix), o = x.toString(16), u.push(o), u.push('"></template>');
      case 1:
        v.status = 2;
        var R = !0;
        x = v.chunks;
        var T = 0;
        v = v.children;
        for (var I = 0; I < v.length; I++) {
          for (R = v[I]; T < R.index; T++) u.push(x[T]);
          R = bn(o, u, R);
        }
        for (; T < x.length - 1; T++) u.push(x[T]);
        return T < x.length && (R = u.push(x[T])), R;
      default:
        throw Error(t(390));
    }
  }
  function bn(o, u, v) {
    var x = v.boundary;
    if (x === null) return xn(o, u, v);
    if (x.parentFlushed = !0, x.forceClientRender) return o.responseState.generateStaticMarkup || (x = x.errorDigest, u.push("<!--$!-->"), u.push("<template"), x && (u.push(' data-dgst="'), x = A(x), u.push(x), u.push('"')), u.push("></template>")), xn(o, u, v), o = o.responseState.generateStaticMarkup ? !0 : u.push("<!--/$-->"), o;
    if (0 < x.pendingTasks) {
      x.rootSegmentID = o.nextSegmentId++, 0 < x.completedSegments.length && o.partialBoundaries.push(x);
      var R = o.responseState, T = R.nextSuspenseID++;
      return R = R.boundaryPrefix + T.toString(16), x = x.id = R, he(u, o.responseState, x), xn(o, u, v), u.push("<!--/$-->");
    }
    if (x.byteSize > o.progressiveChunkSize) return x.rootSegmentID = o.nextSegmentId++, o.completedBoundaries.push(x), he(u, o.responseState, x.id), xn(o, u, v), u.push("<!--/$-->");
    if (o.responseState.generateStaticMarkup || u.push("<!--$-->"), v = x.completedSegments, v.length !== 1) throw Error(t(391));
    return bn(o, u, v[0]), o = o.responseState.generateStaticMarkup ? !0 : u.push("<!--/$-->"), o;
  }
  function Bn(o, u, v) {
    return Ie(u, o.responseState, v.formatContext, v.id), bn(o, u, v), dt(u, v.formatContext);
  }
  function zn(o, u, v) {
    for (var x = v.completedSegments, R = 0; R < x.length; R++) Hn(o, u, v, x[R]);
    if (x.length = 0, o = o.responseState, x = v.id, v = v.rootSegmentID, u.push(o.startInlineScript), o.sentCompleteBoundaryFunction ? u.push('$RC("') : (o.sentCompleteBoundaryFunction = !0, u.push('function $RC(a,b){a=document.getElementById(a);b=document.getElementById(b);b.parentNode.removeChild(b);if(a){a=a.previousSibling;var f=a.parentNode,c=a.nextSibling,e=0;do{if(c&&8===c.nodeType){var d=c.data;if("/$"===d)if(0===e)break;else e--;else"$"!==d&&"$?"!==d&&"$!"!==d||e++}d=c.nextSibling;f.removeChild(c);c=d}while(c);for(;b.firstChild;)f.insertBefore(b.firstChild,c);a.data="$";a._reactRetry&&a._reactRetry()}};$RC("')), x === null) throw Error(t(395));
    return v = v.toString(16), u.push(x), u.push('","'), u.push(o.segmentPrefix), u.push(v), u.push('")<\/script>');
  }
  function Hn(o, u, v, x) {
    if (x.status === 2) return !0;
    var R = x.id;
    if (R === -1) {
      if ((x.id = v.rootSegmentID) === -1) throw Error(t(392));
      return Bn(o, u, x);
    }
    return Bn(o, u, x), o = o.responseState, u.push(o.startInlineScript), o.sentCompleteSegmentFunction ? u.push('$RS("') : (o.sentCompleteSegmentFunction = !0, u.push('function $RS(a,b){a=document.getElementById(a);b=document.getElementById(b);for(a.parentNode.removeChild(a);a.firstChild;)b.parentNode.insertBefore(a.firstChild,b);b.parentNode.removeChild(b)};$RS("')), u.push(o.segmentPrefix), R = R.toString(16), u.push(R), u.push('","'), u.push(o.placeholderPrefix), u.push(R), u.push('")<\/script>');
  }
  function Nn(o, u) {
    try {
      var v = o.completedRootSegment;
      if (v !== null && o.pendingRootTasks === 0) {
        bn(o, u, v), o.completedRootSegment = null;
        var x = o.responseState.bootstrapChunks;
        for (v = 0; v < x.length - 1; v++) u.push(x[v]);
        v < x.length && u.push(x[v]);
      }
      var R = o.clientRenderedBoundaries, T;
      for (T = 0; T < R.length; T++) {
        var I = R[T];
        x = u;
        var H = o.responseState, ee = I.id, ne = I.errorDigest, ae = I.errorMessage, De = I.errorComponentStack;
        if (x.push(H.startInlineScript), H.sentClientRenderFunction ? x.push('$RX("') : (H.sentClientRenderFunction = !0, x.push('function $RX(b,c,d,e){var a=document.getElementById(b);a&&(b=a.previousSibling,b.data="$!",a=a.dataset,c&&(a.dgst=c),d&&(a.msg=d),e&&(a.stck=e),b._reactRetry&&b._reactRetry())};$RX("')), ee === null) throw Error(t(395));
        if (x.push(ee), x.push('"'), ne || ae || De) {
          x.push(",");
          var At = ze(ne || "");
          x.push(At);
        }
        if (ae || De) {
          x.push(",");
          var Ot = ze(ae || "");
          x.push(Ot);
        }
        if (De) {
          x.push(",");
          var vt = ze(De);
          x.push(vt);
        }
        if (!x.push(")<\/script>")) {
          o.destination = null, T++, R.splice(0, T);
          return;
        }
      }
      R.splice(0, T);
      var wn = o.completedBoundaries;
      for (T = 0; T < wn.length; T++) if (!zn(o, u, wn[T])) {
        o.destination = null, T++, wn.splice(0, T);
        return;
      }
      wn.splice(0, T);
      var Wt = o.partialBoundaries;
      for (T = 0; T < Wt.length; T++) {
        var Wn = Wt[T];
        e: {
          R = o, I = u;
          var Sn = Wn.completedSegments;
          for (H = 0; H < Sn.length; H++) if (!Hn(R, I, Wn, Sn[H])) {
            H++, Sn.splice(0, H);
            var cr = !1;
            break e;
          }
          Sn.splice(0, H), cr = !0;
        }
        if (!cr) {
          o.destination = null, T++, Wt.splice(0, T);
          return;
        }
      }
      Wt.splice(0, T);
      var on = o.completedBoundaries;
      for (T = 0; T < on.length; T++) if (!zn(o, u, on[T])) {
        o.destination = null, T++, on.splice(0, T);
        return;
      }
      on.splice(0, T);
    } finally {
      o.allPendingTasks === 0 && o.pingedTasks.length === 0 && o.clientRenderedBoundaries.length === 0 && o.completedBoundaries.length === 0 && u.push(null);
    }
  }
  function ar(o, u) {
    try {
      var v = o.abortableTasks;
      v.forEach(function(x) {
        return rn(x, o, u);
      }), v.clear(), o.destination !== null && Nn(o, o.destination);
    } catch (x) {
      X(o, x), w(o, x);
    }
  }
  function lr() {
  }
  function Vn(o, u, v, x) {
    var R = !1, T = null, I = "", H = { push: function(ne) {
      return ne !== null && (I += ne), !0;
    }, destroy: function(ne) {
      R = !0, T = ne;
    } }, ee = !1;
    if (o = jn(o, qe(v, u ? u.identifierPrefix : void 0), { insertionMode: 1, selectedValue: null }, 1 / 0, lr, void 0, function() {
      ee = !0;
    }), yn(o), ar(o, x), o.status === 1) o.status = 2, H.destroy(o.fatalError);
    else if (o.status !== 2 && o.destination === null) {
      o.destination = H;
      try {
        Nn(o, H);
      } catch (ne) {
        X(o, ne), w(o, ne);
      }
    }
    if (R) throw T;
    if (!ee) throw Error(t(426));
    return I;
  }
  return Tn.renderToNodeStream = function() {
    throw Error(t(207));
  }, Tn.renderToStaticMarkup = function(o, u) {
    return Vn(o, u, !0, 'The server used "renderToStaticMarkup" which does not support Suspense. If you intended to have the server wait for the suspended component please switch to "renderToReadableStream" which supports Suspense on the server');
  }, Tn.renderToStaticNodeStream = function() {
    throw Error(t(208));
  }, Tn.renderToString = function(o, u) {
    return Vn(o, u, !1, 'The server used "renderToString" which does not support Suspense. If you intended for this Suspense boundary to render the fallback content on the server consider throwing an Error somewhere within the Suspense boundary. If you intended to have the server wait for the suspended component please switch to "renderToReadableStream" which supports Suspense on the server');
  }, Tn.version = "18.3.1", Tn;
}
var _r = {};
var $o;
function gl() {
  if ($o) return _r;
  $o = 1;
  var e = He;
  function t(s) {
    for (var c = "https://reactjs.org/docs/error-decoder.html?invariant=" + s, g = 1; g < arguments.length; g++) c += "&args[]=" + encodeURIComponent(arguments[g]);
    return "Minified React error #" + s + "; visit " + c + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
  }
  var n = null, r = 0;
  function i(s, c) {
    if (c.length !== 0) if (512 < c.length) 0 < r && (s.enqueue(new Uint8Array(n.buffer, 0, r)), n = new Uint8Array(512), r = 0), s.enqueue(c);
    else {
      var g = n.length - r;
      g < c.length && (g === 0 ? s.enqueue(n) : (n.set(c.subarray(0, g), r), s.enqueue(n), c = c.subarray(g)), n = new Uint8Array(512), r = 0), n.set(c, r), r += c.length;
    }
  }
  function a(s, c) {
    return i(s, c), !0;
  }
  function d(s) {
    n && 0 < r && (s.enqueue(new Uint8Array(n.buffer, 0, r)), n = null, r = 0);
  }
  var h = new TextEncoder();
  function m(s) {
    return h.encode(s);
  }
  function p(s) {
    return h.encode(s);
  }
  function b(s, c) {
    typeof s.error == "function" ? s.error(c) : s.close();
  }
  var S = Object.prototype.hasOwnProperty, E = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, P = {}, A = {};
  function k(s) {
    return S.call(A, s) ? !0 : S.call(P, s) ? !1 : E.test(s) ? A[s] = !0 : (P[s] = !0, !1);
  }
  function N(s, c, g, y, C, _, L) {
    this.acceptsBooleans = c === 2 || c === 3 || c === 4, this.attributeName = y, this.attributeNamespace = C, this.mustUseProperty = g, this.propertyName = s, this.type = c, this.sanitizeURL = _, this.removeEmptyString = L;
  }
  var j = {};
  "children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(s) {
    j[s] = new N(s, 0, !1, s, null, !1, !1);
  }), [["acceptCharset", "accept-charset"], ["className", "class"], ["htmlFor", "for"], ["httpEquiv", "http-equiv"]].forEach(function(s) {
    var c = s[0];
    j[c] = new N(c, 1, !1, s[1], null, !1, !1);
  }), ["contentEditable", "draggable", "spellCheck", "value"].forEach(function(s) {
    j[s] = new N(s, 2, !1, s.toLowerCase(), null, !1, !1);
  }), ["autoReverse", "externalResourcesRequired", "focusable", "preserveAlpha"].forEach(function(s) {
    j[s] = new N(s, 2, !1, s, null, !1, !1);
  }), "allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(s) {
    j[s] = new N(s, 3, !1, s.toLowerCase(), null, !1, !1);
  }), ["checked", "multiple", "muted", "selected"].forEach(function(s) {
    j[s] = new N(s, 3, !0, s, null, !1, !1);
  }), ["capture", "download"].forEach(function(s) {
    j[s] = new N(s, 4, !1, s, null, !1, !1);
  }), ["cols", "rows", "size", "span"].forEach(function(s) {
    j[s] = new N(s, 6, !1, s, null, !1, !1);
  }), ["rowSpan", "start"].forEach(function(s) {
    j[s] = new N(s, 5, !1, s.toLowerCase(), null, !1, !1);
  });
  var D = /[\-:]([a-z])/g;
  function V(s) {
    return s[1].toUpperCase();
  }
  "accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(s) {
    var c = s.replace(
      D,
      V
    );
    j[c] = new N(c, 1, !1, s, null, !1, !1);
  }), "xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(s) {
    var c = s.replace(D, V);
    j[c] = new N(c, 1, !1, s, "http://www.w3.org/1999/xlink", !1, !1);
  }), ["xml:base", "xml:lang", "xml:space"].forEach(function(s) {
    var c = s.replace(D, V);
    j[c] = new N(c, 1, !1, s, "http://www.w3.org/XML/1998/namespace", !1, !1);
  }), ["tabIndex", "crossOrigin"].forEach(function(s) {
    j[s] = new N(s, 1, !1, s.toLowerCase(), null, !1, !1);
  }), j.xlinkHref = new N("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1), ["src", "href", "action", "formAction"].forEach(function(s) {
    j[s] = new N(s, 1, !1, s.toLowerCase(), null, !0, !0);
  });
  var W = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
  }, M = ["Webkit", "ms", "Moz", "O"];
  Object.keys(W).forEach(function(s) {
    M.forEach(function(c) {
      c = c + s.charAt(0).toUpperCase() + s.substring(1), W[c] = W[s];
    });
  });
  var Z = /["'&<>]/;
  function le(s) {
    if (typeof s == "boolean" || typeof s == "number") return "" + s;
    s = "" + s;
    var c = Z.exec(s);
    if (c) {
      var g = "", y, C = 0;
      for (y = c.index; y < s.length; y++) {
        switch (s.charCodeAt(y)) {
          case 34:
            c = "&quot;";
            break;
          case 38:
            c = "&amp;";
            break;
          case 39:
            c = "&#x27;";
            break;
          case 60:
            c = "&lt;";
            break;
          case 62:
            c = "&gt;";
            break;
          default:
            continue;
        }
        C !== y && (g += s.substring(C, y)), C = y + 1, g += c;
      }
      s = C !== y ? g + s.substring(C, y) : g;
    }
    return s;
  }
  var je = /([A-Z])/g, $e = /^ms-/, Ue = Array.isArray, Se = p("<script>"), ye = p("<\/script>"), J = p('<script src="'), he = p('<script type="module" src="'), Ie = p('" async=""><\/script>'), dt = /(<\/|<)(s)(cript)/gi;
  function Be(s, c, g, y) {
    return "" + c + (g === "s" ? "\\u0073" : "\\u0053") + y;
  }
  function ze(s, c, g, y, C) {
    s = s === void 0 ? "" : s, c = c === void 0 ? Se : p('<script nonce="' + le(c) + '">');
    var _ = [];
    if (g !== void 0 && _.push(c, m(("" + g).replace(dt, Be)), ye), y !== void 0) for (g = 0; g < y.length; g++) _.push(J, m(le(y[g])), Ie);
    if (C !== void 0) for (y = 0; y < C.length; y++) _.push(he, m(le(C[y])), Ie);
    return { bootstrapChunks: _, startInlineScript: c, placeholderPrefix: p(s + "P:"), segmentPrefix: p(s + "S:"), boundaryPrefix: s + "B:", idPrefix: s, nextSuspenseID: 0, sentCompleteSegmentFunction: !1, sentCompleteBoundaryFunction: !1, sentClientRenderFunction: !1 };
  }
  function qe(s, c) {
    return { insertionMode: s, selectedValue: c };
  }
  function ft(s) {
    return qe(s === "http://www.w3.org/2000/svg" ? 2 : s === "http://www.w3.org/1998/Math/MathML" ? 3 : 0, null);
  }
  function xe(s, c, g) {
    switch (c) {
      case "select":
        return qe(1, g.value != null ? g.value : g.defaultValue);
      case "svg":
        return qe(2, null);
      case "math":
        return qe(3, null);
      case "foreignObject":
        return qe(1, null);
      case "table":
        return qe(4, null);
      case "thead":
      case "tbody":
      case "tfoot":
        return qe(5, null);
      case "colgroup":
        return qe(7, null);
      case "tr":
        return qe(6, null);
    }
    return 4 <= s.insertionMode || s.insertionMode === 0 ? qe(1, null) : s;
  }
  var G = p("<!-- -->");
  function z(s, c, g, y) {
    return c === "" ? y : (y && s.push(G), s.push(m(le(c))), !0);
  }
  var q = /* @__PURE__ */ new Map(), U = p(' style="'), O = p(":"), ue = p(";");
  function $(s, c, g) {
    if (typeof g != "object") throw Error(t(62));
    c = !0;
    for (var y in g) if (S.call(g, y)) {
      var C = g[y];
      if (C != null && typeof C != "boolean" && C !== "") {
        if (y.indexOf("--") === 0) {
          var _ = m(le(y));
          C = m(le(("" + C).trim()));
        } else {
          _ = y;
          var L = q.get(_);
          L !== void 0 || (L = p(le(_.replace(je, "-$1").toLowerCase().replace($e, "-ms-"))), q.set(_, L)), _ = L, C = typeof C == "number" ? C === 0 || S.call(W, y) ? m("" + C) : m(C + "px") : m(le(("" + C).trim()));
        }
        c ? (c = !1, s.push(U, _, O, C)) : s.push(ue, _, O, C);
      }
    }
    c || s.push(oe);
  }
  var me = p(" "), ie = p('="'), oe = p('"'), Q = p('=""');
  function se(s, c, g, y) {
    switch (g) {
      case "style":
        $(s, c, y);
        return;
      case "defaultValue":
      case "defaultChecked":
      case "innerHTML":
      case "suppressContentEditableWarning":
      case "suppressHydrationWarning":
        return;
    }
    if (!(2 < g.length) || g[0] !== "o" && g[0] !== "O" || g[1] !== "n" && g[1] !== "N") {
      if (c = j.hasOwnProperty(g) ? j[g] : null, c !== null) {
        switch (typeof y) {
          case "function":
          case "symbol":
            return;
          case "boolean":
            if (!c.acceptsBooleans) return;
        }
        switch (g = m(c.attributeName), c.type) {
          case 3:
            y && s.push(me, g, Q);
            break;
          case 4:
            y === !0 ? s.push(me, g, Q) : y !== !1 && s.push(me, g, ie, m(le(y)), oe);
            break;
          case 5:
            isNaN(y) || s.push(me, g, ie, m(le(y)), oe);
            break;
          case 6:
            !isNaN(y) && 1 <= y && s.push(me, g, ie, m(le(y)), oe);
            break;
          default:
            c.sanitizeURL && (y = "" + y), s.push(me, g, ie, m(le(y)), oe);
        }
      } else if (k(g)) {
        switch (typeof y) {
          case "function":
          case "symbol":
            return;
          case "boolean":
            if (c = g.toLowerCase().slice(0, 5), c !== "data-" && c !== "aria-") return;
        }
        s.push(me, m(g), ie, m(le(y)), oe);
      }
    }
  }
  var ke = p(">"), re = p("/>");
  function Ne(s, c, g) {
    if (c != null) {
      if (g != null) throw Error(t(60));
      if (typeof c != "object" || !("__html" in c)) throw Error(t(61));
      c = c.__html, c != null && s.push(m("" + c));
    }
  }
  function fe(s) {
    var c = "";
    return e.Children.forEach(s, function(g) {
      g != null && (c += g);
    }), c;
  }
  var we = p(' selected=""');
  function Je(s, c, g, y) {
    s.push(Re(g));
    var C = g = null, _;
    for (_ in c) if (S.call(c, _)) {
      var L = c[_];
      if (L != null) switch (_) {
        case "children":
          g = L;
          break;
        case "dangerouslySetInnerHTML":
          C = L;
          break;
        default:
          se(s, y, _, L);
      }
    }
    return s.push(ke), Ne(s, C, g), typeof g == "string" ? (s.push(m(le(g))), null) : g;
  }
  var Ce = p(`
`), wt = /^[a-zA-Z][a-zA-Z:_\.\-\d]*$/, Ye = /* @__PURE__ */ new Map();
  function Re(s) {
    var c = Ye.get(s);
    if (c === void 0) {
      if (!wt.test(s)) throw Error(t(65, s));
      c = p("<" + s), Ye.set(s, c);
    }
    return c;
  }
  var K = p("<!DOCTYPE html>");
  function be(s, c, g, y, C) {
    switch (c) {
      case "select":
        s.push(Re("select"));
        var _ = null, L = null;
        for (ce in g) if (S.call(g, ce)) {
          var B = g[ce];
          if (B != null) switch (ce) {
            case "children":
              _ = B;
              break;
            case "dangerouslySetInnerHTML":
              L = B;
              break;
            case "defaultValue":
            case "value":
              break;
            default:
              se(s, y, ce, B);
          }
        }
        return s.push(ke), Ne(s, L, _), _;
      case "option":
        L = C.selectedValue, s.push(Re("option"));
        var te = B = null, de = null, ce = null;
        for (_ in g) if (S.call(g, _)) {
          var Me = g[_];
          if (Me != null) switch (_) {
            case "children":
              B = Me;
              break;
            case "selected":
              de = Me;
              break;
            case "dangerouslySetInnerHTML":
              ce = Me;
              break;
            case "value":
              te = Me;
            default:
              se(s, y, _, Me);
          }
        }
        if (L != null) if (g = te !== null ? "" + te : fe(B), Ue(L)) {
          for (y = 0; y < L.length; y++)
            if ("" + L[y] === g) {
              s.push(we);
              break;
            }
        } else "" + L === g && s.push(we);
        else de && s.push(we);
        return s.push(ke), Ne(s, ce, B), B;
      case "textarea":
        s.push(Re("textarea")), ce = L = _ = null;
        for (B in g) if (S.call(g, B) && (te = g[B], te != null)) switch (B) {
          case "children":
            ce = te;
            break;
          case "value":
            _ = te;
            break;
          case "defaultValue":
            L = te;
            break;
          case "dangerouslySetInnerHTML":
            throw Error(t(91));
          default:
            se(s, y, B, te);
        }
        if (_ === null && L !== null && (_ = L), s.push(ke), ce != null) {
          if (_ != null) throw Error(t(92));
          if (Ue(ce) && 1 < ce.length) throw Error(t(93));
          _ = "" + ce;
        }
        return typeof _ == "string" && _[0] === `
` && s.push(Ce), _ !== null && s.push(m(le("" + _))), null;
      case "input":
        s.push(Re("input")), te = ce = B = _ = null;
        for (L in g) if (S.call(g, L) && (de = g[L], de != null)) switch (L) {
          case "children":
          case "dangerouslySetInnerHTML":
            throw Error(t(399, "input"));
          case "defaultChecked":
            te = de;
            break;
          case "defaultValue":
            B = de;
            break;
          case "checked":
            ce = de;
            break;
          case "value":
            _ = de;
            break;
          default:
            se(s, y, L, de);
        }
        return ce !== null ? se(
          s,
          y,
          "checked",
          ce
        ) : te !== null && se(s, y, "checked", te), _ !== null ? se(s, y, "value", _) : B !== null && se(s, y, "value", B), s.push(re), null;
      case "menuitem":
        s.push(Re("menuitem"));
        for (var xt in g) if (S.call(g, xt) && (_ = g[xt], _ != null)) switch (xt) {
          case "children":
          case "dangerouslySetInnerHTML":
            throw Error(t(400));
          default:
            se(s, y, xt, _);
        }
        return s.push(ke), null;
      case "title":
        s.push(Re("title")), _ = null;
        for (Me in g) if (S.call(g, Me) && (L = g[Me], L != null)) switch (Me) {
          case "children":
            _ = L;
            break;
          case "dangerouslySetInnerHTML":
            throw Error(t(434));
          default:
            se(s, y, Me, L);
        }
        return s.push(ke), _;
      case "listing":
      case "pre":
        s.push(Re(c)), L = _ = null;
        for (te in g) if (S.call(g, te) && (B = g[te], B != null)) switch (te) {
          case "children":
            _ = B;
            break;
          case "dangerouslySetInnerHTML":
            L = B;
            break;
          default:
            se(s, y, te, B);
        }
        if (s.push(ke), L != null) {
          if (_ != null) throw Error(t(60));
          if (typeof L != "object" || !("__html" in L)) throw Error(t(61));
          g = L.__html, g != null && (typeof g == "string" && 0 < g.length && g[0] === `
` ? s.push(Ce, m(g)) : s.push(m("" + g)));
        }
        return typeof _ == "string" && _[0] === `
` && s.push(Ce), _;
      case "area":
      case "base":
      case "br":
      case "col":
      case "embed":
      case "hr":
      case "img":
      case "keygen":
      case "link":
      case "meta":
      case "param":
      case "source":
      case "track":
      case "wbr":
        s.push(Re(c));
        for (var jt in g) if (S.call(g, jt) && (_ = g[jt], _ != null)) switch (jt) {
          case "children":
          case "dangerouslySetInnerHTML":
            throw Error(t(399, c));
          default:
            se(s, y, jt, _);
        }
        return s.push(re), null;
      case "annotation-xml":
      case "color-profile":
      case "font-face":
      case "font-face-src":
      case "font-face-uri":
      case "font-face-format":
      case "font-face-name":
      case "missing-glyph":
        return Je(s, g, c, y);
      case "html":
        return C.insertionMode === 0 && s.push(K), Je(s, g, c, y);
      default:
        if (c.indexOf("-") === -1 && typeof g.is != "string") return Je(s, g, c, y);
        s.push(Re(c)), L = _ = null;
        for (de in g) if (S.call(g, de) && (B = g[de], B != null)) switch (de) {
          case "children":
            _ = B;
            break;
          case "dangerouslySetInnerHTML":
            L = B;
            break;
          case "style":
            $(s, y, B);
            break;
          case "suppressContentEditableWarning":
          case "suppressHydrationWarning":
            break;
          default:
            k(de) && typeof B != "function" && typeof B != "symbol" && s.push(me, m(de), ie, m(le(B)), oe);
        }
        return s.push(ke), Ne(s, L, _), _;
    }
  }
  var nt = p("</"), Ge = p(">"), Xe = p('<template id="'), dn = p('"></template>'), fn = p("<!--$-->"), pn = p('<!--$?--><template id="'), Kt = p('"></template>'), Tt = p("<!--$!-->"), Zt = p("<!--/$-->"), ht = p("<template"), Lt = p('"'), hn = p(' data-dgst="');
  p(' data-msg="'), p(' data-stck="');
  var mn = p("></template>");
  function pt(s, c, g) {
    if (i(s, pn), g === null) throw Error(t(395));
    return i(s, g), a(s, Kt);
  }
  var Mt = p('<div hidden id="'), _t = p('">'), Te = p("</div>"), mt = p('<svg aria-hidden="true" style="display:none" id="'), Jt = p('">'), Bt = p("</svg>"), _e = p('<math aria-hidden="true" style="display:none" id="'), gt = p('">'), Et = p("</math>"), gn = p('<table hidden id="'), zt = p('">'), Qt = p("</table>"), vn = p('<table hidden><tbody id="'), Rn = p('">'), rt = p("</tbody></table>"), Ct = p('<table hidden><tr id="'), An = p('">'), Ht = p("</tr></table>"), en = p('<table hidden><colgroup id="'), Vt = p('">'), it = p("</colgroup></table>");
  function On(s, c, g, y) {
    switch (g.insertionMode) {
      case 0:
      case 1:
        return i(s, Mt), i(s, c.segmentPrefix), i(s, m(y.toString(16))), a(s, _t);
      case 2:
        return i(s, mt), i(s, c.segmentPrefix), i(s, m(y.toString(16))), a(s, Jt);
      case 3:
        return i(s, _e), i(s, c.segmentPrefix), i(s, m(y.toString(16))), a(s, gt);
      case 4:
        return i(s, gn), i(s, c.segmentPrefix), i(s, m(y.toString(16))), a(s, zt);
      case 5:
        return i(s, vn), i(s, c.segmentPrefix), i(s, m(y.toString(16))), a(s, Rn);
      case 6:
        return i(s, Ct), i(s, c.segmentPrefix), i(s, m(y.toString(16))), a(s, An);
      case 7:
        return i(
          s,
          en
        ), i(s, c.segmentPrefix), i(s, m(y.toString(16))), a(s, Vt);
      default:
        throw Error(t(397));
    }
  }
  function Dt(s, c) {
    switch (c.insertionMode) {
      case 0:
      case 1:
        return a(s, Te);
      case 2:
        return a(s, Bt);
      case 3:
        return a(s, Et);
      case 4:
        return a(s, Qt);
      case 5:
        return a(s, rt);
      case 6:
        return a(s, Ht);
      case 7:
        return a(s, it);
      default:
        throw Error(t(397));
    }
  }
  var jn = p('function $RS(a,b){a=document.getElementById(a);b=document.getElementById(b);for(a.parentNode.removeChild(a);a.firstChild;)b.parentNode.insertBefore(a.firstChild,b);b.parentNode.removeChild(b)};$RS("'), tn = p('$RS("'), nn = p('","'), X = p('")<\/script>'), w = p('function $RC(a,b){a=document.getElementById(a);b=document.getElementById(b);b.parentNode.removeChild(b);if(a){a=a.previousSibling;var f=a.parentNode,c=a.nextSibling,e=0;do{if(c&&8===c.nodeType){var d=c.data;if("/$"===d)if(0===e)break;else e--;else"$"!==d&&"$?"!==d&&"$!"!==d||e++}d=c.nextSibling;f.removeChild(c);c=d}while(c);for(;b.firstChild;)f.insertBefore(b.firstChild,c);a.data="$";a._reactRetry&&a._reactRetry()}};$RC("'), F = p('$RC("'), Y = p('","'), Ae = p('")<\/script>'), Ve = p('function $RX(b,c,d,e){var a=document.getElementById(b);a&&(b=a.previousSibling,b.data="$!",a=a.dataset,c&&(a.dgst=c),d&&(a.msg=d),e&&(a.stck=e),b._reactRetry&&b._reactRetry())};$RX("'), ge = p('$RX("'), Ke = p('"'), ot = p(")<\/script>"), St = p(","), rn = /[<\u2028\u2029]/g;
  function Pe(s) {
    return JSON.stringify(s).replace(rn, function(c) {
      switch (c) {
        case "<":
          return "\\u003c";
        case "\u2028":
          return "\\u2028";
        case "\u2029":
          return "\\u2029";
        default:
          throw Error("escapeJSStringsForInstructionScripts encountered a match it does not know how to replace. this means the match regex and the replacement characters are no longer in sync. This is a bug in React");
      }
    });
  }
  var Rt = Object.assign, yn = Symbol.for("react.element"), xn = Symbol.for("react.portal"), bn = Symbol.for("react.fragment"), Bn = Symbol.for("react.strict_mode"), zn = Symbol.for("react.profiler"), Hn = Symbol.for("react.provider"), Nn = Symbol.for("react.context"), ar = Symbol.for("react.forward_ref"), lr = Symbol.for("react.suspense"), Vn = Symbol.for("react.suspense_list"), o = Symbol.for("react.memo"), u = Symbol.for("react.lazy"), v = Symbol.for("react.scope"), x = Symbol.for("react.debug_trace_mode"), R = Symbol.for("react.legacy_hidden"), T = Symbol.for("react.default_value"), I = Symbol.iterator;
  function H(s) {
    if (s == null) return null;
    if (typeof s == "function") return s.displayName || s.name || null;
    if (typeof s == "string") return s;
    switch (s) {
      case bn:
        return "Fragment";
      case xn:
        return "Portal";
      case zn:
        return "Profiler";
      case Bn:
        return "StrictMode";
      case lr:
        return "Suspense";
      case Vn:
        return "SuspenseList";
    }
    if (typeof s == "object") switch (s.$$typeof) {
      case Nn:
        return (s.displayName || "Context") + ".Consumer";
      case Hn:
        return (s._context.displayName || "Context") + ".Provider";
      case ar:
        var c = s.render;
        return s = s.displayName, s || (s = c.displayName || c.name || "", s = s !== "" ? "ForwardRef(" + s + ")" : "ForwardRef"), s;
      case o:
        return c = s.displayName || null, c !== null ? c : H(s.type) || "Memo";
      case u:
        c = s._payload, s = s._init;
        try {
          return H(s(c));
        } catch {
        }
    }
    return null;
  }
  var ee = {};
  function ne(s, c) {
    if (s = s.contextTypes, !s) return ee;
    var g = {}, y;
    for (y in s) g[y] = c[y];
    return g;
  }
  var ae = null;
  function De(s, c) {
    if (s !== c) {
      s.context._currentValue = s.parentValue, s = s.parent;
      var g = c.parent;
      if (s === null) {
        if (g !== null) throw Error(t(401));
      } else {
        if (g === null) throw Error(t(401));
        De(s, g);
      }
      c.context._currentValue = c.value;
    }
  }
  function At(s) {
    s.context._currentValue = s.parentValue, s = s.parent, s !== null && At(s);
  }
  function Ot(s) {
    var c = s.parent;
    c !== null && Ot(c), s.context._currentValue = s.value;
  }
  function vt(s, c) {
    if (s.context._currentValue = s.parentValue, s = s.parent, s === null) throw Error(t(402));
    s.depth === c.depth ? De(s, c) : vt(s, c);
  }
  function wn(s, c) {
    var g = c.parent;
    if (g === null) throw Error(t(402));
    s.depth === g.depth ? De(s, g) : wn(s, g), c.context._currentValue = c.value;
  }
  function Wt(s) {
    var c = ae;
    c !== s && (c === null ? Ot(s) : s === null ? At(c) : c.depth === s.depth ? De(c, s) : c.depth > s.depth ? vt(c, s) : wn(c, s), ae = s);
  }
  var Wn = { isMounted: function() {
    return !1;
  }, enqueueSetState: function(s, c) {
    s = s._reactInternals, s.queue !== null && s.queue.push(c);
  }, enqueueReplaceState: function(s, c) {
    s = s._reactInternals, s.replace = !0, s.queue = [c];
  }, enqueueForceUpdate: function() {
  } };
  function Sn(s, c, g, y) {
    var C = s.state !== void 0 ? s.state : null;
    s.updater = Wn, s.props = g, s.state = C;
    var _ = { queue: [], replace: !1 };
    s._reactInternals = _;
    var L = c.contextType;
    if (s.context = typeof L == "object" && L !== null ? L._currentValue : y, L = c.getDerivedStateFromProps, typeof L == "function" && (L = L(g, C), C = L == null ? C : Rt({}, C, L), s.state = C), typeof c.getDerivedStateFromProps != "function" && typeof s.getSnapshotBeforeUpdate != "function" && (typeof s.UNSAFE_componentWillMount == "function" || typeof s.componentWillMount == "function")) if (c = s.state, typeof s.componentWillMount == "function" && s.componentWillMount(), typeof s.UNSAFE_componentWillMount == "function" && s.UNSAFE_componentWillMount(), c !== s.state && Wn.enqueueReplaceState(s, s.state, null), _.queue !== null && 0 < _.queue.length) if (c = _.queue, L = _.replace, _.queue = null, _.replace = !1, L && c.length === 1) s.state = c[0];
    else {
      for (_ = L ? c[0] : s.state, C = !0, L = L ? 1 : 0; L < c.length; L++) {
        var B = c[L];
        B = typeof B == "function" ? B.call(s, _, g, y) : B, B != null && (C ? (C = !1, _ = Rt({}, _, B)) : Rt(_, B));
      }
      s.state = _;
    }
    else _.queue = null;
  }
  var cr = { id: 1, overflow: "" };
  function on(s, c, g) {
    var y = s.id;
    s = s.overflow;
    var C = 32 - ur(y) - 1;
    y &= ~(1 << C), g += 1;
    var _ = 32 - ur(c) + C;
    if (30 < _) {
      var L = C - C % 5;
      return _ = (y & (1 << L) - 1).toString(32), y >>= L, C -= L, { id: 1 << 32 - ur(c) + C | g << C | y, overflow: _ + s };
    }
    return { id: 1 << _ | g << C | y, overflow: s };
  }
  var ur = Math.clz32 ? Math.clz32 : Ta, Sa = Math.log, ka = Math.LN2;
  function Ta(s) {
    return s >>>= 0, s === 0 ? 32 : 31 - (Sa(s) / ka | 0) | 0;
  }
  function _a(s, c) {
    return s === c && (s !== 0 || 1 / s === 1 / c) || s !== s && c !== c;
  }
  var Ea = typeof Object.is == "function" ? Object.is : _a, Ut = null, Zr = null, dr = null, Le = null, Un = !1, fr = !1, qn = 0, sn = null, pr = 0;
  function kn() {
    if (Ut === null) throw Error(t(321));
    return Ut;
  }
  function oo() {
    if (0 < pr) throw Error(t(312));
    return { memoizedState: null, queue: null, next: null };
  }
  function Jr() {
    return Le === null ? dr === null ? (Un = !1, dr = Le = oo()) : (Un = !0, Le = dr) : Le.next === null ? (Un = !1, Le = Le.next = oo()) : (Un = !0, Le = Le.next), Le;
  }
  function Qr() {
    Zr = Ut = null, fr = !1, dr = null, pr = 0, Le = sn = null;
  }
  function so(s, c) {
    return typeof c == "function" ? c(s) : c;
  }
  function ao(s, c, g) {
    if (Ut = kn(), Le = Jr(), Un) {
      var y = Le.queue;
      if (c = y.dispatch, sn !== null && (g = sn.get(y), g !== void 0)) {
        sn.delete(y), y = Le.memoizedState;
        do
          y = s(y, g.action), g = g.next;
        while (g !== null);
        return Le.memoizedState = y, [y, c];
      }
      return [Le.memoizedState, c];
    }
    return s = s === so ? typeof c == "function" ? c() : c : g !== void 0 ? g(c) : c, Le.memoizedState = s, s = Le.queue = { last: null, dispatch: null }, s = s.dispatch = Ca.bind(null, Ut, s), [Le.memoizedState, s];
  }
  function lo(s, c) {
    if (Ut = kn(), Le = Jr(), c = c === void 0 ? null : c, Le !== null) {
      var g = Le.memoizedState;
      if (g !== null && c !== null) {
        var y = g[1];
        e: if (y === null) y = !1;
        else {
          for (var C = 0; C < y.length && C < c.length; C++) if (!Ea(c[C], y[C])) {
            y = !1;
            break e;
          }
          y = !0;
        }
        if (y) return g[0];
      }
    }
    return s = s(), Le.memoizedState = [s, c], s;
  }
  function Ca(s, c, g) {
    if (25 <= pr) throw Error(t(301));
    if (s === Ut) if (fr = !0, s = { action: g, next: null }, sn === null && (sn = /* @__PURE__ */ new Map()), g = sn.get(c), g === void 0) sn.set(c, s);
    else {
      for (c = g; c.next !== null; ) c = c.next;
      c.next = s;
    }
  }
  function Ra() {
    throw Error(t(394));
  }
  function hr() {
  }
  var co = { readContext: function(s) {
    return s._currentValue;
  }, useContext: function(s) {
    return kn(), s._currentValue;
  }, useMemo: lo, useReducer: ao, useRef: function(s) {
    Ut = kn(), Le = Jr();
    var c = Le.memoizedState;
    return c === null ? (s = { current: s }, Le.memoizedState = s) : c;
  }, useState: function(s) {
    return ao(so, s);
  }, useInsertionEffect: hr, useLayoutEffect: function() {
  }, useCallback: function(s, c) {
    return lo(function() {
      return s;
    }, c);
  }, useImperativeHandle: hr, useEffect: hr, useDebugValue: hr, useDeferredValue: function(s) {
    return kn(), s;
  }, useTransition: function() {
    return kn(), [!1, Ra];
  }, useId: function() {
    var s = Zr.treeContext, c = s.overflow;
    s = s.id, s = (s & ~(1 << 32 - ur(s) - 1)).toString(32) + c;
    var g = mr;
    if (g === null) throw Error(t(404));
    return c = qn++, s = ":" + g.idPrefix + "R" + s, 0 < c && (s += "H" + c.toString(32)), s + ":";
  }, useMutableSource: function(s, c) {
    return kn(), c(s._source);
  }, useSyncExternalStore: function(s, c, g) {
    if (g === void 0) throw Error(t(407));
    return g();
  } }, mr = null, ei = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentDispatcher;
  function Aa(s) {
    return console.error(s), null;
  }
  function Yn() {
  }
  function Oa(s, c, g, y, C, _, L, B, te) {
    var de = [], ce = /* @__PURE__ */ new Set();
    return c = { destination: null, responseState: c, progressiveChunkSize: y === void 0 ? 12800 : y, status: 0, fatalError: null, nextSegmentId: 0, allPendingTasks: 0, pendingRootTasks: 0, completedRootSegment: null, abortableTasks: ce, pingedTasks: de, clientRenderedBoundaries: [], completedBoundaries: [], partialBoundaries: [], onError: C === void 0 ? Aa : C, onAllReady: _ === void 0 ? Yn : _, onShellReady: L === void 0 ? Yn : L, onShellError: B === void 0 ? Yn : B, onFatalError: te === void 0 ? Yn : te }, g = gr(c, 0, null, g, !1, !1), g.parentFlushed = !0, s = ti(c, s, null, g, ce, ee, null, cr), de.push(s), c;
  }
  function ti(s, c, g, y, C, _, L, B) {
    s.allPendingTasks++, g === null ? s.pendingRootTasks++ : g.pendingTasks++;
    var te = { node: c, ping: function() {
      var de = s.pingedTasks;
      de.push(te), de.length === 1 && vo(s);
    }, blockedBoundary: g, blockedSegment: y, abortSet: C, legacyContext: _, context: L, treeContext: B };
    return C.add(te), te;
  }
  function gr(s, c, g, y, C, _) {
    return { status: 0, id: -1, index: c, parentFlushed: !1, chunks: [], children: [], formatContext: y, boundary: g, lastPushedText: C, textEmbedded: _ };
  }
  function Gn(s, c) {
    if (s = s.onError(c), s != null && typeof s != "string") throw Error('onError returned something with a type other than "string". onError should return a string and may return null or undefined but must not return anything else. It received something of type "' + typeof s + '" instead');
    return s;
  }
  function vr(s, c) {
    var g = s.onShellError;
    g(c), g = s.onFatalError, g(c), s.destination !== null ? (s.status = 2, b(s.destination, c)) : (s.status = 1, s.fatalError = c);
  }
  function uo(s, c, g, y, C) {
    for (Ut = {}, Zr = c, qn = 0, s = g(y, C); fr; ) fr = !1, qn = 0, pr += 1, Le = null, s = g(y, C);
    return Qr(), s;
  }
  function fo(s, c, g, y) {
    var C = g.render(), _ = y.childContextTypes;
    if (_ != null) {
      var L = c.legacyContext;
      if (typeof g.getChildContext != "function") y = L;
      else {
        g = g.getChildContext();
        for (var B in g) if (!(B in _)) throw Error(t(108, H(y) || "Unknown", B));
        y = Rt({}, L, g);
      }
      c.legacyContext = y, yt(s, c, C), c.legacyContext = L;
    } else yt(s, c, C);
  }
  function po(s, c) {
    if (s && s.defaultProps) {
      c = Rt({}, c), s = s.defaultProps;
      for (var g in s) c[g] === void 0 && (c[g] = s[g]);
      return c;
    }
    return c;
  }
  function ni(s, c, g, y, C) {
    if (typeof g == "function") if (g.prototype && g.prototype.isReactComponent) {
      C = ne(g, c.legacyContext);
      var _ = g.contextType;
      _ = new g(y, typeof _ == "object" && _ !== null ? _._currentValue : C), Sn(_, g, y, C), fo(s, c, _, g);
    } else {
      _ = ne(g, c.legacyContext), C = uo(s, c, g, y, _);
      var L = qn !== 0;
      if (typeof C == "object" && C !== null && typeof C.render == "function" && C.$$typeof === void 0) Sn(C, g, y, _), fo(s, c, C, g);
      else if (L) {
        y = c.treeContext, c.treeContext = on(y, 1, 0);
        try {
          yt(s, c, C);
        } finally {
          c.treeContext = y;
        }
      } else yt(s, c, C);
    }
    else if (typeof g == "string") {
      switch (C = c.blockedSegment, _ = be(C.chunks, g, y, s.responseState, C.formatContext), C.lastPushedText = !1, L = C.formatContext, C.formatContext = xe(L, g, y), ri(s, c, _), C.formatContext = L, g) {
        case "area":
        case "base":
        case "br":
        case "col":
        case "embed":
        case "hr":
        case "img":
        case "input":
        case "keygen":
        case "link":
        case "meta":
        case "param":
        case "source":
        case "track":
        case "wbr":
          break;
        default:
          C.chunks.push(nt, m(g), Ge);
      }
      C.lastPushedText = !1;
    } else {
      switch (g) {
        case R:
        case x:
        case Bn:
        case zn:
        case bn:
          yt(s, c, y.children);
          return;
        case Vn:
          yt(s, c, y.children);
          return;
        case v:
          throw Error(t(343));
        case lr:
          e: {
            g = c.blockedBoundary, C = c.blockedSegment, _ = y.fallback, y = y.children, L = /* @__PURE__ */ new Set();
            var B = { id: null, rootSegmentID: -1, parentFlushed: !1, pendingTasks: 0, forceClientRender: !1, completedSegments: [], byteSize: 0, fallbackAbortableTasks: L, errorDigest: null }, te = gr(s, C.chunks.length, B, C.formatContext, !1, !1);
            C.children.push(te), C.lastPushedText = !1;
            var de = gr(s, 0, null, C.formatContext, !1, !1);
            de.parentFlushed = !0, c.blockedBoundary = B, c.blockedSegment = de;
            try {
              if (ri(
                s,
                c,
                y
              ), de.lastPushedText && de.textEmbedded && de.chunks.push(G), de.status = 1, yr(B, de), B.pendingTasks === 0) break e;
            } catch (ce) {
              de.status = 4, B.forceClientRender = !0, B.errorDigest = Gn(s, ce);
            } finally {
              c.blockedBoundary = g, c.blockedSegment = C;
            }
            c = ti(s, _, g, te, L, c.legacyContext, c.context, c.treeContext), s.pingedTasks.push(c);
          }
          return;
      }
      if (typeof g == "object" && g !== null) switch (g.$$typeof) {
        case ar:
          if (y = uo(s, c, g.render, y, C), qn !== 0) {
            g = c.treeContext, c.treeContext = on(g, 1, 0);
            try {
              yt(s, c, y);
            } finally {
              c.treeContext = g;
            }
          } else yt(s, c, y);
          return;
        case o:
          g = g.type, y = po(g, y), ni(s, c, g, y, C);
          return;
        case Hn:
          if (C = y.children, g = g._context, y = y.value, _ = g._currentValue, g._currentValue = y, L = ae, ae = y = { parent: L, depth: L === null ? 0 : L.depth + 1, context: g, parentValue: _, value: y }, c.context = y, yt(s, c, C), s = ae, s === null) throw Error(t(403));
          y = s.parentValue, s.context._currentValue = y === T ? s.context._defaultValue : y, s = ae = s.parent, c.context = s;
          return;
        case Nn:
          y = y.children, y = y(g._currentValue), yt(s, c, y);
          return;
        case u:
          C = g._init, g = C(g._payload), y = po(g, y), ni(s, c, g, y, void 0);
          return;
      }
      throw Error(t(
        130,
        g == null ? g : typeof g,
        ""
      ));
    }
  }
  function yt(s, c, g) {
    if (c.node = g, typeof g == "object" && g !== null) {
      switch (g.$$typeof) {
        case yn:
          ni(s, c, g.type, g.props, g.ref);
          return;
        case xn:
          throw Error(t(257));
        case u:
          var y = g._init;
          g = y(g._payload), yt(s, c, g);
          return;
      }
      if (Ue(g)) {
        ho(s, c, g);
        return;
      }
      if (g === null || typeof g != "object" ? y = null : (y = I && g[I] || g["@@iterator"], y = typeof y == "function" ? y : null), y && (y = y.call(g))) {
        if (g = y.next(), !g.done) {
          var C = [];
          do
            C.push(g.value), g = y.next();
          while (!g.done);
          ho(s, c, C);
        }
        return;
      }
      throw s = Object.prototype.toString.call(g), Error(t(31, s === "[object Object]" ? "object with keys {" + Object.keys(g).join(", ") + "}" : s));
    }
    typeof g == "string" ? (y = c.blockedSegment, y.lastPushedText = z(c.blockedSegment.chunks, g, s.responseState, y.lastPushedText)) : typeof g == "number" && (y = c.blockedSegment, y.lastPushedText = z(c.blockedSegment.chunks, "" + g, s.responseState, y.lastPushedText));
  }
  function ho(s, c, g) {
    for (var y = g.length, C = 0; C < y; C++) {
      var _ = c.treeContext;
      c.treeContext = on(_, y, C);
      try {
        ri(s, c, g[C]);
      } finally {
        c.treeContext = _;
      }
    }
  }
  function ri(s, c, g) {
    var y = c.blockedSegment.formatContext, C = c.legacyContext, _ = c.context;
    try {
      return yt(s, c, g);
    } catch (te) {
      if (Qr(), typeof te == "object" && te !== null && typeof te.then == "function") {
        g = te;
        var L = c.blockedSegment, B = gr(s, L.chunks.length, null, L.formatContext, L.lastPushedText, !0);
        L.children.push(B), L.lastPushedText = !1, s = ti(s, c.node, c.blockedBoundary, B, c.abortSet, c.legacyContext, c.context, c.treeContext).ping, g.then(s, s), c.blockedSegment.formatContext = y, c.legacyContext = C, c.context = _, Wt(_);
      } else throw c.blockedSegment.formatContext = y, c.legacyContext = C, c.context = _, Wt(_), te;
    }
  }
  function ja(s) {
    var c = s.blockedBoundary;
    s = s.blockedSegment, s.status = 3, go(this, c, s);
  }
  function mo(s, c, g) {
    var y = s.blockedBoundary;
    s.blockedSegment.status = 3, y === null ? (c.allPendingTasks--, c.status !== 2 && (c.status = 2, c.destination !== null && c.destination.close())) : (y.pendingTasks--, y.forceClientRender || (y.forceClientRender = !0, s = g === void 0 ? Error(t(432)) : g, y.errorDigest = c.onError(s), y.parentFlushed && c.clientRenderedBoundaries.push(y)), y.fallbackAbortableTasks.forEach(function(C) {
      return mo(C, c, g);
    }), y.fallbackAbortableTasks.clear(), c.allPendingTasks--, c.allPendingTasks === 0 && (y = c.onAllReady, y()));
  }
  function yr(s, c) {
    if (c.chunks.length === 0 && c.children.length === 1 && c.children[0].boundary === null) {
      var g = c.children[0];
      g.id = c.id, g.parentFlushed = !0, g.status === 1 && yr(s, g);
    } else s.completedSegments.push(c);
  }
  function go(s, c, g) {
    if (c === null) {
      if (g.parentFlushed) {
        if (s.completedRootSegment !== null) throw Error(t(389));
        s.completedRootSegment = g;
      }
      s.pendingRootTasks--, s.pendingRootTasks === 0 && (s.onShellError = Yn, c = s.onShellReady, c());
    } else c.pendingTasks--, c.forceClientRender || (c.pendingTasks === 0 ? (g.parentFlushed && g.status === 1 && yr(c, g), c.parentFlushed && s.completedBoundaries.push(c), c.fallbackAbortableTasks.forEach(ja, s), c.fallbackAbortableTasks.clear()) : g.parentFlushed && g.status === 1 && (yr(c, g), c.completedSegments.length === 1 && c.parentFlushed && s.partialBoundaries.push(c)));
    s.allPendingTasks--, s.allPendingTasks === 0 && (s = s.onAllReady, s());
  }
  function vo(s) {
    if (s.status !== 2) {
      var c = ae, g = ei.current;
      ei.current = co;
      var y = mr;
      mr = s.responseState;
      try {
        var C = s.pingedTasks, _;
        for (_ = 0; _ < C.length; _++) {
          var L = C[_], B = s, te = L.blockedSegment;
          if (te.status === 0) {
            Wt(L.context);
            try {
              yt(B, L, L.node), te.lastPushedText && te.textEmbedded && te.chunks.push(G), L.abortSet.delete(L), te.status = 1, go(B, L.blockedBoundary, te);
            } catch (Nt) {
              if (Qr(), typeof Nt == "object" && Nt !== null && typeof Nt.then == "function") {
                var de = L.ping;
                Nt.then(de, de);
              } else {
                L.abortSet.delete(L), te.status = 4;
                var ce = L.blockedBoundary, Me = Nt, xt = Gn(B, Me);
                if (ce === null ? vr(B, Me) : (ce.pendingTasks--, ce.forceClientRender || (ce.forceClientRender = !0, ce.errorDigest = xt, ce.parentFlushed && B.clientRenderedBoundaries.push(ce))), B.allPendingTasks--, B.allPendingTasks === 0) {
                  var jt = B.onAllReady;
                  jt();
                }
              }
            } finally {
            }
          }
        }
        C.splice(0, _), s.destination !== null && ii(s, s.destination);
      } catch (Nt) {
        Gn(s, Nt), vr(s, Nt);
      } finally {
        mr = y, ei.current = g, g === co && Wt(c);
      }
    }
  }
  function xr(s, c, g) {
    switch (g.parentFlushed = !0, g.status) {
      case 0:
        var y = g.id = s.nextSegmentId++;
        return g.lastPushedText = !1, g.textEmbedded = !1, s = s.responseState, i(c, Xe), i(c, s.placeholderPrefix), s = m(y.toString(16)), i(c, s), a(c, dn);
      case 1:
        g.status = 2;
        var C = !0;
        y = g.chunks;
        var _ = 0;
        g = g.children;
        for (var L = 0; L < g.length; L++) {
          for (C = g[L]; _ < C.index; _++) i(c, y[_]);
          C = br(s, c, C);
        }
        for (; _ < y.length - 1; _++) i(c, y[_]);
        return _ < y.length && (C = a(c, y[_])), C;
      default:
        throw Error(t(390));
    }
  }
  function br(s, c, g) {
    var y = g.boundary;
    if (y === null) return xr(s, c, g);
    if (y.parentFlushed = !0, y.forceClientRender) y = y.errorDigest, a(c, Tt), i(c, ht), y && (i(c, hn), i(c, m(le(y))), i(c, Lt)), a(c, mn), xr(s, c, g);
    else if (0 < y.pendingTasks) {
      y.rootSegmentID = s.nextSegmentId++, 0 < y.completedSegments.length && s.partialBoundaries.push(y);
      var C = s.responseState, _ = C.nextSuspenseID++;
      C = p(C.boundaryPrefix + _.toString(16)), y = y.id = C, pt(c, s.responseState, y), xr(s, c, g);
    } else if (y.byteSize > s.progressiveChunkSize) y.rootSegmentID = s.nextSegmentId++, s.completedBoundaries.push(y), pt(c, s.responseState, y.id), xr(s, c, g);
    else {
      if (a(c, fn), g = y.completedSegments, g.length !== 1) throw Error(t(391));
      br(s, c, g[0]);
    }
    return a(c, Zt);
  }
  function yo(s, c, g) {
    return On(c, s.responseState, g.formatContext, g.id), br(s, c, g), Dt(c, g.formatContext);
  }
  function xo(s, c, g) {
    for (var y = g.completedSegments, C = 0; C < y.length; C++) bo(s, c, g, y[C]);
    if (y.length = 0, s = s.responseState, y = g.id, g = g.rootSegmentID, i(c, s.startInlineScript), s.sentCompleteBoundaryFunction ? i(c, F) : (s.sentCompleteBoundaryFunction = !0, i(c, w)), y === null) throw Error(t(395));
    return g = m(g.toString(16)), i(c, y), i(c, Y), i(c, s.segmentPrefix), i(c, g), a(c, Ae);
  }
  function bo(s, c, g, y) {
    if (y.status === 2) return !0;
    var C = y.id;
    if (C === -1) {
      if ((y.id = g.rootSegmentID) === -1) throw Error(t(392));
      return yo(s, c, y);
    }
    return yo(s, c, y), s = s.responseState, i(c, s.startInlineScript), s.sentCompleteSegmentFunction ? i(c, tn) : (s.sentCompleteSegmentFunction = !0, i(c, jn)), i(c, s.segmentPrefix), C = m(C.toString(16)), i(c, C), i(c, nn), i(c, s.placeholderPrefix), i(c, C), a(c, X);
  }
  function ii(s, c) {
    n = new Uint8Array(512), r = 0;
    try {
      var g = s.completedRootSegment;
      if (g !== null && s.pendingRootTasks === 0) {
        br(s, c, g), s.completedRootSegment = null;
        var y = s.responseState.bootstrapChunks;
        for (g = 0; g < y.length - 1; g++) i(c, y[g]);
        g < y.length && a(c, y[g]);
      }
      var C = s.clientRenderedBoundaries, _;
      for (_ = 0; _ < C.length; _++) {
        var L = C[_];
        y = c;
        var B = s.responseState, te = L.id, de = L.errorDigest, ce = L.errorMessage, Me = L.errorComponentStack;
        if (i(y, B.startInlineScript), B.sentClientRenderFunction ? i(y, ge) : (B.sentClientRenderFunction = !0, i(
          y,
          Ve
        )), te === null) throw Error(t(395));
        i(y, te), i(y, Ke), (de || ce || Me) && (i(y, St), i(y, m(Pe(de || "")))), (ce || Me) && (i(y, St), i(y, m(Pe(ce || "")))), Me && (i(y, St), i(y, m(Pe(Me)))), a(y, ot);
      }
      C.splice(0, _);
      var xt = s.completedBoundaries;
      for (_ = 0; _ < xt.length; _++) xo(s, c, xt[_]);
      xt.splice(0, _), d(c), n = new Uint8Array(512), r = 0;
      var jt = s.partialBoundaries;
      for (_ = 0; _ < jt.length; _++) {
        var Nt = jt[_];
        e: {
          C = s, L = c;
          var wr = Nt.completedSegments;
          for (B = 0; B < wr.length; B++) if (!bo(
            C,
            L,
            Nt,
            wr[B]
          )) {
            B++, wr.splice(0, B);
            var So = !1;
            break e;
          }
          wr.splice(0, B), So = !0;
        }
        if (!So) {
          s.destination = null, _++, jt.splice(0, _);
          return;
        }
      }
      jt.splice(0, _);
      var oi = s.completedBoundaries;
      for (_ = 0; _ < oi.length; _++) xo(s, c, oi[_]);
      oi.splice(0, _);
    } finally {
      d(c), s.allPendingTasks === 0 && s.pingedTasks.length === 0 && s.clientRenderedBoundaries.length === 0 && s.completedBoundaries.length === 0 && c.close();
    }
  }
  function wo(s, c) {
    try {
      var g = s.abortableTasks;
      g.forEach(function(y) {
        return mo(y, s, c);
      }), g.clear(), s.destination !== null && ii(s, s.destination);
    } catch (y) {
      Gn(s, y), vr(s, y);
    }
  }
  return _r.renderToReadableStream = function(s, c) {
    return new Promise(function(g, y) {
      var C, _, L = new Promise(function(ce, Me) {
        _ = ce, C = Me;
      }), B = Oa(s, ze(c ? c.identifierPrefix : void 0, c ? c.nonce : void 0, c ? c.bootstrapScriptContent : void 0, c ? c.bootstrapScripts : void 0, c ? c.bootstrapModules : void 0), ft(c ? c.namespaceURI : void 0), c ? c.progressiveChunkSize : void 0, c ? c.onError : void 0, _, function() {
        var ce = new ReadableStream({ type: "bytes", pull: function(Me) {
          if (B.status === 1) B.status = 2, b(Me, B.fatalError);
          else if (B.status !== 2 && B.destination === null) {
            B.destination = Me;
            try {
              ii(B, Me);
            } catch (xt) {
              Gn(B, xt), vr(B, xt);
            }
          }
        }, cancel: function() {
          wo(B);
        } }, { highWaterMark: 0 });
        ce.allReady = L, g(ce);
      }, function(ce) {
        L.catch(function() {
        }), y(ce);
      }, C);
      if (c && c.signal) {
        var te = c.signal, de = function() {
          wo(B, te.reason), te.removeEventListener("abort", de);
        };
        te.addEventListener("abort", de);
      }
      vo(B);
    });
  }, _r.version = "18.3.1", _r;
}
var $n, Rs;
$n = ml(), Rs = gl();
$n.version;
$n.renderToString;
$n.renderToStaticMarkup;
$n.renderToNodeStream;
$n.renderToStaticNodeStream;
Rs.renderToReadableStream;
const vl = "staticMarkup";
function Cn() {
  const t = Bi().indexOf(vl) > -1 ? !0 : void 0;
  return {
    isBootstrap: t,
    isReact: t ? void 0 : !0
  };
}
const Ze = ({ gaData: e, prefix: t = "", children: n }) => {
  const { isReact: r } = Cn(), { onClick: i, ...a } = n.props;
  if (r)
    return He.cloneElement(n, {
      ...a,
      onClick: (m) => (e && e.event && e.action && Ts(e), i ? i(m) : !0)
    });
  let d = "";
  ["input", "header", "header-input"].includes(t) && (d = `-${t}`);
  const h = {
    [`data-ga${d}`]: e.text,
    [`data-ga${d}-name`]: e.name,
    [`data-ga${d}-event`]: e.event,
    [`data-ga${d}-action`]: e.action,
    [`data-ga${d}-type`]: e.type,
    [`data-ga${d}-region`]: e.region,
    [`data-ga${d}-section`]: e.section,
    [`data-ga${d}-component`]: e.component
  };
  return He.cloneElement(n, {
    ...a,
    onClick: i,
    ...h
  });
}, As = zi(
  ({
    id: e,
    parentId: t,
    /** @type {AccordionCard} */
    item: n,
    openCard: r,
    onClick: i,
    gaData: a
  }, d) => {
    var p, b, S, E, P, A;
    const h = e === r, m = h ? "open" : "close";
    return /* @__PURE__ */ f.jsxs(
      "div",
      {
        ref: d,
        className: ve("accordion-item", "mt-3", {
          [`accordion-item-${n.color}`]: n.color,
          "accordion-header-icon": (p = n.content) == null ? void 0 : p.icon
        }),
        children: [
          /* @__PURE__ */ f.jsx("div", { className: "accordion-header", children: /* @__PURE__ */ f.jsx("h4", { children: /* @__PURE__ */ f.jsx(
            Ze,
            {
              gaData: {
                ...a,
                action: m,
                text: n.content.header
              },
              children: /* @__PURE__ */ f.jsxs(
                "button",
                {
                  "data-testid": "accordion-opener",
                  className: ve({ collapsed: !h }),
                  "data-bs-toggle": "collapse",
                  href: `#card-body-${e}`,
                  type: "button",
                  "aria-expanded": h,
                  "aria-controls": `card-body-${e}`,
                  onClick: (k) => i(k, e),
                  children: [
                    (b = n.content) != null && b.icon ? /* @__PURE__ */ f.jsxs("span", { className: "accordion-icon", children: [
                      /* @__PURE__ */ f.jsx(
                        "i",
                        {
                          className: `${(S = n.content.icon) == null ? void 0 : S[0]} fa-${(E = n.content.icon) == null ? void 0 : E[1]} me-2`
                        }
                      ),
                      n.content.header
                    ] }) : (P = n.content) == null ? void 0 : P.header,
                    /* @__PURE__ */ f.jsx("i", { className: "fas fa-chevron-up" })
                  ]
                }
              )
            }
          ) }) }),
          ((A = n.content) == null ? void 0 : A.body) && /* @__PURE__ */ f.jsx(
            "div",
            {
              "data-bs-parent": `#${t}`,
              id: `card-body-${e}`,
              className: ve("collapse", { show: h }),
              children: /* @__PURE__ */ f.jsx(
                "div",
                {
                  className: "accordion-body",
                  dangerouslySetInnerHTML: lt(
                    n.content.body
                  )
                }
              )
            }
          )
        ]
      }
    );
  }
);
As.propTypes = {
  id: l.number,
  // @ts-ignore a technical type mismatch between PropTypes definition and your TypeScript
  item: Cs,
  parentId: l.string,
  openCard: l.number,
  onClick: l.func,
  gaData: l.object
};
const yl = {
  event: "collapse",
  name: "onclick",
  type: "click",
  region: "main content"
}, Os = ({ cards: e, openedCard: t }) => {
  const [n, r] = Qe(t), i = `accordion-${Bi()}`, a = cn(
    /** @type { HTMLDivElement[]} */
    []
  ), d = (h, m) => {
    if (h.preventDefault(), n !== m) {
      const p = a.current[n - 1], b = p == null ? void 0 : p.lastElementChild;
      fl(b), r(m);
    } else
      r(null);
  };
  return /* @__PURE__ */ f.jsx("div", { className: "accordion", id: i, children: e == null ? void 0 : e.map(
    (h, m) => h.content.body && h.content.header && /* @__PURE__ */ f.jsx(
      As,
      {
        ref: (p) => {
          a.current[m] = p;
        },
        id: m + 1,
        parentId: i,
        item: h,
        openCard: n,
        onClick: d,
        gaData: yl
      },
      m + 1
    )
  ) });
};
Os.propTypes = {
  /**
   * Cards to show in the accordion component
   */
  cards: l.arrayOf(Cs).isRequired,
  /**
   * Opened card based on rendered card position
   */
  openedCard: l.number
};
const Bo = {
  name: "onclick",
  event: "link",
  action: "click",
  type: "internal link",
  region: "main content"
}, an = ({
  label: e = "",
  cardTitle: t = "",
  gaData: n,
  ariaLabel: r,
  block: i,
  color: a = "gray",
  disabled: d,
  element: h = "button",
  href: m,
  icon: p,
  innerRef: b,
  onClick: S,
  size: E = "default",
  variant: P,
  classes: A,
  target: k = "_self",
  ...N
}) => {
  if (P) {
    const V = {
      borderless: "borderless",
      outline: "outline",
      filled: "filled"
    }, W = ve("btn", V[P], {
      [`btn-${V[P]}-${a}`]: !0,
      "btn-medium": E === "medium",
      "btn-small": E === "small",
      "btn-large": E === "large" || E === "default",
      disabled: d
    });
    let M = h;
    return m && h === "button" && (M = "a"), /* @__PURE__ */ f.jsx(
      Ze,
      {
        gaData: {
          ...Bo,
          section: t,
          ...n,
          text: e
        },
        children: /* @__PURE__ */ f.jsxs(
          M,
          {
            type: M === "button" && S ? "button" : void 0,
            ...N,
            className: ve(A) || W,
            href: m,
            ref: b,
            onClick: S,
            "aria-label": r,
            target: M === "a" ? k : null,
            disabled: d,
            children: [
              p && /* @__PURE__ */ f.jsx("i", { className: `${p == null ? void 0 : p[0]} fa-${p == null ? void 0 : p[1]} me-1` }),
              e
            ]
          }
        )
      }
    );
  }
  const j = ve("btn", {
    [`btn-${a}`]: !0,
    "btn-md": E === "small",
    "btn-sm": E === "xsmall",
    "btn-block": i,
    disabled: d
  });
  let D = h;
  return m && h === "button" && (D = "a"), /* @__PURE__ */ f.jsx(
    Ze,
    {
      gaData: {
        ...Bo,
        section: t,
        // @deprecated - remove at some point
        ...n,
        text: e
      },
      children: /* @__PURE__ */ f.jsxs(
        D,
        {
          type: D === "button" && S ? "button" : void 0,
          ...N,
          className: ve(A) || j,
          href: m,
          ref: b,
          onClick: S,
          "aria-label": r,
          target: D === "a" ? k : null,
          children: [
            p && /* @__PURE__ */ f.jsx("i", { className: `${p == null ? void 0 : p[0]} fa-${p == null ? void 0 : p[1]} me-1` }),
            e
          ]
        }
      )
    }
  );
};
an.propTypes = {
  /**
   * Button label
   */
  label: l.string,
  /**
   * @deprecated
   * Card title, use `gaData.section` instead
   */
  cardTitle: l.string,
  /**
   * Google Analytics event data
   */
  gaData: Wi,
  /**
    ARIA label for accessibility
  */
  ariaLabel: l.string,
  /**
    Render button as a block-button?
  */
  block: l.bool,
  /**
    Button background color
  */
  color: l.oneOf(["gold", "maroon", "gray", "dark"]),
  /**
    Disable the button?
  */
  disabled: l.bool,
  /**
    Pass in a Component to override default button element.
    For example: react-router Link
  */
  element: l.oneOfType([
    l.func,
    l.string,
    l.shape({ $$typeof: l.symbol, render: l.func }),
    l.arrayOf(
      l.oneOfType([
        l.func,
        l.string,
        l.shape({ $$typeof: l.symbol, render: l.func })
      ])
    )
  ]),
  /**
    Link target url; will cause button to be rendered as `<a>` link
  */
  href: l.string,
  /**
    React Font Awesome icon prefix and name string to be rendered in button label. Ex: ['fab', 'drupal']
  */
  icon: l.arrayOf(l.string),
  /**
   * ref will only get you a reference to the Button component, use innerRef to
   * get a reference to the DOM element (for things like focus management).
   */
  innerRef: l.oneOfType([
    l.object,
    l.func,
    l.string
  ]),
  /**
    Event handler function for `<button>`
  */
  onClick: l.func,
  /**
    Button size. Legacy sizes (default, small, xsmall) or new sizes (large, medium, small) when used with variant prop.
  */
  size: l.oneOf(["default", "small", "xsmall", "large", "medium"]),
  /**
    Button style variant (borderless, outline, filled). When provided, uses new UDS button styles.
  */
  variant: l.oneOf(["borderless", "outline", "filled"]),
  /**
    Classes to add to button
  */
  classes: l.arrayOf(l.string),
  /**
   Link target type
   */
  target: l.oneOf(["_blank", "_self", "_top", "_parent"])
};
var js = { exports: {} }, Oe = {};
var zo;
function xl() {
  if (zo) return Oe;
  zo = 1;
  var e = Symbol.for("react.transitional.element"), t = Symbol.for("react.portal"), n = Symbol.for("react.fragment"), r = Symbol.for("react.strict_mode"), i = Symbol.for("react.profiler"), a = Symbol.for("react.consumer"), d = Symbol.for("react.context"), h = Symbol.for("react.forward_ref"), m = Symbol.for("react.suspense"), p = Symbol.for("react.suspense_list"), b = Symbol.for("react.memo"), S = Symbol.for("react.lazy"), E = Symbol.for("react.offscreen"), P = Symbol.for("react.client.reference");
  function A(k) {
    if (typeof k == "object" && k !== null) {
      var N = k.$$typeof;
      switch (N) {
        case e:
          switch (k = k.type, k) {
            case n:
            case i:
            case r:
            case m:
            case p:
              return k;
            default:
              switch (k = k && k.$$typeof, k) {
                case d:
                case h:
                case S:
                case b:
                  return k;
                case a:
                  return k;
                default:
                  return N;
              }
          }
        case t:
          return N;
      }
    }
  }
  return Oe.ContextConsumer = a, Oe.ContextProvider = d, Oe.Element = e, Oe.ForwardRef = h, Oe.Fragment = n, Oe.Lazy = S, Oe.Memo = b, Oe.Portal = t, Oe.Profiler = i, Oe.StrictMode = r, Oe.Suspense = m, Oe.SuspenseList = p, Oe.isContextConsumer = function(k) {
    return A(k) === a;
  }, Oe.isContextProvider = function(k) {
    return A(k) === d;
  }, Oe.isElement = function(k) {
    return typeof k == "object" && k !== null && k.$$typeof === e;
  }, Oe.isForwardRef = function(k) {
    return A(k) === h;
  }, Oe.isFragment = function(k) {
    return A(k) === n;
  }, Oe.isLazy = function(k) {
    return A(k) === S;
  }, Oe.isMemo = function(k) {
    return A(k) === b;
  }, Oe.isPortal = function(k) {
    return A(k) === t;
  }, Oe.isProfiler = function(k) {
    return A(k) === i;
  }, Oe.isStrictMode = function(k) {
    return A(k) === r;
  }, Oe.isSuspense = function(k) {
    return A(k) === m;
  }, Oe.isSuspenseList = function(k) {
    return A(k) === p;
  }, Oe.isValidElementType = function(k) {
    return typeof k == "string" || typeof k == "function" || k === n || k === i || k === r || k === m || k === p || k === E || typeof k == "object" && k !== null && (k.$$typeof === S || k.$$typeof === b || k.$$typeof === d || k.$$typeof === a || k.$$typeof === h || k.$$typeof === P || k.getModuleId !== void 0);
  }, Oe.typeOf = A, Oe;
}
js.exports = xl();
var Ns = js.exports;
function bl(e) {
  function t(G, z, q, U, O) {
    for (var ue = 0, $ = 0, me = 0, ie = 0, oe, Q, se = 0, ke = 0, re, Ne = re = oe = 0, fe = 0, we = 0, Je = 0, Ce = 0, wt = q.length, Ye = wt - 1, Re, K = "", be = "", nt = "", Ge = "", Xe; fe < wt; ) {
      if (Q = q.charCodeAt(fe), fe === Ye && $ + ie + me + ue !== 0 && ($ !== 0 && (Q = $ === 47 ? 10 : 47), ie = me = ue = 0, wt++, Ye++), $ + ie + me + ue === 0) {
        if (fe === Ye && (0 < we && (K = K.replace(E, "")), 0 < K.trim().length)) {
          switch (Q) {
            case 32:
            case 9:
            case 59:
            case 13:
            case 10:
              break;
            default:
              K += q.charAt(fe);
          }
          Q = 59;
        }
        switch (Q) {
          case 123:
            for (K = K.trim(), oe = K.charCodeAt(0), re = 1, Ce = ++fe; fe < wt; ) {
              switch (Q = q.charCodeAt(fe)) {
                case 123:
                  re++;
                  break;
                case 125:
                  re--;
                  break;
                case 47:
                  switch (Q = q.charCodeAt(fe + 1)) {
                    case 42:
                    case 47:
                      e: {
                        for (Ne = fe + 1; Ne < Ye; ++Ne)
                          switch (q.charCodeAt(Ne)) {
                            case 47:
                              if (Q === 42 && q.charCodeAt(Ne - 1) === 42 && fe + 2 !== Ne) {
                                fe = Ne + 1;
                                break e;
                              }
                              break;
                            case 10:
                              if (Q === 47) {
                                fe = Ne + 1;
                                break e;
                              }
                          }
                        fe = Ne;
                      }
                  }
                  break;
                case 91:
                  Q++;
                case 40:
                  Q++;
                case 34:
                case 39:
                  for (; fe++ < Ye && q.charCodeAt(fe) !== Q; )
                    ;
              }
              if (re === 0) break;
              fe++;
            }
            switch (re = q.substring(Ce, fe), oe === 0 && (oe = (K = K.replace(S, "").trim()).charCodeAt(0)), oe) {
              case 64:
                switch (0 < we && (K = K.replace(E, "")), Q = K.charCodeAt(1), Q) {
                  case 100:
                  case 109:
                  case 115:
                  case 45:
                    we = z;
                    break;
                  default:
                    we = dt;
                }
                if (re = t(z, we, re, Q, O + 1), Ce = re.length, 0 < ze && (we = n(dt, K, Je), Xe = h(3, re, we, z, J, ye, Ce, Q, O, U), K = we.join(""), Xe !== void 0 && (Ce = (re = Xe.trim()).length) === 0 && (Q = 0, re = "")), 0 < Ce) switch (Q) {
                  case 115:
                    K = K.replace(Z, d);
                  case 100:
                  case 109:
                  case 45:
                    re = K + "{" + re + "}";
                    break;
                  case 107:
                    K = K.replace(D, "$1 $2"), re = K + "{" + re + "}", re = Ie === 1 || Ie === 2 && a("@" + re, 3) ? "@-webkit-" + re + "@" + re : "@" + re;
                    break;
                  default:
                    re = K + re, U === 112 && (re = (be += re, ""));
                }
                else re = "";
                break;
              default:
                re = t(z, n(z, K, Je), re, U, O + 1);
            }
            nt += re, re = Je = we = Ne = oe = 0, K = "", Q = q.charCodeAt(++fe);
            break;
          case 125:
          case 59:
            if (K = (0 < we ? K.replace(E, "") : K).trim(), 1 < (Ce = K.length)) switch (Ne === 0 && (oe = K.charCodeAt(0), oe === 45 || 96 < oe && 123 > oe) && (Ce = (K = K.replace(" ", ":")).length), 0 < ze && (Xe = h(1, K, z, G, J, ye, be.length, U, O, U)) !== void 0 && (Ce = (K = Xe.trim()).length) === 0 && (K = "\0\0"), oe = K.charCodeAt(0), Q = K.charCodeAt(1), oe) {
              case 0:
                break;
              case 64:
                if (Q === 105 || Q === 99) {
                  Ge += K + q.charAt(fe);
                  break;
                }
              default:
                K.charCodeAt(Ce - 1) !== 58 && (be += i(K, oe, Q, K.charCodeAt(2)));
            }
            Je = we = Ne = oe = 0, K = "", Q = q.charCodeAt(++fe);
        }
      }
      switch (Q) {
        case 13:
        case 10:
          $ === 47 ? $ = 0 : 1 + oe === 0 && U !== 107 && 0 < K.length && (we = 1, K += "\0"), 0 < ze * ft && h(0, K, z, G, J, ye, be.length, U, O, U), ye = 1, J++;
          break;
        case 59:
        case 125:
          if ($ + ie + me + ue === 0) {
            ye++;
            break;
          }
        default:
          switch (ye++, Re = q.charAt(fe), Q) {
            case 9:
            case 32:
              if (ie + ue + $ === 0) switch (se) {
                case 44:
                case 58:
                case 9:
                case 32:
                  Re = "";
                  break;
                default:
                  Q !== 32 && (Re = " ");
              }
              break;
            case 0:
              Re = "\\0";
              break;
            case 12:
              Re = "\\f";
              break;
            case 11:
              Re = "\\v";
              break;
            case 38:
              ie + $ + ue === 0 && (we = Je = 1, Re = "\f" + Re);
              break;
            case 108:
              if (ie + $ + ue + he === 0 && 0 < Ne) switch (fe - Ne) {
                case 2:
                  se === 112 && q.charCodeAt(fe - 3) === 58 && (he = se);
                case 8:
                  ke === 111 && (he = ke);
              }
              break;
            case 58:
              ie + $ + ue === 0 && (Ne = fe);
              break;
            case 44:
              $ + me + ie + ue === 0 && (we = 1, Re += "\r");
              break;
            case 34:
            case 39:
              $ === 0 && (ie = ie === Q ? 0 : ie === 0 ? Q : ie);
              break;
            case 91:
              ie + $ + me === 0 && ue++;
              break;
            case 93:
              ie + $ + me === 0 && ue--;
              break;
            case 41:
              ie + $ + ue === 0 && me--;
              break;
            case 40:
              if (ie + $ + ue === 0) {
                if (oe === 0) switch (2 * se + 3 * ke) {
                  case 533:
                    break;
                  default:
                    oe = 1;
                }
                me++;
              }
              break;
            case 64:
              $ + me + ie + ue + Ne + re === 0 && (re = 1);
              break;
            case 42:
            case 47:
              if (!(0 < ie + ue + me)) switch ($) {
                case 0:
                  switch (2 * Q + 3 * q.charCodeAt(fe + 1)) {
                    case 235:
                      $ = 47;
                      break;
                    case 220:
                      Ce = fe, $ = 42;
                  }
                  break;
                case 42:
                  Q === 47 && se === 42 && Ce + 2 !== fe && (q.charCodeAt(Ce + 2) === 33 && (be += q.substring(Ce, fe + 1)), Re = "", $ = 0);
              }
          }
          $ === 0 && (K += Re);
      }
      ke = se, se = Q, fe++;
    }
    if (Ce = be.length, 0 < Ce) {
      if (we = z, 0 < ze && (Xe = h(2, be, we, G, J, ye, Ce, U, O, U), Xe !== void 0 && (be = Xe).length === 0)) return Ge + be + nt;
      if (be = we.join(",") + "{" + be + "}", Ie * he !== 0) {
        switch (Ie !== 2 || a(be, 2) || (he = 0), he) {
          case 111:
            be = be.replace(W, ":-moz-$1") + be;
            break;
          case 112:
            be = be.replace(V, "::-webkit-input-$1") + be.replace(V, "::-moz-$1") + be.replace(V, ":-ms-input-$1") + be;
        }
        he = 0;
      }
    }
    return Ge + be + nt;
  }
  function n(G, z, q) {
    var U = z.trim().split(N);
    z = U;
    var O = U.length, ue = G.length;
    switch (ue) {
      case 0:
      case 1:
        var $ = 0;
        for (G = ue === 0 ? "" : G[0] + " "; $ < O; ++$)
          z[$] = r(G, z[$], q).trim();
        break;
      default:
        var me = $ = 0;
        for (z = []; $ < O; ++$)
          for (var ie = 0; ie < ue; ++ie)
            z[me++] = r(G[ie] + " ", U[$], q).trim();
    }
    return z;
  }
  function r(G, z, q) {
    var U = z.charCodeAt(0);
    switch (33 > U && (U = (z = z.trim()).charCodeAt(0)), U) {
      case 38:
        return z.replace(j, "$1" + G.trim());
      case 58:
        return G.trim() + z.replace(j, "$1" + G.trim());
      default:
        if (0 < 1 * q && 0 < z.indexOf("\f")) return z.replace(j, (G.charCodeAt(0) === 58 ? "" : "$1") + G.trim());
    }
    return G + z;
  }
  function i(G, z, q, U) {
    var O = G + ";", ue = 2 * z + 3 * q + 4 * U;
    if (ue === 944) {
      G = O.indexOf(":", 9) + 1;
      var $ = O.substring(G, O.length - 1).trim();
      return $ = O.substring(0, G).trim() + $ + ";", Ie === 1 || Ie === 2 && a($, 1) ? "-webkit-" + $ + $ : $;
    }
    if (Ie === 0 || Ie === 2 && !a(O, 1)) return O;
    switch (ue) {
      case 1015:
        return O.charCodeAt(10) === 97 ? "-webkit-" + O + O : O;
      case 951:
        return O.charCodeAt(3) === 116 ? "-webkit-" + O + O : O;
      case 963:
        return O.charCodeAt(5) === 110 ? "-webkit-" + O + O : O;
      case 1009:
        if (O.charCodeAt(4) !== 100) break;
      case 969:
      case 942:
        return "-webkit-" + O + O;
      case 978:
        return "-webkit-" + O + "-moz-" + O + O;
      case 1019:
      case 983:
        return "-webkit-" + O + "-moz-" + O + "-ms-" + O + O;
      case 883:
        if (O.charCodeAt(8) === 45) return "-webkit-" + O + O;
        if (0 < O.indexOf("image-set(", 11)) return O.replace(Se, "$1-webkit-$2") + O;
        break;
      case 932:
        if (O.charCodeAt(4) === 45) switch (O.charCodeAt(5)) {
          case 103:
            return "-webkit-box-" + O.replace("-grow", "") + "-webkit-" + O + "-ms-" + O.replace("grow", "positive") + O;
          case 115:
            return "-webkit-" + O + "-ms-" + O.replace("shrink", "negative") + O;
          case 98:
            return "-webkit-" + O + "-ms-" + O.replace("basis", "preferred-size") + O;
        }
        return "-webkit-" + O + "-ms-" + O + O;
      case 964:
        return "-webkit-" + O + "-ms-flex-" + O + O;
      case 1023:
        if (O.charCodeAt(8) !== 99) break;
        return $ = O.substring(O.indexOf(":", 15)).replace("flex-", "").replace("space-between", "justify"), "-webkit-box-pack" + $ + "-webkit-" + O + "-ms-flex-pack" + $ + O;
      case 1005:
        return A.test(O) ? O.replace(P, ":-webkit-") + O.replace(P, ":-moz-") + O : O;
      case 1e3:
        switch ($ = O.substring(13).trim(), z = $.indexOf("-") + 1, $.charCodeAt(0) + $.charCodeAt(z)) {
          case 226:
            $ = O.replace(M, "tb");
            break;
          case 232:
            $ = O.replace(M, "tb-rl");
            break;
          case 220:
            $ = O.replace(M, "lr");
            break;
          default:
            return O;
        }
        return "-webkit-" + O + "-ms-" + $ + O;
      case 1017:
        if (O.indexOf("sticky", 9) === -1) break;
      case 975:
        switch (z = (O = G).length - 10, $ = (O.charCodeAt(z) === 33 ? O.substring(0, z) : O).substring(G.indexOf(":", 7) + 1).trim(), ue = $.charCodeAt(0) + ($.charCodeAt(7) | 0)) {
          case 203:
            if (111 > $.charCodeAt(8)) break;
          case 115:
            O = O.replace($, "-webkit-" + $) + ";" + O;
            break;
          case 207:
          case 102:
            O = O.replace($, "-webkit-" + (102 < ue ? "inline-" : "") + "box") + ";" + O.replace($, "-webkit-" + $) + ";" + O.replace($, "-ms-" + $ + "box") + ";" + O;
        }
        return O + ";";
      case 938:
        if (O.charCodeAt(5) === 45) switch (O.charCodeAt(6)) {
          case 105:
            return $ = O.replace("-items", ""), "-webkit-" + O + "-webkit-box-" + $ + "-ms-flex-" + $ + O;
          case 115:
            return "-webkit-" + O + "-ms-flex-item-" + O.replace(je, "") + O;
          default:
            return "-webkit-" + O + "-ms-flex-line-pack" + O.replace("align-content", "").replace(je, "") + O;
        }
        break;
      case 973:
      case 989:
        if (O.charCodeAt(3) !== 45 || O.charCodeAt(4) === 122) break;
      case 931:
      case 953:
        if (Ue.test(G) === !0) return ($ = G.substring(G.indexOf(":") + 1)).charCodeAt(0) === 115 ? i(G.replace("stretch", "fill-available"), z, q, U).replace(":fill-available", ":stretch") : O.replace($, "-webkit-" + $) + O.replace($, "-moz-" + $.replace("fill-", "")) + O;
        break;
      case 962:
        if (O = "-webkit-" + O + (O.charCodeAt(5) === 102 ? "-ms-" + O : "") + O, q + U === 211 && O.charCodeAt(13) === 105 && 0 < O.indexOf("transform", 10)) return O.substring(0, O.indexOf(";", 27) + 1).replace(k, "$1-webkit-$2") + O;
    }
    return O;
  }
  function a(G, z) {
    var q = G.indexOf(z === 1 ? ":" : "{"), U = G.substring(0, z !== 3 ? q : 10);
    return q = G.substring(q + 1, G.length - 1), qe(z !== 2 ? U : U.replace($e, "$1"), q, z);
  }
  function d(G, z) {
    var q = i(z, z.charCodeAt(0), z.charCodeAt(1), z.charCodeAt(2));
    return q !== z + ";" ? q.replace(le, " or ($1)").substring(4) : "(" + z + ")";
  }
  function h(G, z, q, U, O, ue, $, me, ie, oe) {
    for (var Q = 0, se = z, ke; Q < ze; ++Q)
      switch (ke = Be[Q].call(b, G, se, q, U, O, ue, $, me, ie, oe)) {
        case void 0:
        case !1:
        case !0:
        case null:
          break;
        default:
          se = ke;
      }
    if (se !== z) return se;
  }
  function m(G) {
    switch (G) {
      case void 0:
      case null:
        ze = Be.length = 0;
        break;
      default:
        if (typeof G == "function") Be[ze++] = G;
        else if (typeof G == "object") for (var z = 0, q = G.length; z < q; ++z)
          m(G[z]);
        else ft = !!G | 0;
    }
    return m;
  }
  function p(G) {
    return G = G.prefix, G !== void 0 && (qe = null, G ? typeof G != "function" ? Ie = 1 : (Ie = 2, qe = G) : Ie = 0), p;
  }
  function b(G, z) {
    var q = G;
    if (33 > q.charCodeAt(0) && (q = q.trim()), xe = q, q = [xe], 0 < ze) {
      var U = h(-1, z, q, q, J, ye, 0, 0, 0, 0);
      U !== void 0 && typeof U == "string" && (z = U);
    }
    var O = t(dt, q, z, 0, 0);
    return 0 < ze && (U = h(-2, O, q, q, J, ye, O.length, 0, 0, 0), U !== void 0 && (O = U)), xe = "", he = 0, ye = J = 1, O;
  }
  var S = /^\0+/g, E = /[\0\r\f]/g, P = /: */g, A = /zoo|gra/, k = /([,: ])(transform)/g, N = /,\r+?/g, j = /([\t\r\n ])*\f?&/g, D = /@(k\w+)\s*(\S*)\s*/, V = /::(place)/g, W = /:(read-only)/g, M = /[svh]\w+-[tblr]{2}/, Z = /\(\s*(.*)\s*\)/g, le = /([\s\S]*?);/g, je = /-self|flex-/g, $e = /[^]*?(:[rp][el]a[\w-]+)[^]*/, Ue = /stretch|:\s*\w+\-(?:conte|avail)/, Se = /([^-])(image-set\()/, ye = 1, J = 1, he = 0, Ie = 1, dt = [], Be = [], ze = 0, qe = null, ft = 0, xe = "";
  return b.use = m, b.set = p, e !== void 0 && p(e), b;
}
var wl = {
  animationIterationCount: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
};
function Sl(e) {
  var t = /* @__PURE__ */ Object.create(null);
  return function(n) {
    return t[n] === void 0 && (t[n] = e(n)), t[n];
  };
}
var kl = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|disableRemotePlayback|download|draggable|encType|enterKeyHint|fetchpriority|fetchPriority|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/, Ho = /* @__PURE__ */ Sl(
  function(e) {
    return kl.test(e) || e.charCodeAt(0) === 111 && e.charCodeAt(1) === 110 && e.charCodeAt(2) < 91;
  }
  /* Z+1 */
), Is = { exports: {} }, Ee = {};
var Vo;
function Tl() {
  if (Vo) return Ee;
  Vo = 1;
  var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, n = e ? Symbol.for("react.portal") : 60106, r = e ? Symbol.for("react.fragment") : 60107, i = e ? Symbol.for("react.strict_mode") : 60108, a = e ? Symbol.for("react.profiler") : 60114, d = e ? Symbol.for("react.provider") : 60109, h = e ? Symbol.for("react.context") : 60110, m = e ? Symbol.for("react.async_mode") : 60111, p = e ? Symbol.for("react.concurrent_mode") : 60111, b = e ? Symbol.for("react.forward_ref") : 60112, S = e ? Symbol.for("react.suspense") : 60113, E = e ? Symbol.for("react.suspense_list") : 60120, P = e ? Symbol.for("react.memo") : 60115, A = e ? Symbol.for("react.lazy") : 60116, k = e ? Symbol.for("react.block") : 60121, N = e ? Symbol.for("react.fundamental") : 60117, j = e ? Symbol.for("react.responder") : 60118, D = e ? Symbol.for("react.scope") : 60119;
  function V(M) {
    if (typeof M == "object" && M !== null) {
      var Z = M.$$typeof;
      switch (Z) {
        case t:
          switch (M = M.type, M) {
            case m:
            case p:
            case r:
            case a:
            case i:
            case S:
              return M;
            default:
              switch (M = M && M.$$typeof, M) {
                case h:
                case b:
                case A:
                case P:
                case d:
                  return M;
                default:
                  return Z;
              }
          }
        case n:
          return Z;
      }
    }
  }
  function W(M) {
    return V(M) === p;
  }
  return Ee.AsyncMode = m, Ee.ConcurrentMode = p, Ee.ContextConsumer = h, Ee.ContextProvider = d, Ee.Element = t, Ee.ForwardRef = b, Ee.Fragment = r, Ee.Lazy = A, Ee.Memo = P, Ee.Portal = n, Ee.Profiler = a, Ee.StrictMode = i, Ee.Suspense = S, Ee.isAsyncMode = function(M) {
    return W(M) || V(M) === m;
  }, Ee.isConcurrentMode = W, Ee.isContextConsumer = function(M) {
    return V(M) === h;
  }, Ee.isContextProvider = function(M) {
    return V(M) === d;
  }, Ee.isElement = function(M) {
    return typeof M == "object" && M !== null && M.$$typeof === t;
  }, Ee.isForwardRef = function(M) {
    return V(M) === b;
  }, Ee.isFragment = function(M) {
    return V(M) === r;
  }, Ee.isLazy = function(M) {
    return V(M) === A;
  }, Ee.isMemo = function(M) {
    return V(M) === P;
  }, Ee.isPortal = function(M) {
    return V(M) === n;
  }, Ee.isProfiler = function(M) {
    return V(M) === a;
  }, Ee.isStrictMode = function(M) {
    return V(M) === i;
  }, Ee.isSuspense = function(M) {
    return V(M) === S;
  }, Ee.isValidElementType = function(M) {
    return typeof M == "string" || typeof M == "function" || M === r || M === p || M === a || M === i || M === S || M === E || typeof M == "object" && M !== null && (M.$$typeof === A || M.$$typeof === P || M.$$typeof === d || M.$$typeof === h || M.$$typeof === b || M.$$typeof === N || M.$$typeof === j || M.$$typeof === D || M.$$typeof === k);
  }, Ee.typeOf = V, Ee;
}
Is.exports = Tl();
var _l = Is.exports, Ui = _l, El = {
  childContextTypes: !0,
  contextType: !0,
  contextTypes: !0,
  defaultProps: !0,
  displayName: !0,
  getDefaultProps: !0,
  getDerivedStateFromError: !0,
  getDerivedStateFromProps: !0,
  mixins: !0,
  propTypes: !0,
  type: !0
}, Cl = {
  name: !0,
  length: !0,
  prototype: !0,
  caller: !0,
  callee: !0,
  arguments: !0,
  arity: !0
}, Rl = {
  $$typeof: !0,
  render: !0,
  defaultProps: !0,
  displayName: !0,
  propTypes: !0
}, Ps = {
  $$typeof: !0,
  compare: !0,
  defaultProps: !0,
  displayName: !0,
  propTypes: !0,
  type: !0
}, qi = {};
qi[Ui.ForwardRef] = Rl;
qi[Ui.Memo] = Ps;
function Wo(e) {
  return Ui.isMemo(e) ? Ps : qi[e.$$typeof] || El;
}
var Al = Object.defineProperty, Ol = Object.getOwnPropertyNames, Uo = Object.getOwnPropertySymbols, jl = Object.getOwnPropertyDescriptor, Nl = Object.getPrototypeOf, qo = Object.prototype;
function Ls(e, t, n) {
  if (typeof t != "string") {
    if (qo) {
      var r = Nl(t);
      r && r !== qo && Ls(e, r, n);
    }
    var i = Ol(t);
    Uo && (i = i.concat(Uo(t)));
    for (var a = Wo(e), d = Wo(t), h = 0; h < i.length; ++h) {
      var m = i[h];
      if (!Cl[m] && !(n && n[m]) && !(d && d[m]) && !(a && a[m])) {
        var p = jl(t, m);
        try {
          Al(e, m, p);
        } catch {
        }
      }
    }
  }
  return e;
}
var Il = Ls;
const Pl = /* @__PURE__ */ Vi(Il);
var tt = { env: { NODE_ENV: "production" } };
function Gt() {
  return (Gt = Object.assign || function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }).apply(this, arguments);
}
var Yo = function(e, t) {
  for (var n = [e[0]], r = 0, i = t.length; r < i; r += 1) n.push(t[r], e[r + 1]);
  return n;
}, Si = function(e) {
  return e !== null && typeof e == "object" && (e.toString ? e.toString() : Object.prototype.toString.call(e)) === "[object Object]" && !Ns.typeOf(e);
}, $r = Object.freeze([]), ln = Object.freeze({});
function rr(e) {
  return typeof e == "function";
}
function Go(e) {
  return e.displayName || e.name || "Component";
}
function Yi(e) {
  return e && typeof e.styledComponentId == "string";
}
var Ln = typeof tt < "u" && tt.env !== void 0 && (tt.env.REACT_APP_SC_ATTR || tt.env.SC_ATTR) || "data-styled", Gi = typeof window < "u" && "HTMLElement" in window, Ll = !!(typeof SC_DISABLE_SPEEDY == "boolean" ? SC_DISABLE_SPEEDY : typeof tt < "u" && tt.env !== void 0 && (tt.env.REACT_APP_SC_DISABLE_SPEEDY !== void 0 && tt.env.REACT_APP_SC_DISABLE_SPEEDY !== "" ? tt.env.REACT_APP_SC_DISABLE_SPEEDY !== "false" && tt.env.REACT_APP_SC_DISABLE_SPEEDY : tt.env.SC_DISABLE_SPEEDY !== void 0 && tt.env.SC_DISABLE_SPEEDY !== "" ? tt.env.SC_DISABLE_SPEEDY !== "false" && tt.env.SC_DISABLE_SPEEDY : tt.env.NODE_ENV !== "production"));
function or(e) {
  for (var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++) n[r - 1] = arguments[r];
  throw new Error("An error occurred. See https://git.io/JUIaE#" + e + " for more information." + (n.length > 0 ? " Args: " + n.join(", ") : ""));
}
var Ml = function() {
  function e(n) {
    this.groupSizes = new Uint32Array(512), this.length = 512, this.tag = n;
  }
  var t = e.prototype;
  return t.indexOfGroup = function(n) {
    for (var r = 0, i = 0; i < n; i++) r += this.groupSizes[i];
    return r;
  }, t.insertRules = function(n, r) {
    if (n >= this.groupSizes.length) {
      for (var i = this.groupSizes, a = i.length, d = a; n >= d; ) (d <<= 1) < 0 && or(16, "" + n);
      this.groupSizes = new Uint32Array(d), this.groupSizes.set(i), this.length = d;
      for (var h = a; h < d; h++) this.groupSizes[h] = 0;
    }
    for (var m = this.indexOfGroup(n + 1), p = 0, b = r.length; p < b; p++) this.tag.insertRule(m, r[p]) && (this.groupSizes[n]++, m++);
  }, t.clearGroup = function(n) {
    if (n < this.length) {
      var r = this.groupSizes[n], i = this.indexOfGroup(n), a = i + r;
      this.groupSizes[n] = 0;
      for (var d = i; d < a; d++) this.tag.deleteRule(i);
    }
  }, t.getGroup = function(n) {
    var r = "";
    if (n >= this.length || this.groupSizes[n] === 0) return r;
    for (var i = this.groupSizes[n], a = this.indexOfGroup(n), d = a + i, h = a; h < d; h++) r += this.tag.getRule(h) + `/*!sc*/
`;
    return r;
  }, e;
}(), Ir = /* @__PURE__ */ new Map(), Br = /* @__PURE__ */ new Map(), tr = 1, Er = function(e) {
  if (Ir.has(e)) return Ir.get(e);
  for (; Br.has(tr); ) tr++;
  var t = tr++;
  return Ir.set(e, t), Br.set(t, e), t;
}, Dl = function(e) {
  return Br.get(e);
}, Fl = function(e, t) {
  t >= tr && (tr = t + 1), Ir.set(e, t), Br.set(t, e);
}, $l = "style[" + Ln + '][data-styled-version="5.3.11"]', Bl = new RegExp("^" + Ln + '\\.g(\\d+)\\[id="([\\w\\d-]+)"\\].*?"([^"]*)'), zl = function(e, t, n) {
  for (var r, i = n.split(","), a = 0, d = i.length; a < d; a++) (r = i[a]) && e.registerName(t, r);
}, Hl = function(e, t) {
  for (var n = (t.textContent || "").split(`/*!sc*/
`), r = [], i = 0, a = n.length; i < a; i++) {
    var d = n[i].trim();
    if (d) {
      var h = d.match(Bl);
      if (h) {
        var m = 0 | parseInt(h[1], 10), p = h[2];
        m !== 0 && (Fl(p, m), zl(e, p, h[3]), e.getTag().insertRules(m, r)), r.length = 0;
      } else r.push(d);
    }
  }
}, Vl = function() {
  return typeof __webpack_nonce__ < "u" ? __webpack_nonce__ : null;
}, Ms = function(e) {
  var t = document.head, n = e || t, r = document.createElement("style"), i = function(h) {
    for (var m = h.childNodes, p = m.length; p >= 0; p--) {
      var b = m[p];
      if (b && b.nodeType === 1 && b.hasAttribute(Ln)) return b;
    }
  }(n), a = i !== void 0 ? i.nextSibling : null;
  r.setAttribute(Ln, "active"), r.setAttribute("data-styled-version", "5.3.11");
  var d = Vl();
  return d && r.setAttribute("nonce", d), n.insertBefore(r, a), r;
}, Wl = function() {
  function e(n) {
    var r = this.element = Ms(n);
    r.appendChild(document.createTextNode("")), this.sheet = function(i) {
      if (i.sheet) return i.sheet;
      for (var a = document.styleSheets, d = 0, h = a.length; d < h; d++) {
        var m = a[d];
        if (m.ownerNode === i) return m;
      }
      or(17);
    }(r), this.length = 0;
  }
  var t = e.prototype;
  return t.insertRule = function(n, r) {
    try {
      return this.sheet.insertRule(r, n), this.length++, !0;
    } catch {
      return !1;
    }
  }, t.deleteRule = function(n) {
    this.sheet.deleteRule(n), this.length--;
  }, t.getRule = function(n) {
    var r = this.sheet.cssRules[n];
    return r !== void 0 && typeof r.cssText == "string" ? r.cssText : "";
  }, e;
}(), Ul = function() {
  function e(n) {
    var r = this.element = Ms(n);
    this.nodes = r.childNodes, this.length = 0;
  }
  var t = e.prototype;
  return t.insertRule = function(n, r) {
    if (n <= this.length && n >= 0) {
      var i = document.createTextNode(r), a = this.nodes[n];
      return this.element.insertBefore(i, a || null), this.length++, !0;
    }
    return !1;
  }, t.deleteRule = function(n) {
    this.element.removeChild(this.nodes[n]), this.length--;
  }, t.getRule = function(n) {
    return n < this.length ? this.nodes[n].textContent : "";
  }, e;
}(), ql = function() {
  function e(n) {
    this.rules = [], this.length = 0;
  }
  var t = e.prototype;
  return t.insertRule = function(n, r) {
    return n <= this.length && (this.rules.splice(n, 0, r), this.length++, !0);
  }, t.deleteRule = function(n) {
    this.rules.splice(n, 1), this.length--;
  }, t.getRule = function(n) {
    return n < this.length ? this.rules[n] : "";
  }, e;
}(), Xo = Gi, Yl = { isServer: !Gi, useCSSOMInjection: !Ll }, Ds = function() {
  function e(n, r, i) {
    n === void 0 && (n = ln), r === void 0 && (r = {}), this.options = Gt({}, Yl, {}, n), this.gs = r, this.names = new Map(i), this.server = !!n.isServer, !this.server && Gi && Xo && (Xo = !1, function(a) {
      for (var d = document.querySelectorAll($l), h = 0, m = d.length; h < m; h++) {
        var p = d[h];
        p && p.getAttribute(Ln) !== "active" && (Hl(a, p), p.parentNode && p.parentNode.removeChild(p));
      }
    }(this));
  }
  e.registerId = function(n) {
    return Er(n);
  };
  var t = e.prototype;
  return t.reconstructWithOptions = function(n, r) {
    return r === void 0 && (r = !0), new e(Gt({}, this.options, {}, n), this.gs, r && this.names || void 0);
  }, t.allocateGSInstance = function(n) {
    return this.gs[n] = (this.gs[n] || 0) + 1;
  }, t.getTag = function() {
    return this.tag || (this.tag = (i = (r = this.options).isServer, a = r.useCSSOMInjection, d = r.target, n = i ? new ql(d) : a ? new Wl(d) : new Ul(d), new Ml(n)));
    var n, r, i, a, d;
  }, t.hasNameForId = function(n, r) {
    return this.names.has(n) && this.names.get(n).has(r);
  }, t.registerName = function(n, r) {
    if (Er(n), this.names.has(n)) this.names.get(n).add(r);
    else {
      var i = /* @__PURE__ */ new Set();
      i.add(r), this.names.set(n, i);
    }
  }, t.insertRules = function(n, r, i) {
    this.registerName(n, r), this.getTag().insertRules(Er(n), i);
  }, t.clearNames = function(n) {
    this.names.has(n) && this.names.get(n).clear();
  }, t.clearRules = function(n) {
    this.getTag().clearGroup(Er(n)), this.clearNames(n);
  }, t.clearTag = function() {
    this.tag = void 0;
  }, t.toString = function() {
    return function(n) {
      for (var r = n.getTag(), i = r.length, a = "", d = 0; d < i; d++) {
        var h = Dl(d);
        if (h !== void 0) {
          var m = n.names.get(h), p = r.getGroup(d);
          if (m && p && m.size) {
            var b = Ln + ".g" + d + '[id="' + h + '"]', S = "";
            m !== void 0 && m.forEach(function(E) {
              E.length > 0 && (S += E + ",");
            }), a += "" + p + b + '{content:"' + S + `"}/*!sc*/
`;
          }
        }
      }
      return a;
    }(this);
  }, e;
}(), Gl = /(a)(d)/gi, Ko = function(e) {
  return String.fromCharCode(e + (e > 25 ? 39 : 97));
};
function ki(e) {
  var t, n = "";
  for (t = Math.abs(e); t > 52; t = t / 52 | 0) n = Ko(t % 52) + n;
  return (Ko(t % 52) + n).replace(Gl, "$1-$2");
}
var Pn = function(e, t) {
  for (var n = t.length; n; ) e = 33 * e ^ t.charCodeAt(--n);
  return e;
}, Fs = function(e) {
  return Pn(5381, e);
};
function Xl(e) {
  for (var t = 0; t < e.length; t += 1) {
    var n = e[t];
    if (rr(n) && !Yi(n)) return !1;
  }
  return !0;
}
var Kl = Fs("5.3.11"), Zl = function() {
  function e(t, n, r) {
    this.rules = t, this.staticRulesId = "", this.isStatic = (r === void 0 || r.isStatic) && Xl(t), this.componentId = n, this.baseHash = Pn(Kl, n), this.baseStyle = r, Ds.registerId(n);
  }
  return e.prototype.generateAndInjectStyles = function(t, n, r) {
    var i = this.componentId, a = [];
    if (this.baseStyle && a.push(this.baseStyle.generateAndInjectStyles(t, n, r)), this.isStatic && !r.hash) if (this.staticRulesId && n.hasNameForId(i, this.staticRulesId)) a.push(this.staticRulesId);
    else {
      var d = Mn(this.rules, t, n, r).join(""), h = ki(Pn(this.baseHash, d) >>> 0);
      if (!n.hasNameForId(i, h)) {
        var m = r(d, "." + h, void 0, i);
        n.insertRules(i, h, m);
      }
      a.push(h), this.staticRulesId = h;
    }
    else {
      for (var p = this.rules.length, b = Pn(this.baseHash, r.hash), S = "", E = 0; E < p; E++) {
        var P = this.rules[E];
        if (typeof P == "string") S += P;
        else if (P) {
          var A = Mn(P, t, n, r), k = Array.isArray(A) ? A.join("") : A;
          b = Pn(b, k + E), S += k;
        }
      }
      if (S) {
        var N = ki(b >>> 0);
        if (!n.hasNameForId(i, N)) {
          var j = r(S, "." + N, void 0, i);
          n.insertRules(i, N, j);
        }
        a.push(N);
      }
    }
    return a.join(" ");
  }, e;
}(), Jl = /^\s*\/\/.*$/gm, Ql = [":", "[", ".", "#"];
function ec(e) {
  var t, n, r, i, a = ln, d = a.options, h = d === void 0 ? ln : d, m = a.plugins, p = m === void 0 ? $r : m, b = new bl(h), S = [], E = /* @__PURE__ */ function(k) {
    function N(j) {
      if (j) try {
        k(j + "}");
      } catch {
      }
    }
    return function(j, D, V, W, M, Z, le, je, $e, Ue) {
      switch (j) {
        case 1:
          if ($e === 0 && D.charCodeAt(0) === 64) return k(D + ";"), "";
          break;
        case 2:
          if (je === 0) return D + "/*|*/";
          break;
        case 3:
          switch (je) {
            case 102:
            case 112:
              return k(V[0] + D), "";
            default:
              return D + (Ue === 0 ? "/*|*/" : "");
          }
        case -2:
          D.split("/*|*/}").forEach(N);
      }
    };
  }(function(k) {
    S.push(k);
  }), P = function(k, N, j) {
    return N === 0 && Ql.indexOf(j[n.length]) !== -1 || j.match(i) ? k : "." + t;
  };
  function A(k, N, j, D) {
    D === void 0 && (D = "&");
    var V = k.replace(Jl, ""), W = N && j ? j + " " + N + " { " + V + " }" : V;
    return t = D, n = N, r = new RegExp("\\" + n + "\\b", "g"), i = new RegExp("(\\" + n + "\\b){2,}"), b(j || !N ? "" : N, W);
  }
  return b.use([].concat(p, [function(k, N, j) {
    k === 2 && j.length && j[0].lastIndexOf(n) > 0 && (j[0] = j[0].replace(r, P));
  }, E, function(k) {
    if (k === -2) {
      var N = S;
      return S = [], N;
    }
  }])), A.hash = p.length ? p.reduce(function(k, N) {
    return N.name || or(15), Pn(k, N.name);
  }, 5381).toString() : "", A;
}
var $s = He.createContext();
$s.Consumer;
var Bs = He.createContext(), tc = (Bs.Consumer, new Ds()), Ti = ec();
function nc() {
  return Hi($s) || tc;
}
function rc() {
  return Hi(Bs) || Ti;
}
var ic = function() {
  function e(t, n) {
    var r = this;
    this.inject = function(i, a) {
      a === void 0 && (a = Ti);
      var d = r.name + a.hash;
      i.hasNameForId(r.id, d) || i.insertRules(r.id, d, a(r.rules, d, "@keyframes"));
    }, this.toString = function() {
      return or(12, String(r.name));
    }, this.name = t, this.id = "sc-keyframes-" + t, this.rules = n;
  }
  return e.prototype.getName = function(t) {
    return t === void 0 && (t = Ti), this.name + t.hash;
  }, e;
}(), oc = /([A-Z])/, sc = /([A-Z])/g, ac = /^ms-/, lc = function(e) {
  return "-" + e.toLowerCase();
};
function Zo(e) {
  return oc.test(e) ? e.replace(sc, lc).replace(ac, "-ms-") : e;
}
var Jo = function(e) {
  return e == null || e === !1 || e === "";
};
function Mn(e, t, n, r) {
  if (Array.isArray(e)) {
    for (var i, a = [], d = 0, h = e.length; d < h; d += 1) (i = Mn(e[d], t, n, r)) !== "" && (Array.isArray(i) ? a.push.apply(a, i) : a.push(i));
    return a;
  }
  if (Jo(e)) return "";
  if (Yi(e)) return "." + e.styledComponentId;
  if (rr(e)) {
    if (typeof (p = e) != "function" || p.prototype && p.prototype.isReactComponent || !t) return e;
    var m = e(t);
    return Mn(m, t, n, r);
  }
  var p;
  return e instanceof ic ? n ? (e.inject(n, r), e.getName(r)) : e : Si(e) ? function b(S, E) {
    var P, A, k = [];
    for (var N in S) S.hasOwnProperty(N) && !Jo(S[N]) && (Array.isArray(S[N]) && S[N].isCss || rr(S[N]) ? k.push(Zo(N) + ":", S[N], ";") : Si(S[N]) ? k.push.apply(k, b(S[N], N)) : k.push(Zo(N) + ": " + (P = N, (A = S[N]) == null || typeof A == "boolean" || A === "" ? "" : typeof A != "number" || A === 0 || P in wl || P.startsWith("--") ? String(A).trim() : A + "px") + ";"));
    return E ? [E + " {"].concat(k, ["}"]) : k;
  }(e) : e.toString();
}
var Qo = function(e) {
  return Array.isArray(e) && (e.isCss = !0), e;
};
function cc(e) {
  for (var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++) n[r - 1] = arguments[r];
  return rr(e) || Si(e) ? Qo(Mn(Yo($r, [e].concat(n)))) : n.length === 0 && e.length === 1 && typeof e[0] == "string" ? e : Qo(Mn(Yo(e, n)));
}
var uc = function(e, t, n) {
  return n === void 0 && (n = ln), e.theme !== n.theme && e.theme || t || n.theme;
}, dc = /[!"#$%&'()*+,./:;<=>?@[\\\]^`{|}~-]+/g, fc = /(^-|-$)/g;
function gi(e) {
  return e.replace(dc, "-").replace(fc, "");
}
var pc = function(e) {
  return ki(Fs(e) >>> 0);
};
function Cr(e) {
  return typeof e == "string" && tt.env.NODE_ENV === "production";
}
var _i = function(e) {
  return typeof e == "function" || typeof e == "object" && e !== null && !Array.isArray(e);
}, hc = function(e) {
  return e !== "__proto__" && e !== "constructor" && e !== "prototype";
};
function mc(e, t, n) {
  var r = e[n];
  _i(t) && _i(r) ? zs(r, t) : e[n] = t;
}
function zs(e) {
  for (var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++) n[r - 1] = arguments[r];
  for (var i = 0, a = n; i < a.length; i++) {
    var d = a[i];
    if (_i(d)) for (var h in d) hc(h) && mc(e, d[h], h);
  }
  return e;
}
var Hs = He.createContext();
Hs.Consumer;
var vi = {};
function Vs(e, t, n) {
  var r = Yi(e), i = !Cr(e), a = t.attrs, d = a === void 0 ? $r : a, h = t.componentId, m = h === void 0 ? function(D, V) {
    var W = typeof D != "string" ? "sc" : gi(D);
    vi[W] = (vi[W] || 0) + 1;
    var M = W + "-" + pc("5.3.11" + W + vi[W]);
    return V ? V + "-" + M : M;
  }(t.displayName, t.parentComponentId) : h, p = t.displayName, b = p === void 0 ? function(D) {
    return Cr(D) ? "styled." + D : "Styled(" + Go(D) + ")";
  }(e) : p, S = t.displayName && t.componentId ? gi(t.displayName) + "-" + t.componentId : t.componentId || m, E = r && e.attrs ? Array.prototype.concat(e.attrs, d).filter(Boolean) : d, P = t.shouldForwardProp;
  r && e.shouldForwardProp && (P = t.shouldForwardProp ? function(D, V, W) {
    return e.shouldForwardProp(D, V, W) && t.shouldForwardProp(D, V, W);
  } : e.shouldForwardProp);
  var A, k = new Zl(n, S, r ? e.componentStyle : void 0), N = k.isStatic && d.length === 0, j = function(D, V) {
    return function(W, M, Z, le) {
      var je = W.attrs, $e = W.componentStyle, Ue = W.defaultProps, Se = W.foldedComponentIds, ye = W.shouldForwardProp, J = W.styledComponentId, he = W.target, Ie = function(U, O, ue) {
        U === void 0 && (U = ln);
        var $ = Gt({}, O, { theme: U }), me = {};
        return ue.forEach(function(ie) {
          var oe, Q, se, ke = ie;
          for (oe in rr(ke) && (ke = ke($)), ke) $[oe] = me[oe] = oe === "className" ? (Q = me[oe], se = ke[oe], Q && se ? Q + " " + se : Q || se) : ke[oe];
        }), [$, me];
      }(uc(M, Hi(Hs), Ue) || ln, M, je), dt = Ie[0], Be = Ie[1], ze = function(U, O, ue, $) {
        var me = nc(), ie = rc(), oe = O ? U.generateAndInjectStyles(ln, me, ie) : U.generateAndInjectStyles(ue, me, ie);
        return oe;
      }($e, le, dt), qe = Z, ft = Be.$as || M.$as || Be.as || M.as || he, xe = Cr(ft), G = Be !== M ? Gt({}, M, {}, Be) : M, z = {};
      for (var q in G) q[0] !== "$" && q !== "as" && (q === "forwardedAs" ? z.as = G[q] : (ye ? ye(q, Ho, ft) : !xe || Ho(q)) && (z[q] = G[q]));
      return M.style && Be.style !== M.style && (z.style = Gt({}, M.style, {}, Be.style)), z.className = Array.prototype.concat(Se, J, ze !== J ? ze : null, M.className, Be.className).filter(Boolean).join(" "), z.ref = qe, Na(ft, z);
    }(A, D, V, N);
  };
  return j.displayName = b, (A = He.forwardRef(j)).attrs = E, A.componentStyle = k, A.displayName = b, A.shouldForwardProp = P, A.foldedComponentIds = r ? Array.prototype.concat(e.foldedComponentIds, e.styledComponentId) : $r, A.styledComponentId = S, A.target = r ? e.target : e, A.withComponent = function(D) {
    var V = t.componentId, W = function(Z, le) {
      if (Z == null) return {};
      var je, $e, Ue = {}, Se = Object.keys(Z);
      for ($e = 0; $e < Se.length; $e++) je = Se[$e], le.indexOf(je) >= 0 || (Ue[je] = Z[je]);
      return Ue;
    }(t, ["componentId"]), M = V && V + "-" + (Cr(D) ? D : gi(Go(D)));
    return Vs(D, Gt({}, W, { attrs: E, componentId: M }), n);
  }, Object.defineProperty(A, "defaultProps", { get: function() {
    return this._foldedDefaultProps;
  }, set: function(D) {
    this._foldedDefaultProps = r ? zs({}, e.defaultProps, D) : D;
  } }), Object.defineProperty(A, "toString", { value: function() {
    return "." + A.styledComponentId;
  } }), i && Pl(A, e, { attrs: !0, componentStyle: !0, displayName: !0, foldedComponentIds: !0, shouldForwardProp: !0, styledComponentId: !0, target: !0, withComponent: !0 }), A;
}
var Pt = function(e) {
  return function t(n, r, i) {
    if (i === void 0 && (i = ln), !Ns.isValidElementType(r)) return or(1, String(r));
    var a = function() {
      return n(r, i, cc.apply(void 0, arguments));
    };
    return a.withConfig = function(d) {
      return t(n, r, Gt({}, i, {}, d));
    }, a.attrs = function(d) {
      return t(n, r, Gt({}, i, { attrs: Array.prototype.concat(i.attrs, d).filter(Boolean) }));
    }, a;
  }(Vs, e);
};
["a", "abbr", "address", "area", "article", "aside", "audio", "b", "base", "bdi", "bdo", "big", "blockquote", "body", "br", "button", "canvas", "caption", "cite", "code", "col", "colgroup", "data", "datalist", "dd", "del", "details", "dfn", "dialog", "div", "dl", "dt", "em", "embed", "fieldset", "figcaption", "figure", "footer", "form", "h1", "h2", "h3", "h4", "h5", "h6", "head", "header", "hgroup", "hr", "html", "i", "iframe", "img", "input", "ins", "kbd", "keygen", "label", "legend", "li", "link", "main", "map", "mark", "marquee", "menu", "menuitem", "meta", "meter", "nav", "noscript", "object", "ol", "optgroup", "option", "output", "p", "param", "picture", "pre", "progress", "q", "rp", "rt", "ruby", "s", "samp", "script", "section", "select", "small", "source", "span", "strong", "style", "sub", "summary", "sup", "table", "tbody", "td", "textarea", "tfoot", "th", "thead", "time", "title", "tr", "track", "u", "ul", "var", "video", "wbr", "circle", "clipPath", "defs", "ellipse", "foreignObject", "g", "image", "line", "linearGradient", "marker", "mask", "path", "pattern", "polygon", "polyline", "radialGradient", "rect", "stop", "svg", "text", "textPath", "tspan"].forEach(function(e) {
  Pt[e] = Pt(e);
});
const gc = Pt.div`
  &.sticky {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    &.with-header {
      top: ${({ requiresAltMenuSpacing: e }) => e ? "112px" : "142px"};
      @media (max-width: 992px) {
        top: 110px;
      }
    }
  }
  .mobile-menu-toggler {
    background-color: transparent;
    border: none;
    cursor: default;
    h4,
    h2 {
      align-items: center;
    }
    i {
      transition: all 0.3s;
    }
  }
  .show-menu i {
    transform: rotate(-180deg);
  }
  .nav-link {
    border: none;
    background-color: #ffffff;
    i {
      width: 2rem !important;
      text-align: center !important;
    }
  }
`, Pr = "On This Page", vc = {
  event: "collapse",
  name: "onclick",
  type: "click",
  text: Pr
}, Ws = ({
  items: e,
  firstElementId: t,
  focusFirstFocusableElement: n = !1
}) => {
  const { isReact: r, isBootstrap: i } = Cn(), a = cn(null), d = Ha("(max-width: 991px)"), [h, m] = Qe({
    hasHeader: !1,
    hasAltMenuSpacing: !1,
    containerClass: "container-xl",
    activeContainer: "",
    showMenu: !1,
    sticky: !1
  }), p = d ? 110 : 142, b = () => {
    var Z;
    const j = {}, D = window.scrollY, V = (Z = document.getElementById(t)) == null ? void 0 : Z.getBoundingClientRect().top, W = 103;
    V >= 0 && (j.sticky = !1, j.activeContainer = ""), D > a.current.getBoundingClientRect().top && (j.sticky = !0);
    const M = h.hasHeader ? p + W : W;
    e == null || e.forEach(({ targetIdName: le }) => {
      const je = document.getElementById(le), $e = (je == null ? void 0 : je.getBoundingClientRect().top) - M, Ue = (je == null ? void 0 : je.getBoundingClientRect().bottom) - M;
      $e < 0 && Ue > 0 && (j.activeContainer = le);
    }), m((le) => ({
      ...le,
      ...j
    }));
  }, S = () => {
    bi(b, 150), wi(b, 150);
  }, E = () => !!(document.getElementById("asu-header") || document.getElementById("headerContainer") || document.getElementById("asuHeader")), P = () => !!document.getElementById(
    "degreeDetailPageContainer"
  );
  function A(j = null) {
    if (j === null) return h.containerClass;
    const D = Object.values(j.classList).filter(
      (V) => [
        "container-sm",
        "container-md",
        "container",
        "container-lg",
        "container-xl",
        "container-fluid"
      ].includes(V)
    );
    return D.length > 0 ? D.join(" ") : A(j.parentElement);
  }
  at(() => {
    const j = document.getElementById(t) || null, D = {
      hasHeader: E(),
      hasAltMenuSpacing: P(),
      containerClass: A(j)
    };
    m((V) => ({
      ...V,
      ...D
    }));
  }, []), at(() => (window == null || window.addEventListener("scroll", S), () => window.removeEventListener("scroll", S)), [h.hasHeader]);
  const k = (j) => {
    var M, Z;
    const D = window.scrollY - (h.hasHeader ? p + 100 : 100), V = d ? 410 : 90;
    let W = ((M = document.getElementById(j)) == null ? void 0 : M.getBoundingClientRect().top) + D;
    a.current.classList.contains("sticky") || (W -= V), n && ((Z = dl(`#${j}`)) == null || Z.focus()), window.scrollTo({ top: W, behavior: "smooth" });
  }, N = () => {
    m((j) => ({
      ...j,
      showMenu: !j.showMenu
    }));
  };
  return (e == null ? void 0 : e.length) > 0 && /* @__PURE__ */ f.jsx(
    gc,
    {
      requiresAltMenuSpacing: h.hasAltMenuSpacing,
      ref: a,
      id: "uds-anchor-menu",
      className: ve(
        "uds-anchor-menu",
        "uds-anchor-menu-expanded-lg",
        "mb-4",
        {
          sticky: h.sticky,
          "with-header": h.hasHeader
        }
      ),
      style: h.showMenu ? { borderBottom: 0 } : {},
      children: /* @__PURE__ */ f.jsxs("div", { className: `${h.containerClass} uds-anchor-menu-wrapper`, children: [
        d ? /* @__PURE__ */ f.jsx(
          Ze,
          {
            gaData: {
              ...vc,
              action: h.showMenu ? "close" : "open"
            },
            children: /* @__PURE__ */ f.jsx(
              "button",
              {
                className: ve("mobile-menu-toggler", {
                  "show-menu": h.showMenu
                }),
                type: "button",
                onClick: N,
                "data-bs-toggle": "collapse",
                "data-bs-target": "#collapseAnchorMenu",
                "aria-controls": "collapseAnchorMenu",
                children: /* @__PURE__ */ f.jsxs("h2", { children: [
                  Pr,
                  ":",
                  /* @__PURE__ */ f.jsx("i", { className: "fas fa-chevron-down" })
                ] })
              }
            )
          }
        ) : /* @__PURE__ */ f.jsxs("h2", { children: [
          Pr,
          ":"
        ] }),
        /* @__PURE__ */ f.jsx(
          "div",
          {
            "data-testid": "anchor-menu-container",
            id: "collapseAnchorMenu",
            className: ve("card", "card-body", "collapse", {
              show: h.showMenu
            }),
            children: /* @__PURE__ */ f.jsx(
              "nav",
              {
                "data-testid": "anchor-menu",
                className: "nav",
                "aria-label": Pr,
                children: e == null ? void 0 : e.map((j) => (
                  // Use this package button
                  // @ts-ignore
                  /* @__PURE__ */ f.jsx(
                    an,
                    {
                      "data-testid": `anchor-item-${j.targetIdName}`,
                      classes: ve("nav-link", {
                        active: h.activeContainer === j.targetIdName
                      }).split(" "),
                      ariaLabel: j.text,
                      label: j.text,
                      icon: j.icon,
                      onClick: r && (() => k(j.targetIdName)),
                      href: i && `#${j.targetIdName}`
                    },
                    j.targetIdName
                  )
                ))
              }
            )
          }
        )
      ] })
    }
  );
};
Ws.propTypes = {
  /**
   * Anchor menu items
   */
  items: l.arrayOf(
    l.shape({
      text: l.string.isRequired,
      targetIdName: l.string.isRequired,
      icon: l.arrayOf(l.string)
    })
  ).isRequired,
  /**
   * First next sibling element of the anchor menu
   */
  firstElementId: l.string.isRequired,
  /**
   * If true it focus the first focusable element into the section
   * If false it focus the next menu item into the nav bar
   */
  focusFirstFocusableElement: l.bool
};
var Ei = function() {
  return Ei = Object.assign || function(e) {
    for (var t, n = 1, r = arguments.length; n < r; n++) {
      t = arguments[n];
      for (var i in t) Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
    }
    return e;
  }, Ei.apply(this, arguments);
}, yc = function(e, t) {
  var n = {};
  for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var i = 0, r = Object.getOwnPropertySymbols(e); i < r.length; i++)
      t.indexOf(r[i]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[i]) && (n[r[i]] = e[r[i]]);
  return n;
};
function Wr(e) {
  var t = function(n) {
    var r = n.bgStyle, i = n.borderRadius, a = n.iconFillColor, d = n.round, h = n.size, m = yc(n, ["bgStyle", "borderRadius", "iconFillColor", "round", "size"]);
    return He.createElement(
      "svg",
      Ei({ viewBox: "0 0 64 64", width: h, height: h }, m),
      d ? He.createElement("circle", { cx: "32", cy: "32", r: "31", fill: e.color, style: r }) : He.createElement("rect", { width: "64", height: "64", rx: i, ry: i, fill: e.color, style: r }),
      He.createElement("path", { d: e.path, fill: a })
    );
  };
  return t.defaultProps = {
    bgStyle: {},
    borderRadius: 0,
    iconFillColor: "white",
    size: 64
  }, t;
}
var xc = Wr({
  color: "#7f7f7f",
  path: "M17,22v20h30V22H17z M41.1,25L32,32.1L22.9,25H41.1z M20,39V26.6l12,9.3l12-9.3V39H20z"
});
function Ur(e) {
  var t = Object.entries(e).filter(function(n) {
    var r = n[1];
    return r != null;
  }).map(function(n) {
    var r = n[0], i = n[1];
    return "".concat(encodeURIComponent(r), "=").concat(encodeURIComponent(String(i)));
  });
  return t.length > 0 ? "?".concat(t.join("&")) : "";
}
var bc = /* @__PURE__ */ function() {
  var e = function(t, n) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, i) {
      r.__proto__ = i;
    } || function(r, i) {
      for (var a in i) Object.prototype.hasOwnProperty.call(i, a) && (r[a] = i[a]);
    }, e(t, n);
  };
  return function(t, n) {
    if (typeof n != "function" && n !== null)
      throw new TypeError("Class extends value " + String(n) + " is not a constructor or null");
    e(t, n);
    function r() {
      this.constructor = t;
    }
    t.prototype = n === null ? Object.create(n) : (r.prototype = n.prototype, new r());
  };
}(), qt = function() {
  return qt = Object.assign || function(e) {
    for (var t, n = 1, r = arguments.length; n < r; n++) {
      t = arguments[n];
      for (var i in t) Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
    }
    return e;
  }, qt.apply(this, arguments);
}, wc = function(e, t, n, r) {
  function i(a) {
    return a instanceof n ? a : new n(function(d) {
      d(a);
    });
  }
  return new (n || (n = Promise))(function(a, d) {
    function h(b) {
      try {
        p(r.next(b));
      } catch (S) {
        d(S);
      }
    }
    function m(b) {
      try {
        p(r.throw(b));
      } catch (S) {
        d(S);
      }
    }
    function p(b) {
      b.done ? a(b.value) : i(b.value).then(h, m);
    }
    p((r = r.apply(e, t || [])).next());
  });
}, Sc = function(e, t) {
  var n = { label: 0, sent: function() {
    if (a[0] & 1) throw a[1];
    return a[1];
  }, trys: [], ops: [] }, r, i, a, d;
  return d = { next: h(0), throw: h(1), return: h(2) }, typeof Symbol == "function" && (d[Symbol.iterator] = function() {
    return this;
  }), d;
  function h(p) {
    return function(b) {
      return m([p, b]);
    };
  }
  function m(p) {
    if (r) throw new TypeError("Generator is already executing.");
    for (; n; ) try {
      if (r = 1, i && (a = p[0] & 2 ? i.return : p[0] ? i.throw || ((a = i.return) && a.call(i), 0) : i.next) && !(a = a.call(i, p[1])).done) return a;
      switch (i = 0, a && (p = [p[0] & 2, a.value]), p[0]) {
        case 0:
        case 1:
          a = p;
          break;
        case 4:
          return n.label++, { value: p[1], done: !1 };
        case 5:
          n.label++, i = p[1], p = [0];
          continue;
        case 7:
          p = n.ops.pop(), n.trys.pop();
          continue;
        default:
          if (a = n.trys, !(a = a.length > 0 && a[a.length - 1]) && (p[0] === 6 || p[0] === 2)) {
            n = 0;
            continue;
          }
          if (p[0] === 3 && (!a || p[1] > a[0] && p[1] < a[3])) {
            n.label = p[1];
            break;
          }
          if (p[0] === 6 && n.label < a[1]) {
            n.label = a[1], a = p;
            break;
          }
          if (a && n.label < a[2]) {
            n.label = a[2], n.ops.push(p);
            break;
          }
          a[2] && n.ops.pop(), n.trys.pop();
          continue;
      }
      p = t.call(e, n);
    } catch (b) {
      p = [6, b], i = 0;
    } finally {
      r = a = 0;
    }
    if (p[0] & 5) throw p[1];
    return { value: p[0] ? p[1] : void 0, done: !0 };
  }
}, Us = function(e, t) {
  var n = {};
  for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var i = 0, r = Object.getOwnPropertySymbols(e); i < r.length; i++)
      t.indexOf(r[i]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[i]) && (n[r[i]] = e[r[i]]);
  return n;
}, kc = function(e) {
  return !!e && (typeof e == "object" || typeof e == "function") && typeof e.then == "function";
}, Tc = function(e, t) {
  return {
    left: window.outerWidth / 2 + (window.screenX || window.screenLeft || 0) - e / 2,
    top: window.outerHeight / 2 + (window.screenY || window.screenTop || 0) - t / 2
  };
}, _c = function(e, t) {
  return {
    top: (window.screen.height - t) / 2,
    left: (window.screen.width - e) / 2
  };
};
function Ec(e, t, n) {
  var r = t.height, i = t.width, a = Us(t, ["height", "width"]), d = qt({ height: r, width: i, location: "no", toolbar: "no", status: "no", directories: "no", menubar: "no", scrollbars: "yes", resizable: "no", centerscreen: "yes", chrome: "yes" }, a), h = window.open(e, "", Object.keys(d).map(function(p) {
    return "".concat(p, "=").concat(d[p]);
  }).join(", "));
  if (n)
    var m = window.setInterval(function() {
      try {
        (h === null || h.closed) && (window.clearInterval(m), n(h));
      } catch (p) {
        console.error(p);
      }
    }, 1e3);
  return h;
}
var Cc = (
  /** @class */
  function(e) {
    bc(t, e);
    function t() {
      var n = e !== null && e.apply(this, arguments) || this;
      return n.openShareDialog = function(r) {
        var i = n.props, a = i.onShareWindowClose, d = i.windowHeight, h = d === void 0 ? 400 : d, m = i.windowPosition, p = m === void 0 ? "windowCenter" : m, b = i.windowWidth, S = b === void 0 ? 550 : b, E = qt({ height: h, width: S }, p === "windowCenter" ? Tc(S, h) : _c(S, h));
        Ec(r, E, a);
      }, n.handleClick = function(r) {
        return wc(n, void 0, void 0, function() {
          var i, a, d, h, m, p, b, S, E, P;
          return Sc(this, function(A) {
            switch (A.label) {
              case 0:
                return i = this.props, a = i.beforeOnClick, d = i.disabled, h = i.networkLink, m = i.onClick, p = i.url, b = i.openShareDialogOnClick, S = i.opts, E = h(p, S), d ? [
                  2
                  /*return*/
                ] : (r.preventDefault(), a ? (P = a(), kc(P) ? [4, P] : [3, 2]) : [3, 2]);
              case 1:
                A.sent(), A.label = 2;
              case 2:
                return b && this.openShareDialog(E), m && m(r, E), [
                  2
                  /*return*/
                ];
            }
          });
        });
      }, n;
    }
    return t.prototype.render = function() {
      var n = this.props;
      n.beforeOnClick;
      var r = n.children, i = n.className, a = n.disabled, d = n.disabledStyle, h = n.forwardedRef;
      n.networkLink;
      var m = n.networkName;
      n.onShareWindowClose, n.openShareDialogOnClick, n.opts;
      var p = n.resetButtonStyle, b = n.style;
      n.url, n.windowHeight, n.windowPosition, n.windowWidth;
      var S = Us(n, ["beforeOnClick", "children", "className", "disabled", "disabledStyle", "forwardedRef", "networkLink", "networkName", "onShareWindowClose", "openShareDialogOnClick", "opts", "resetButtonStyle", "style", "url", "windowHeight", "windowPosition", "windowWidth"]), E = ve("react-share__ShareButton", {
        "react-share__ShareButton--disabled": !!a,
        disabled: !!a
      }, i), P = qt(qt(p ? { backgroundColor: "transparent", border: "none", padding: 0, font: "inherit", color: "inherit", cursor: "pointer" } : {}, b), a && d);
      return He.createElement("button", qt({}, S, { "aria-label": S["aria-label"] || m, className: E, onClick: this.handleClick, ref: h, style: P }), r);
    }, t.defaultProps = {
      disabledStyle: { opacity: 0.6 },
      openShareDialogOnClick: !0,
      resetButtonStyle: !0
    }, t;
  }(Ia)
), zr = function() {
  return zr = Object.assign || function(e) {
    for (var t, n = 1, r = arguments.length; n < r; n++) {
      t = arguments[n];
      for (var i in t) Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
    }
    return e;
  }, zr.apply(this, arguments);
};
function qr(e, t, n, r) {
  function i(a, d) {
    var h = n(a), m = zr({}, a), p = Object.keys(h);
    return p.forEach(function(b) {
      delete m[b];
    }), He.createElement(Cc, zr({}, r, m, { forwardedRef: d, networkName: e, networkLink: t, opts: n(a) }));
  }
  return i.displayName = "ShareButton-".concat(e), zi(i);
}
function Rc(e, t) {
  var n = t.subject, r = t.body, i = t.separator;
  return "mailto:" + Ur({ subject: n, body: r ? r + i + e : e });
}
var Ac = qr("email", Rc, function(e) {
  return {
    subject: e.subject,
    body: e.body,
    separator: e.separator || " "
  };
}, {
  openShareDialogOnClick: !1,
  onClick: function(e, t) {
    window.location.href = t;
  }
}), es = Wr({
  color: "#3b5998",
  path: "M34.1,47V33.3h4.6l0.7-5.3h-5.3v-3.4c0-1.5,0.4-2.6,2.6-2.6l2.8,0v-4.8c-0.5-0.1-2.2-0.2-4.1-0.2 c-4.1,0-6.9,2.5-6.9,7V28H24v5.3h4.6V47H34.1z"
}), Oc = /* @__PURE__ */ function() {
  var e = function(t, n) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, i) {
      r.__proto__ = i;
    } || function(r, i) {
      for (var a in i) Object.prototype.hasOwnProperty.call(i, a) && (r[a] = i[a]);
    }, e(t, n);
  };
  return function(t, n) {
    if (typeof n != "function" && n !== null)
      throw new TypeError("Class extends value " + String(n) + " is not a constructor or null");
    e(t, n);
    function r() {
      this.constructor = t;
    }
    t.prototype = n === null ? Object.create(n) : (r.prototype = n.prototype, new r());
  };
}(), jc = (
  /** @class */
  function(e) {
    Oc(t, e);
    function t(n) {
      var r = e.call(this, n) || this;
      return r.name = "AssertionError", r;
    }
    return t;
  }(Error)
);
function nr(e, t) {
  if (!e)
    throw new jc(t);
}
function Nc(e, t) {
  var n = t.quote, r = t.hashtag;
  return nr(e, "facebook.url"), "https://www.facebook.com/sharer/sharer.php" + Ur({
    u: e,
    quote: n,
    hashtag: r
  });
}
var ts = qr("facebook", Nc, function(e) {
  return {
    quote: e.quote,
    hashtag: e.hashtag
  };
}, {
  windowWidth: 550,
  windowHeight: 400
}), ns = Wr({
  color: "#007fb1",
  path: "M20.4,44h5.4V26.6h-5.4V44z M23.1,18c-1.7,0-3.1,1.4-3.1,3.1c0,1.7,1.4,3.1,3.1,3.1 c1.7,0,3.1-1.4,3.1-3.1C26.2,19.4,24.8,18,23.1,18z M39.5,26.2c-2.6,0-4.4,1.4-5.1,2.8h-0.1v-2.4h-5.2V44h5.4v-8.6 c0-2.3,0.4-4.5,3.2-4.5c2.8,0,2.8,2.6,2.8,4.6V44H46v-9.5C46,29.8,45,26.2,39.5,26.2z"
});
function Ic(e, t) {
  var n = t.title, r = t.summary, i = t.source;
  return nr(e, "linkedin.url"), "https://linkedin.com/shareArticle" + Ur({ url: e, mini: "true", title: n, summary: r, source: i });
}
var rs = qr("linkedin", Ic, function(e) {
  var t = e.title, n = e.summary, r = e.source;
  return { title: t, summary: n, source: r };
}, {
  windowWidth: 750,
  windowHeight: 600
}), is = Wr({
  color: "#00aced",
  path: "M48,22.1c-1.2,0.5-2.4,0.9-3.8,1c1.4-0.8,2.4-2.1,2.9-3.6c-1.3,0.8-2.7,1.3-4.2,1.6 C41.7,19.8,40,19,38.2,19c-3.6,0-6.6,2.9-6.6,6.6c0,0.5,0.1,1,0.2,1.5c-5.5-0.3-10.3-2.9-13.5-6.9c-0.6,1-0.9,2.1-0.9,3.3 c0,2.3,1.2,4.3,2.9,5.5c-1.1,0-2.1-0.3-3-0.8c0,0,0,0.1,0,0.1c0,3.2,2.3,5.8,5.3,6.4c-0.6,0.1-1.1,0.2-1.7,0.2c-0.4,0-0.8,0-1.2-0.1 c0.8,2.6,3.3,4.5,6.1,4.6c-2.2,1.8-5.1,2.8-8.2,2.8c-0.5,0-1.1,0-1.6-0.1c2.9,1.9,6.4,2.9,10.1,2.9c12.1,0,18.7-10,18.7-18.7 c0-0.3,0-0.6,0-0.8C46,24.5,47.1,23.4,48,22.1z"
});
function Pc(e, t) {
  var n = t.title, r = t.via, i = t.hashtags, a = i === void 0 ? [] : i, d = t.related, h = d === void 0 ? [] : d;
  return nr(e, "twitter.url"), nr(Array.isArray(a), "twitter.hashtags is not an array"), nr(Array.isArray(h), "twitter.related is not an array"), "https://twitter.com/share" + Ur({
    url: e,
    text: n,
    via: r,
    hashtags: a.length > 0 ? a.join(",") : void 0,
    related: h.length > 0 ? h.join(",") : void 0
  });
}
var os = qr("twitter", Pc, function(e) {
  return {
    hashtags: e.hashtags,
    title: e.title,
    via: e.via,
    related: e.related
  };
}, {
  windowWidth: 550,
  windowHeight: 400
});
function Ci(e) {
  "@babel/helpers - typeof";
  return Ci = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Ci(e);
}
var Lc;
function Ri() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Lc;
  return t ? e.split(" ").map(function(n) {
    return t[n] || n;
  }).join(" ") : e;
}
var Mc = (typeof window > "u" ? "undefined" : Ci(window)) === "object" && window.Element || function() {
};
function Dc(e, t, n) {
  if (!(e[t] instanceof Mc))
    return new Error("Invalid prop `" + t + "` supplied to `" + n + "`. Expected prop to be an instance of Element. Validation failed.");
}
l.oneOfType([l.string, l.func, Dc, l.shape({
  current: l.any
})]);
var Ai = l.oneOfType([l.func, l.string, l.shape({
  $$typeof: l.symbol,
  render: l.func
}), l.arrayOf(l.oneOfType([l.func, l.string, l.shape({
  $$typeof: l.symbol,
  render: l.func
})]))]), Fc = ["className", "listClassName", "cssModule", "children", "tag", "listTag", "aria-label"];
function Oi() {
  return Oi = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Oi.apply(this, arguments);
}
function $c(e, t) {
  if (e == null) return {};
  var n = Bc(e, t), r, i;
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    for (i = 0; i < a.length; i++)
      r = a[i], !(t.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
  }
  return n;
}
function Bc(e, t) {
  if (e == null) return {};
  var n = {}, r = Object.keys(e), i, a;
  for (a = 0; a < r.length; a++)
    i = r[a], !(t.indexOf(i) >= 0) && (n[i] = e[i]);
  return n;
}
var zc = {
  /** Aria label */
  "aria-label": l.string,
  /** Pass children so this component can wrap them */
  children: l.node,
  /** Add custom class */
  className: l.string,
  /** Change existing className with a new className */
  cssModule: l.object,
  /** Add custom class to list tag */
  listClassName: l.string,
  /** Set a custom element for list tag */
  listTag: Ai,
  /** Set a custom element for this component */
  tag: Ai
};
function qs(e) {
  var t = e.className, n = e.listClassName, r = e.cssModule, i = e.children, a = e.tag, d = a === void 0 ? "nav" : a, h = e.listTag, m = h === void 0 ? "ol" : h, p = e["aria-label"], b = p === void 0 ? "breadcrumb" : p, S = $c(e, Fc), E = Ri(ve(t), r), P = Ri(ve("breadcrumb", n), r);
  return /* @__PURE__ */ He.createElement(d, Oi({}, S, {
    className: E,
    "aria-label": b
  }), /* @__PURE__ */ He.createElement(m, {
    className: P
  }, i));
}
qs.propTypes = zc;
var Hc = ["className", "cssModule", "active", "tag"];
function ji() {
  return ji = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, ji.apply(this, arguments);
}
function Vc(e, t) {
  if (e == null) return {};
  var n = Wc(e, t), r, i;
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    for (i = 0; i < a.length; i++)
      r = a[i], !(t.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
  }
  return n;
}
function Wc(e, t) {
  if (e == null) return {};
  var n = {}, r = Object.keys(e), i, a;
  for (a = 0; a < r.length; a++)
    i = r[a], !(t.indexOf(i) >= 0) && (n[i] = e[i]);
  return n;
}
var Uc = {
  /** Adds a visual "active" state to a Breadcrumb Item */
  active: l.bool,
  /** Add custom class to the element */
  className: l.string,
  /** Change existing className with a new className */
  cssModule: l.object,
  /** Set a custom element for this component */
  tag: Ai
};
function Ni(e) {
  var t = e.className, n = e.cssModule, r = e.active, i = e.tag, a = i === void 0 ? "li" : i, d = Vc(e, Hc), h = Ri(ve(t, r ? "active" : !1, "breadcrumb-item"), n);
  return /* @__PURE__ */ He.createElement(a, ji({}, d, {
    className: h,
    "aria-current": r ? "page" : void 0
  }));
}
Ni.propTypes = Uc;
const qc = Pt.div`
  &.news-container h2 {
    font-size: 48px;
  }

  &.event-container h2 {
    font-size: 40px;
  }

  &.news-container img,
  &.event-container img {
    width: 100%;
    max-width: fit-content;
  }

  &.wrapper-container h4 {
    margin-top: 0;
  }

  &.wrapper-container {
    max-width: 1300px;
    margin: 0 auto;
    padding: 0 10%;
  }

  &.event-container.wrapper-container {
    max-width: 1500px;
  }

  &.news-container {
    background: #fff;
  }

  ol.breadcrumb {
    padding: 0;
    margin: 0;
  }

  ol.breadcrumb > li {
    margin-bottom: 0;
  }

  .article-social-media {
    margin-bottom: 24px;
  }

  .react-share__ShareButton {
    margin-right: 12px;
  }

  i.news-date {
    display: inline-block;
    margin-bottom: 24px;
  }

  .highlight-gold {
    box-shadow:
      -0.15em 0 0 #ffc627,
      0.15em 0 0 #ffc627;
    background: #ffc627;
  }

  .author {
    display: inline-block;
    margin-top: 30px;
    margin-left: -7px;
    padding: 0 6px;
    font-size: 16px;
    font-weight: 600;
    line-height: 16px;
  }

  .icon-bg {
    display: inline-block;
    position: relative;
    padding: 1px 3.5px;
    background-color: maroon;
    margin-right: 4px;
    border-radius: 4px;
    color: white;
    font-size: 0.65rem;
  }

  .uds-button {
    margin-top: 17px;
    padding: 0;
  }

  .author-title {
    max-width: 250px;
    margin-top: 10px;
    margin-bottom: 11px;
    font-size: 16px;
  }

  .author-contact {
    margin-top: 4px;
    font-size: 14px;
    font-weight: 500;
  }

  ol.breadcrumb a {
    text-decoration: none;
  }

  i.fa-calendar,
  i.fa-map-marker-alt {
    font-size: 1.17rem;
    margin-right: 8px;
  }

  .event-author {
    font-size: 16px;
    font-weight: 600;
    line-height: 16px;
  }

  .event-author-title {
    margin-top: 4px;
  }

  .event-author-info {
    margin-top: 24px;
  }
`, Yc = Pt.div`
  border-top: 1px solid black;
  h4 {
    margin-top: 0;
  }
  .react-share__ShareButton {
    margin-right: 24px;
  }
`, Ys = ({
  type: e = "news",
  articleUrl: t,
  publicationDate: n,
  title: r,
  body: i,
  authorEmail: a,
  authorName: d,
  authorPhone: h,
  authorTitle: m,
  breadcrumbs: p,
  calendarUrl: b,
  eventLocation: S,
  eventTime: E,
  headerImageUrl: P,
  registrationUrl: A,
  zoomUrl: k
}) => {
  const N = ve("col", "col-12", {
    "col-lg-8": e === "event" && (A || k || b)
  }), j = () => A ? /* @__PURE__ */ f.jsx("div", { className: "card-button uds-button", children: /* @__PURE__ */ f.jsx(an, { color: "maroon", href: A, label: "Register" }) }) : /* @__PURE__ */ f.jsx("div", { className: "card-button uds-button", children: /* @__PURE__ */ f.jsx(an, { color: "maroon", href: k, label: "Attend on Zoom" }) }), D = () => /* @__PURE__ */ f.jsx("div", { className: "row pb-2", "data-testid": "author-info", children: /* @__PURE__ */ f.jsxs("div", { className: "col col-12", children: [
    /* @__PURE__ */ f.jsx("div", { className: "author highlight-gold", children: d }),
    m && /* @__PURE__ */ f.jsx("div", { className: "author-title", children: m }),
    a && /* @__PURE__ */ f.jsxs("div", { className: "author-contact", children: [
      /* @__PURE__ */ f.jsx("span", { className: "icon-bg", children: /* @__PURE__ */ f.jsx("i", { className: "fas fa-envelope" }) }),
      /* @__PURE__ */ f.jsx("a", { href: `mailto: ${a}`, children: a })
    ] }),
    h && /* @__PURE__ */ f.jsxs("div", { className: "author-contact", children: [
      /* @__PURE__ */ f.jsx("span", { className: "icon-bg", children: /* @__PURE__ */ f.jsx("i", { className: "fas fa-phone" }) }),
      /* @__PURE__ */ f.jsx("a", { href: `tel: ${h}`, children: h })
    ] })
  ] }) }), V = () => /* @__PURE__ */ f.jsxs(
    Yc,
    {
      className: "row row-spaced mt-3 pt-6 pb-2 event-info",
      "data-testid": "event-info",
      children: [
        /* @__PURE__ */ f.jsxs("div", { className: "col col-lg-4 col-md-6 col-12", children: [
          /* @__PURE__ */ f.jsx("h4", { children: "For more information contact:" }),
          /* @__PURE__ */ f.jsx("div", { className: "event-author", children: d }),
          /* @__PURE__ */ f.jsx("div", { className: "event-author-title", children: m }),
          (a || h) && /* @__PURE__ */ f.jsxs("div", { className: "event-author-info", children: [
            a && /* @__PURE__ */ f.jsx("div", { children: /* @__PURE__ */ f.jsx("a", { href: `mailto: ${a}`, children: a }) }),
            h && /* @__PURE__ */ f.jsx("div", { children: /* @__PURE__ */ f.jsx("a", { href: `tel: ${h}`, children: h }) })
          ] })
        ] }),
        /* @__PURE__ */ f.jsxs("div", { className: "col col-lg-4 col-md-6 col-12", children: [
          /* @__PURE__ */ f.jsx("h4", { children: "Share this event:" }),
          /* @__PURE__ */ f.jsxs("div", { className: "article-social-media", children: [
            /* @__PURE__ */ f.jsx(ts, { url: t, quote: r, children: /* @__PURE__ */ f.jsx(
              es,
              {
                size: 28,
                borderRadius: 4,
                bgStyle: { fill: "maroon" }
              }
            ) }),
            /* @__PURE__ */ f.jsx(os, { url: t, quote: r, children: /* @__PURE__ */ f.jsx(
              is,
              {
                size: 28,
                borderRadius: 4,
                bgStyle: { fill: "maroon" }
              }
            ) }),
            /* @__PURE__ */ f.jsx(Ac, { url: a, quote: r, children: /* @__PURE__ */ f.jsx(
              xc,
              {
                size: 28,
                borderRadius: 4,
                bgStyle: { fill: "maroon" }
              }
            ) }),
            /* @__PURE__ */ f.jsx(rs, { url: t, quote: r, children: /* @__PURE__ */ f.jsx(
              ns,
              {
                size: 28,
                borderRadius: 4,
                bgStyle: { fill: "maroon" }
              }
            ) })
          ] })
        ] })
      ]
    }
  ), W = () => /* @__PURE__ */ f.jsxs("div", { className: "col col-12 col-lg-4 col-md-6", children: [
    /* @__PURE__ */ f.jsxs("h4", { children: [
      /* @__PURE__ */ f.jsx("i", { className: "fas fa-map-marker-alt" }),
      "Location:"
    ] }),
    /* @__PURE__ */ f.jsx("div", { dangerouslySetInnerHTML: lt(S) }),
    A && k && /* @__PURE__ */ f.jsx("a", { href: k, children: "Attend on Zoom" })
  ] }), M = (Z) => /* @__PURE__ */ f.jsx(
    Ni,
    {
      active: Z.active,
      tag: "li",
      className: "breadcrumb-item",
      children: /* @__PURE__ */ f.jsx(Ni, { tag: "a", href: Z.url, children: Z.title })
    },
    Z.title
  );
  return /* @__PURE__ */ f.jsxs(f.Fragment, { children: [
    P && e !== "event" && /* @__PURE__ */ f.jsx(
      "div",
      {
        "data-testid": "uds-hero",
        className: "uds-hero uds-hero-md",
        style: {
          // @ts-ignore
          "--color1": "#19191900",
          "--color2": "#191919c9",
          // moved colors to variable because hex color in linear-gradient breaks react
          backgroundImage: `linear-gradient(180deg, var(--color1) 0%, var(--color2) 100%), url(${P})`
        }
      }
    ),
    /* @__PURE__ */ f.jsxs(qc, { className: `container ${e}-container wrapper-container`, children: [
      p && /* @__PURE__ */ f.jsx("div", { className: "row pt-4", "data-testid": "breadcrumbs", children: /* @__PURE__ */ f.jsx("div", { className: "col col-12", children: /* @__PURE__ */ f.jsx(qs, { listClassName: "breadcrumb", children: p.map((Z) => M(Z)) }) }) }),
      /* @__PURE__ */ f.jsxs("div", { className: "row pb-2 pt-3", children: [
        /* @__PURE__ */ f.jsx("div", { className: N, children: /* @__PURE__ */ f.jsx("h2", { "data-testid": "title", children: r }) }),
        e === "event" && /* @__PURE__ */ f.jsxs("div", { className: "col col-lg-4 col-xs-12", children: [
          (A || k) && j(),
          b && /* @__PURE__ */ f.jsx("div", { className: "card-button uds-button", children: /* @__PURE__ */ f.jsx(
            an,
            {
              color: "gray",
              size: "small",
              href: b,
              label: "Add to calendar"
            }
          ) })
        ] })
      ] }),
      e === "event" ? /* @__PURE__ */ f.jsxs("div", { className: "row row-spaced pt-3 mb-2", children: [
        E && /* @__PURE__ */ f.jsxs("div", { className: "col col-lg-4 col-md-6 col-sm-12", children: [
          /* @__PURE__ */ f.jsxs("h4", { children: [
            /* @__PURE__ */ f.jsx("i", { className: "far fa-calendar" }),
            "Date and time:"
          ] }),
          /* @__PURE__ */ f.jsx(
            "div",
            {
              dangerouslySetInnerHTML: lt(E)
            }
          )
        ] }),
        (A && k || S) && W()
      ] }) : /* @__PURE__ */ f.jsx("div", { className: "row row-spaced pt-2", children: /* @__PURE__ */ f.jsxs("div", { className: "col col-12", children: [
        /* @__PURE__ */ f.jsxs("div", { className: "article-social-media", children: [
          /* @__PURE__ */ f.jsx(ts, { url: t, quote: r, children: /* @__PURE__ */ f.jsx(
            es,
            {
              size: 28,
              borderRadius: 4,
              bgStyle: { fill: "maroon" }
            }
          ) }),
          /* @__PURE__ */ f.jsx(os, { url: t, quote: r, children: /* @__PURE__ */ f.jsx(
            is,
            {
              size: 28,
              borderRadius: 4,
              bgStyle: { fill: "maroon" }
            }
          ) }),
          /* @__PURE__ */ f.jsx(rs, { url: t, quote: r, children: /* @__PURE__ */ f.jsx(
            ns,
            {
              size: 28,
              borderRadius: 4,
              bgStyle: { fill: "maroon" }
            }
          ) })
        ] }),
        n && /* @__PURE__ */ f.jsx("i", { className: "news-date", children: n })
      ] }) }),
      /* @__PURE__ */ f.jsx("div", { className: "row", children: /* @__PURE__ */ f.jsx(
        "div",
        {
          className: "col col-12",
          dangerouslySetInnerHTML: lt(i),
          "data-testid": "body"
        }
      ) }),
      e === "news" && D(),
      e === "event" && V()
    ] })
  ] });
};
Ys.propTypes = {
  /**
   * Type of article
   */
  type: l.oneOf(["event", "news"]),
  /**
   * This is the relative or absolute url to the full-page article
   */
  articleUrl: l.string.isRequired,
  /**
   * Date for the article
   */
  publicationDate: l.string.isRequired,
  /**
   * Title
   */
  title: l.string.isRequired,
  /**
   * Body content for the article
   */
  body: l.string.isRequired,
  /**
   * Article author email
   */
  authorEmail: l.string,
  /**
   * Article author full name
   */
  authorName: l.string.isRequired,
  /**
   * Article author phone number
   */
  authorPhone: l.string,
  /**
   * Article author title
   */
  authorTitle: l.string,
  /**
   * Breadcrumbs array
   */
  breadcrumbs: l.arrayOf(
    l.shape({
      title: l.string,
      url: l.string,
      active: l.bool
    })
  ),
  /**
   * URL for an "add to calendar" button
   */
  calendarUrl: l.string,
  /**
   * Article image
   */
  headerImageUrl: l.string,
  /**
   * Event location
   */
  eventLocation: l.string,
  /**
   * Event time
   */
  eventTime: l.string,
  /**
   * URL for a registation button
   */
  registrationUrl: l.string,
  /**
   * URL for a Zoom button
   */
  zoomUrl: l.string
};
const Gc = {
  name: "onclick",
  event: "link",
  action: "click",
  type: "internal link",
  region: "main content"
}, Xi = ({
  color: e = "gray",
  icon: t = void 0,
  innerRef: n = void 0,
  onClick: r = void 0,
  size: i = "small",
  cardTitle: a = "",
  className: d,
  gaData: h,
  ...m
}) => {
  const p = () => {
    r == null || r();
  };
  return /* @__PURE__ */ f.jsx(
    Ze,
    {
      gaData: {
        ...Gc,
        section: a,
        // @deprecated - remove at some point
        ...h,
        text: `${t == null ? void 0 : t[1]} icon`
      },
      children: /* @__PURE__ */ f.jsx(
        "button",
        {
          type: "button",
          className: `btn btn-circle btn-circle-alt-${e} ${i === "large" && "btn-circle-large"} ${d}`,
          ref: n,
          "aria-label": "Close",
          onClick: p,
          ...m,
          children: /* @__PURE__ */ f.jsx("i", { className: `${t == null ? void 0 : t[0]} fa-${t == null ? void 0 : t[1]}` })
        }
      )
    }
  );
};
Xi.propTypes = {
  /**
    Color the button based on the background color
  */
  color: l.oneOf(["white", "gray", "black"]),
  /**
    React Font Awesome icon prefix and name string to be rendered in button label. Ex: ['fab', 'drupal']
  */
  icon: l.arrayOf(l.string),
  /**
   * ref will only get you a reference to the Button component, use innerRef to
   * get a reference to the DOM element (for things like focus management).
   */
  innerRef: l.oneOfType([
    l.object,
    l.func,
    l.string
  ]),
  /**
    Event handler function for `<button>`
  */
  onClick: l.func,
  /**
   * @deprecated
   * Card title, use `gaData.section` instead
   */
  cardTitle: l.string,
  /**
   * Google Analytics event data
   */
  gaData: Wi,
  /**
    Button size
  */
  size: l.oneOf(["large", "small"]),
  className: l.string
};
const Xc = {
  name: "onclick",
  event: "link",
  action: "click",
  type: "internal link",
  region: "main content"
}, Ki = ({
  label: e = "",
  cardTitle: t = "",
  gaData: n,
  ariaLabel: r,
  color: i = "gray",
  disabled: a,
  element: d = "button",
  innerRef: h,
  href: m,
  onClick: p,
  ...b
}) => {
  const S = ve("btn", "btn-tag", {
    "btn-tag-alt-white": i === "white",
    "btn-tag-alt-gray": i === "gray",
    "btn-tag-alt-dark": i === "dark",
    disabled: a
  });
  let E = d;
  return m && d === "button" && (E = "a"), /* @__PURE__ */ f.jsx(
    Ze,
    {
      gaData: {
        ...Xc,
        section: t,
        // @deprecated - remove at some point
        ...n,
        text: e
      },
      children: /* @__PURE__ */ f.jsx(
        E,
        {
          type: E === "button" && p ? "button" : void 0,
          ...b,
          className: S,
          href: m,
          ref: h,
          onClick: p,
          "aria-label": r,
          children: e
        }
      )
    }
  );
};
Ki.propTypes = {
  /**
    Button tag label
  */
  label: l.string,
  /**
   * @deprecated
   * Card title, use `gaData.section` instead
   */
  cardTitle: l.string,
  /**
   * Google Analytics event data
   */
  gaData: Wi,
  /**
    ARIA label for accessibility
  */
  ariaLabel: l.string,
  /**
    Button background color
  */
  color: l.oneOf(["white", "gray", "dark"]),
  /**
    Disable the button?
  */
  disabled: l.bool,
  /**
    Pass in a Component to override default button element.
    For example: react-router Link
  */
  element: l.oneOfType([
    l.func,
    l.string,
    l.shape({ $$typeof: l.symbol, render: l.func }),
    l.arrayOf(
      l.oneOfType([
        l.func,
        l.string,
        l.shape({ $$typeof: l.symbol, render: l.func })
      ])
    )
  ]),
  /**
    Link target url; will cause button to be rendered as `<a>` link
  */
  href: l.string,
  /**
   * ref will only get you a reference to the Button component, use innerRef to
   * get a reference to the DOM element (for things like focus management).
   */
  innerRef: l.oneOfType([
    l.object,
    l.func,
    l.string
  ]),
  /**
    Event handler function for `<button>`
  */
  onClick: l.func
};
const En = ({
  src: e,
  alt: t,
  cssClasses: n,
  loading: r = "lazy",
  decoding: i = "async",
  dataTestId: a,
  fetchPriority: d = "auto",
  width: h,
  height: m,
  cardLink: p,
  title: b,
  caption: S,
  captionTitle: E,
  border: P,
  dropShadow: A
}) => {
  const k = {
    src: e,
    alt: t,
    loading: r,
    decoding: i,
    fetchpriority: d,
    // React attribute bug workaround
    ...(n == null ? void 0 : n.length) > 0 && { className: Or(n) },
    ...a && { "data-testid": a },
    ...h && { width: h },
    ...m && { height: m }
  }, N = ve("uds-img", {
    borderless: !P,
    "uds-img-drop-shadow": A
  }), j = (V) => {
    const W = V ? `${k.className} ${V}` : k.className;
    return p ? /* @__PURE__ */ f.jsxs("a", { href: p, children: [
      /* @__PURE__ */ f.jsx("img", { ...k, className: W }),
      /* @__PURE__ */ f.jsx("span", { className: "visually-hidden", children: b })
    ] }) : /* @__PURE__ */ f.jsx("img", { ...k, className: W });
  }, D = () => /* @__PURE__ */ f.jsx("div", { className: N, children: /* @__PURE__ */ f.jsxs("figure", { className: "figure uds-figure", children: [
    j(),
    S && /* @__PURE__ */ f.jsxs("figcaption", { className: "figure-caption uds-figure-caption", children: [
      E && /* @__PURE__ */ f.jsx("h3", { children: E }),
      /* @__PURE__ */ f.jsx(
        "span",
        {
          className: "uds-caption-text",
          dangerouslySetInnerHTML: lt(S)
        }
      )
    ] })
  ] }) });
  return /* @__PURE__ */ f.jsx(f.Fragment, { children: S ? D() : j(N) });
};
En.propTypes = {
  /**
   * Image source (We keep the same name as in the whole project)
   */
  src: l.string.isRequired,
  /**
   * Image alt text
   */
  alt: l.string.isRequired,
  /**
   * Array classes for the image
   */
  cssClasses: l.arrayOf(l.string),
  /**
   * Image loading mode
   */
  loading: l.oneOf(["lazy", "eager"]),
  /**
   * Image decoding mode
   */
  decoding: l.oneOf(["sync", "async", "auto"]),
  /**
   * Image fetch priority mode
   */
  fetchPriority: l.oneOf(["auto", "high", "low"]),
  /**
   * Width of the image
   */
  width: l.string,
  /**
   * Height of the image
   */
  height: l.string,
  dataTestId: l.string,
  cardLink: l.string,
  title: l.string,
  caption: l.string,
  captionTitle: l.string,
  border: l.bool,
  dropShadow: l.bool
};
const Kc = Pt.div`
  &.cards-components a + &.cards-components a {
    margin-left: 5px;
  }
  .card-button {
    column-gap: 1rem;
  }
  .card-button .btn {
    margin: 0;
  }
`, Zc = (e) => /^[A-Z0-9._+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(e), Jc = (e) => !e.startsWith("https://") && !e.startsWith("http://") && Zc(e) ? `mailto:${e}` : e, Qc = {
  name: "onclick",
  event: "link",
  action: "click",
  type: "internal link",
  region: "main content"
}, Yt = ({
  type: e = "default",
  width: t = "100%",
  horizontal: n = !1,
  image: r,
  imageAltText: i,
  title: a,
  icon: d,
  body: h,
  eventFormat: m = "stack",
  eventLocation: p,
  eventTime: b,
  buttons: S,
  linkLabel: E,
  linkUrl: P,
  tags: A,
  showBorders: k = !0,
  cardLink: N
}) => /* @__PURE__ */ f.jsx(
  Gs,
  {
    type: e,
    width: t,
    horizontal: n,
    image: r,
    imageAltText: i,
    title: a,
    icon: d,
    body: h,
    eventFormat: m,
    eventLocation: p,
    eventTime: b,
    buttons: S,
    linkLabel: E,
    linkUrl: P,
    tags: A,
    showBorders: k,
    cardLink: N
  }
);
Yt.propTypes = {
  /**
   * Type of card
   */
  type: l.oneOf(["default", "degree", "event", "news", "story"]),
  /**
   * Width of card
   */
  width: l.oneOf(["25%", "50%", "75%", "100%"]),
  /**
   * Enable horizontal mode
   */
  horizontal: l.bool,
  /**
   * Card title
   */
  title: l.string.isRequired,
  /**
    React Font Awesome icon prefix and name string to be rendered in button label. Ex: ['fab', 'drupal']
  */
  icon: l.arrayOf(l.string),
  /**
   * Card body content
   */
  body: l.string,
  /**
   * Event info format
   */
  eventFormat: l.oneOf(["stack", "inline"]),
  /**
   * Location
   */
  eventLocation: l.string,
  /**
   * Event start time
   */
  eventTime: l.string,
  /**
   * Card header image
   */
  image: l.string,
  /**
   * Card header image alt text
   */
  imageAltText: l.string,
  /**
   * Buttons
   */
  buttons: l.arrayOf(
    l.shape({
      ariaLabel: l.string,
      color: l.oneOf(["gold", "maroon", "gray", "dark"]),
      icon: l.arrayOf(l.string),
      href: l.string,
      label: l.string,
      onClick: l.func,
      size: l.oneOf(["default", "small", "xsmall"]),
      target: l.oneOf(["_blank", "_self", "_top", "_parent"])
    })
  ),
  linkLabel: l.string,
  linkUrl: l.string,
  /**
   * Tags
   */
  tags: l.arrayOf(
    l.shape({
      ariaLabel: l.string,
      color: l.oneOf(["white", "gray", "dark"]),
      href: l.string,
      label: l.string,
      onClick: l.func
    })
  ),
  /**
   * Remove card borders
   */
  showBorders: l.bool,
  /**
   * Card link
   */
  cardLink: l.string
};
const Gs = ({
  type: e = "default",
  width: t = "100%",
  horizontal: n = !1,
  image: r = "",
  imageAltText: i = "",
  title: a,
  icon: d = void 0,
  body: h = "",
  eventFormat: m = "stack",
  eventLocation: p = "",
  eventTime: b = "",
  buttons: S = void 0,
  linkLabel: E = void 0,
  linkUrl: P = void 0,
  tags: A = void 0,
  showBorders: k = !0,
  cardLink: N
}) => {
  const j = ve("card", "cards-components", {
    "card-degree": e === "degree",
    "card-event": e === "event",
    "card-story": e === "story",
    [`w-${t.replace("%", "")}`]: t !== "100%",
    "card-horizontal": n,
    borderless: !k
  });
  return /* @__PURE__ */ f.jsx(f.Fragment, { children: /* @__PURE__ */ f.jsxs(Kc, { className: j, "data-testid": "card-container", children: [
    !!r && /* @__PURE__ */ f.jsx(
      En,
      {
        src: r,
        alt: i,
        dataTestId: "card-image",
        cssClasses: ["card-img-top"],
        cardLink: N,
        title: a
      }
    ),
    !r && d && /* @__PURE__ */ f.jsx(
      "i",
      {
        className: `${d == null ? void 0 : d[0]} fa-${d == null ? void 0 : d[1]} fa-2x card-icon-top`,
        "data-testid": "card-icon"
      }
    ),
    n ? /* @__PURE__ */ f.jsx("div", { className: "card-content-wrapper", children: /* @__PURE__ */ f.jsx(
      Ii,
      {
        type: e,
        body: h,
        eventFormat: m,
        eventLocation: p,
        eventTime: b,
        title: a,
        buttons: S,
        linkLabel: E,
        linkUrl: P,
        tags: A,
        cardLink: N
      }
    ) }) : /* @__PURE__ */ f.jsx(
      Ii,
      {
        type: e,
        body: h,
        eventFormat: m,
        eventLocation: p,
        eventTime: b,
        title: a,
        buttons: S,
        linkLabel: E,
        linkUrl: P,
        tags: A,
        cardLink: N
      }
    )
  ] }) });
};
Gs.propTypes = {
  type: l.oneOf(["default", "degree", "event", "news", "story"]),
  width: l.oneOf(["25%", "50%", "75%", "100%"]),
  horizontal: l.bool,
  title: l.string.isRequired,
  icon: l.arrayOf(l.string),
  // React Font Awesome icon prefix and name string to be rendered in button label. Ex: ['fab', 'drupal']
  body: l.string,
  eventFormat: l.oneOf(["stack", "inline"]),
  eventLocation: l.string,
  eventTime: l.string,
  image: l.string,
  imageAltText: l.string,
  buttons: l.arrayOf(
    l.shape({
      ariaLabel: l.string,
      color: l.oneOf(["gold", "maroon", "gray", "dark"]),
      icon: l.arrayOf(l.string),
      href: l.string,
      label: l.string,
      onClick: l.func,
      size: l.oneOf(["default", "small", "xsmall"]),
      target: l.oneOf(["_blank", "_self", "_top", "_parent"])
    })
  ),
  linkLabel: l.string,
  linkUrl: l.string,
  tags: l.arrayOf(
    l.shape({
      ariaLabel: l.string,
      color: l.oneOf(["white", "gray", "dark"]),
      href: l.string,
      label: l.string,
      onClick: l.func
    })
  ),
  showBorders: l.bool,
  cardLink: l.string
};
const Ii = ({
  type: e = "default",
  body: t = "",
  eventFormat: n = "stack",
  eventLocation: r = "",
  eventTime: i = "",
  title: a,
  buttons: d = void 0,
  linkLabel: h = void 0,
  linkUrl: m = void 0,
  tags: p = void 0,
  cardLink: b
}) => /* @__PURE__ */ f.jsxs(f.Fragment, { children: [
  !!a && /* @__PURE__ */ f.jsx("div", { className: "card-header", "data-testid": "card-title", children: /* @__PURE__ */ f.jsx("h3", { className: "card-title", children: b ? /* @__PURE__ */ f.jsx("a", { href: b, children: a }) : a }) }),
  !!t && /* @__PURE__ */ f.jsx("div", { className: "card-body", "data-testid": "card-body", children: /* @__PURE__ */ f.jsx("div", { dangerouslySetInnerHTML: lt(t) }) }),
  e === "event" && (i || r) && /* @__PURE__ */ f.jsx(
    Xs,
    {
      eventFormat: n,
      eventTime: i,
      eventLocation: r
    }
  ),
  d && /* @__PURE__ */ f.jsx("div", { className: "card-buttons", children: d.map((S) => /* @__PURE__ */ f.jsx(
    "div",
    {
      className: "card-button",
      "data-testid": "card-button",
      children: /* @__PURE__ */ f.jsx(
        an,
        {
          ariaLabel: S.ariaLabel,
          color: S.color,
          icon: S.icon,
          href: S.href,
          label: S.label,
          onClick: S.onClick,
          size: S.size,
          target: S.target,
          cardTitle: a
        }
      )
    },
    `${S.label}-${S.href}`
  )) }),
  m && h && /* @__PURE__ */ f.jsx("div", { className: "card-link", "data-testid": "card-link", children: /* @__PURE__ */ f.jsx(
    Ze,
    {
      gaData: {
        ...Qc,
        section: a,
        text: h
      },
      children: /* @__PURE__ */ f.jsx("a", { href: Jc(m), children: h })
    }
  ) }),
  p && /* @__PURE__ */ f.jsx("div", { className: "card-tags", "data-testid": "card-tags", children: p.map((S) => (
    // @ts-ignore
    /* @__PURE__ */ f.jsx(
      Ki,
      {
        ariaLabel: S.ariaLabel,
        color: S.color,
        href: S.href,
        label: S.label,
        onClick: S.onClick,
        cardTitle: a
      },
      `${S.label}-${S.href}`
    )
  )) })
] });
Ii.propTypes = {
  type: l.oneOf(["default", "degree", "event", "news", "story"]),
  body: l.string,
  eventFormat: l.oneOf(["stack", "inline"]),
  eventLocation: l.string,
  eventTime: l.string,
  title: l.string.isRequired,
  buttons: l.arrayOf(
    l.shape({
      ariaLabel: l.string,
      color: l.oneOf(["gold", "maroon", "gray", "dark"]),
      icon: l.arrayOf(l.string),
      href: l.string,
      label: l.string,
      onClick: l.func,
      size: l.oneOf(["default", "small", "xsmall"]),
      target: l.oneOf(["_blank", "_self", "_top", "_parent"])
    })
  ),
  linkLabel: l.string,
  linkUrl: l.string,
  tags: l.arrayOf(
    l.shape({
      ariaLabel: l.string,
      color: l.oneOf(["white", "gray", "dark"]),
      href: l.string,
      label: l.string,
      onClick: l.func
    })
  ),
  cardLink: l.string
};
const Xs = ({
  eventFormat: e = "stack",
  eventLocation: t = "",
  eventTime: n = ""
}) => e === "inline" ? /* @__PURE__ */ f.jsxs("div", { className: "card-event-details", children: [
  n && /* @__PURE__ */ f.jsxs("div", { className: "card-event-icons", children: [
    /* @__PURE__ */ f.jsx("div", { children: /* @__PURE__ */ f.jsx("i", { className: "far fa-calendar" }) }),
    /* @__PURE__ */ f.jsx("div", { dangerouslySetInnerHTML: lt(n) })
  ] }),
  t && /* @__PURE__ */ f.jsxs("div", { className: "card-event-icons", children: [
    /* @__PURE__ */ f.jsx("div", { children: /* @__PURE__ */ f.jsx("i", { className: "fas fa-map-marker-alt" }) }),
    /* @__PURE__ */ f.jsx(
      "div",
      {
        dangerouslySetInnerHTML: lt(t)
      }
    )
  ] })
] }) : /* @__PURE__ */ f.jsxs(f.Fragment, { children: [
  n && /* @__PURE__ */ f.jsx("div", { className: "card-event-details", children: /* @__PURE__ */ f.jsxs("div", { className: "card-event-icons", children: [
    /* @__PURE__ */ f.jsx("div", { children: /* @__PURE__ */ f.jsx("i", { className: "far fa-calendar" }) }),
    /* @__PURE__ */ f.jsx("div", { dangerouslySetInnerHTML: lt(n) })
  ] }) }),
  t && /* @__PURE__ */ f.jsx("div", { className: "card-event-details", children: /* @__PURE__ */ f.jsxs("div", { className: "card-event-icons", children: [
    /* @__PURE__ */ f.jsx("div", { children: /* @__PURE__ */ f.jsx("i", { className: "fas fa-map-marker-alt" }) }),
    /* @__PURE__ */ f.jsx("span", { children: /* @__PURE__ */ f.jsx(
      "div",
      {
        dangerouslySetInnerHTML: lt(t)
      }
    ) })
  ] }) })
] });
Xs.propTypes = {
  eventFormat: l.oneOf(["stack", "inline"]),
  eventLocation: l.string,
  eventTime: l.string
};
const ss = {
  name: "onclick",
  event: "link",
  action: "click",
  type: "internal link",
  region: "main content"
}, as = {
  OPEN: "open",
  CLOSE: "close"
}, eu = {
  SMALL: "small"
}, Ks = (e) => e === eu.SMALL, Zs = ({ imageSize: e, body: t, heading: n, readMoreLink: r }) => {
  const [i, a] = Qe(!1), d = Bi(), { isReact: h, isBootstrap: m } = Cn(), p = `info-layer-${d}`, b = Ks(e), S = (E) => {
    (E.type === "click" || E.key === "Enter" || E.key === " ") && a(!i);
  };
  return /* @__PURE__ */ f.jsx(
    "div",
    {
      className: ve("info-layer", { show: i }),
      "data-testid": "info-layer",
      id: p,
      children: /* @__PURE__ */ f.jsxs("div", { className: "content", children: [
        /* @__PURE__ */ f.jsxs(
          "div",
          {
            className: ve("header", {
              closed: b && !i
            }),
            children: [
              b && /* @__PURE__ */ f.jsx("p", { dangerouslySetInnerHTML: lt(t) }),
              /* @__PURE__ */ f.jsx(
                Ze,
                {
                  gaData: {
                    ...ss,
                    text: "Expand ranking",
                    // TODO: for bootstrap can we use aria-expanded value of the button to populate the "action" field
                    action: i ? as.OPEN : as.CLOSE,
                    section: n
                  },
                  children: /* @__PURE__ */ f.jsxs(
                    "button",
                    {
                      "data-bs-toggle": m && "collapse",
                      "data-bs-target": m && `#${p}`,
                      onClick: h && S,
                      className: ve("btn-expand", {
                        btn: b
                      }),
                      type: "button",
                      "aria-expanded": i,
                      "aria-controls": p,
                      children: [
                        b ? /* @__PURE__ */ f.jsx("span", { className: "visually-hidden", children: n }) : /* @__PURE__ */ f.jsx("h4", { children: n }),
                        /* @__PURE__ */ f.jsx("i", { className: "fas fa-chevron-up" })
                      ]
                    }
                  )
                }
              )
            ]
          }
        ),
        !b && /* @__PURE__ */ f.jsx("p", { dangerouslySetInnerHTML: lt(t) }),
        r && /* @__PURE__ */ f.jsx(
          Ze,
          {
            gaData: {
              ...ss,
              section: n,
              text: "read more"
            },
            children: /* @__PURE__ */ f.jsxs("a", { href: r, className: "read-more", children: [
              "Read more ",
              /* @__PURE__ */ f.jsx("span", { className: "visually-hidden", children: n }),
              /* @__PURE__ */ f.jsx(
                "span",
                {
                  className: "fas icon-small fa-arrow-right",
                  "aria-hidden": "true"
                }
              )
            ] })
          }
        )
      ] })
    }
  );
};
Zs.propTypes = {
  imageSize: l.oneOf(["small", "large"]),
  body: l.string.isRequired,
  heading: l.string.isRequired,
  readMoreLink: l.string
};
const Zi = ({
  imageSize: e = "large",
  image: t,
  imageAlt: n,
  heading: r,
  body: i,
  readMoreLink: a = "",
  citation: d
}) => {
  const h = Ks(e);
  return /* @__PURE__ */ f.jsxs(
    "div",
    {
      className: ve("card-ranking", {
        "large-image": !h,
        "small-image": h
      }),
      children: [
        h ? /* @__PURE__ */ f.jsx("div", { className: "image-wrapper", children: /* @__PURE__ */ f.jsx(En, { src: t, alt: n, fetchPriority: "high" }) }) : /* @__PURE__ */ f.jsx(En, { src: t, alt: n, fetchPriority: "high" }),
        h && /* @__PURE__ */ f.jsxs("div", { className: "citation", children: [
          /* @__PURE__ */ f.jsx("h4", { children: r }),
          /* @__PURE__ */ f.jsxs("p", { children: [
            "— ",
            d
          ] })
        ] }),
        /* @__PURE__ */ f.jsx(
          Zs,
          {
            imageSize: e,
            body: i,
            heading: r,
            readMoreLink: a
          }
        )
      ]
    }
  );
};
Zi.propTypes = {
  /**
   * Size of ranking card
   */
  imageSize: l.oneOf(["small", "large"]).isRequired,
  /**
   * Ranking card image
   */
  image: l.string.isRequired,
  /**
   * Card header image alt text
   */
  imageAlt: l.string.isRequired,
  /**
   * Ranking card heading
   */
  heading: l.string.isRequired,
  /**
   * Ranking card body content
   */
  body: l.string.isRequired,
  /**
   * Link for read more
   */
  readMoreLink: l.string,
  /**
   * Ranking card citation content (Required for small size only)
   */
  citation: l.string
};
const tu = {
  1: "col-12",
  2: "col-12 col-md-6",
  3: "col-12 col-md-6 col-lg-4",
  4: "col-12 col-md-6 col-lg-4 col-xl-3"
}, Js = ({ cards: e, cardType: t = "card", columns: n }) => {
  if (!e || e.length === 0)
    return null;
  let r;
  switch (t) {
    case "ranking":
      r = Zi;
      break;
    case "image":
      r = En;
      break;
    default:
      r = Yt;
      break;
  }
  const i = tu[n] || "col-12 col-md-auto";
  return /* @__PURE__ */ f.jsx("div", { className: "row", "data-testid": "card-arrangement", children: e.map((a, d) => /* @__PURE__ */ f.jsx(
    "div",
    {
      "data-testid": "uds-card-arrangement-content-container",
      className: `${a.horizontal ? "col-12 col-md-6" : i} mb-4`,
      children: /* @__PURE__ */ f.jsx(r, { ...a })
    },
    d
  )) });
};
Js.propTypes = {
  /**
   * Array of card objects to render. Each object should contain props for the
   * Card or RankingCard component. Cards will wrap naturally based on their
   * intrinsic min/max widths.
   */
  cards: l.arrayOf(l.object).isRequired,
  /**
   * Type of card to render - either "card" (default), "ranking", or "image"
   */
  cardType: l.oneOf(["card", "ranking", "image"]),
  /**
   * Number of columns to display.
   */
  columns: l.oneOf([1, 2, 3, 4, "1", "2", "3", "4"])
};
const nu = {
  name: "onclick",
  event: "link",
  action: "click",
  type: "internal link",
  region: "main content"
}, Qs = ({
  backgroundImage: e,
  icon: t,
  title: n,
  highlightText: r,
  description: i,
  button: a
}) => {
  const d = () => {
    if (!t) return null;
    let h = "";
    return Array.isArray(t) ? h = t.join(" ") : h = t.includes(" ") ? t : `fas fa-${t}`, /* @__PURE__ */ f.jsx("i", { className: h, "aria-hidden": "true" });
  };
  return /* @__PURE__ */ f.jsxs("div", { className: "content-spotlight", children: [
    /* @__PURE__ */ f.jsx("div", { className: "content-spotlight-image-container", children: /* @__PURE__ */ f.jsxs("div", { className: "content-spotlight-image-wrapper", children: [
      /* @__PURE__ */ f.jsx("div", { className: "content-spotlight-overlay" }),
      /* @__PURE__ */ f.jsx(
        "img",
        {
          src: e,
          alt: "",
          "aria-hidden": "true",
          className: "content-spotlight-image"
        }
      )
    ] }) }),
    /* @__PURE__ */ f.jsxs("div", { className: "content-spotlight-content", children: [
      t && /* @__PURE__ */ f.jsx("div", { className: "content-spotlight-icon", children: d() }),
      /* @__PURE__ */ f.jsxs("h2", { className: "content-spotlight-title", children: [
        n,
        r && /* @__PURE__ */ f.jsxs(f.Fragment, { children: [
          n && r && /* @__PURE__ */ f.jsx("br", {}),
          /* @__PURE__ */ f.jsx("span", { className: "highlight", children: r })
        ] })
      ] }),
      i && /* @__PURE__ */ f.jsx(
        "p",
        {
          className: "content-spotlight-description",
          dangerouslySetInnerHTML: lt(i)
        }
      ),
      a && /* @__PURE__ */ f.jsx(
        Ze,
        {
          gaData: {
            ...nu,
            text: a.label,
            component: "ContentSpotlight"
          },
          children: /* @__PURE__ */ f.jsx(
            "a",
            {
              href: a.href,
              className: `btn ${a.color ? `btn-${a.color}` : "btn-gold"}`,
              children: a.label
            }
          )
        }
      )
    ] })
  ] });
};
Qs.propTypes = {
  backgroundImage: l.string.isRequired,
  icon: l.oneOfType([
    l.string,
    l.arrayOf(l.string)
  ]),
  title: l.node.isRequired,
  highlightText: l.string,
  description: l.string,
  button: l.shape({
    label: l.string.isRequired,
    href: l.string.isRequired,
    color: l.string
  })
};
var ru = /* @__PURE__ */ ((e) => (e.COPY = "copy", e))(ru || {});
const iu = ({ type: e }) => e == "copy" ? /* @__PURE__ */ f.jsx("hr", { className: "copy-divider" }) : /* @__PURE__ */ f.jsx("hr", {}), ou = Pt.div`
  display: inline-block;
  position: relative;
  width: 80px;
  height: 80px;
  div {
    box-sizing: border-box;
    display: block;
    position: absolute;
    width: 30px;
    height: 30px;
    margin: 3px;
    border: 3px solid #1b1b1b;
    border-radius: 50%;
    animation: lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
    border-color: #1b1b1b transparent transparent transparent;
  }
  div:nth-child(1) {
    animation-delay: -0.45s;
  }
  div:nth-child(2) {
    animation-delay: -0.3s;
  }
  div:nth-child(3) {
    animation-delay: -0.15s;
  }
  @keyframes lds-ring {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`, su = () => /* @__PURE__ */ f.jsxs(ou, { children: [
  /* @__PURE__ */ f.jsx("div", {}),
  /* @__PURE__ */ f.jsx("div", {}),
  /* @__PURE__ */ f.jsx("div", {}),
  /* @__PURE__ */ f.jsx("div", {})
] }), au = Pt.section``, lu = Pa(null), cu = ({
  defaultProps: e,
  dataSource: t,
  noFeedText: n,
  renderHeader: r,
  renderBody: i,
  dataTransformer: a,
  dataFilter: d,
  maxItems: h
}) => {
  const [{ data: m, loading: p, error: b }, S] = za(), [E, P] = Qe([]), A = { ...e.dataSource, ...t };
  return at(() => {
    S(A == null ? void 0 : A.url);
  }, [A == null ? void 0 : A.url]), at(() => {
    const k = m == null ? void 0 : m.nodes.map(a), N = k == null ? void 0 : k.filter(
      (j) => d(j, t == null ? void 0 : t.filters)
    );
    P(h ? N == null ? void 0 : N.slice(0, h) : N);
  }, [m]), // Init the context to be used on its childrens
  /* @__PURE__ */ f.jsx(lu.Provider, { value: { feeds: E }, children: /* @__PURE__ */ f.jsxs(au, { children: [
    r,
    b ? /* @__PURE__ */ f.jsx("span", { children: "Error, try again!" }) : /* @__PURE__ */ f.jsxs(f.Fragment, { children: [
      p && !(E != null && E.length) && /* @__PURE__ */ f.jsx("div", { className: "text-center mt-4", children: /* @__PURE__ */ f.jsx(su, {}) }),
      E != null && E.length ? i : !p && /* @__PURE__ */ f.jsx("p", { className: "text-center", children: n })
    ] })
  ] }) });
};
cu.propTypes = {
  renderHeader: l.element,
  renderBody: l.element,
  maxItems: l.number,
  dataTransformer: l.func,
  dataFilter: l.func,
  noFeedText: l.string
};
const ea = l.shape({
  color: l.oneOf(["white", "dark"]),
  text: l.string
}), ta = l.shape({
  color: l.oneOf(["gold", "maroon", "gray", "dark"]),
  text: l.string
}), Hd = l.shape({
  color: l.oneOf(["gold", "maroon", "gray", "dark"]),
  text: l.string,
  size: l.string
}), uu = l.shape({
  url: l.string,
  filters: l.string
}), du = l.shape({
  header: ea,
  ctaButton: ta,
  dataSource: uu,
  maxItems: l.number
}), fu = Pt.div`
  @media screen and (min-width: 768px) {
    & {
      display: inline-flex;
      justify-content: flex-end;
    }
  }
`, pu = ({
  defaultProps: e,
  header: t,
  ctaButton: n
}) => {
  const r = { ...e.header, ...t }, i = { ...e.ctaButton, ...n }, a = r.tag || "h2", d = a !== "h2", h = `text-${r.color} ${d ? "h2" : ""}`.trim();
  return /* @__PURE__ */ f.jsxs(
    "div",
    {
      className: "row justify-content-between align-items-center pb-6",
      "data-testid": "feed-header",
      children: [
        /* @__PURE__ */ f.jsx("div", { className: "col-sm-12 col-md-9", children: /* @__PURE__ */ f.jsx(a, { className: h, children: r.text }) }),
        /* @__PURE__ */ f.jsx(fu, { className: "col-sm-12 col-md-3", children: /* @__PURE__ */ f.jsx(
          Ze,
          {
            gaData: {
              event: "link",
              action: "click",
              name: "onclick",
              type: "internal link",
              region: "main content",
              section: r.text,
              text: i.text
            },
            children: /* @__PURE__ */ f.jsx("a", { className: `btn btn-${i.color}`, href: i.url, children: i.text })
          }
        ) })
      ]
    }
  );
};
pu.propTypes = {
  defaultProps: du,
  header: ea,
  ctaButton: ta
};
const hu = ({ children: e }) => /* @__PURE__ */ f.jsx("div", { className: "row", "data-testid": "feed-body", children: /* @__PURE__ */ f.jsx("div", { className: "col", children: e }) });
hu.propTypes = {
  children: l.element
};
const mu = Pt.img`
  width: 100%;
`;
function gu({ image: e, title: t, contents: n }) {
  return console.log({ image: e, title: t, contents: n }), /* @__PURE__ */ f.jsx("div", { children: "TODO: to be implemented" });
}
function vu({
  image: e,
  subTitle: t,
  title: n,
  contents: r,
  contentsColor: i
}) {
  const a = {
    small: "uds-hero-sm",
    medium: "uds-hero-md",
    large: "uds-hero-lg",
    undefined: ""
  }, d = {
    gold: "highlight-gold",
    black: "highlight-black",
    white: "highlight-white",
    none: "text-white",
    undefined: ""
  }, h = {
    black: "text-dark",
    white: "text-white",
    undefined: ""
  };
  return /* @__PURE__ */ f.jsxs(
    "div",
    {
      className: ve("uds-hero", {
        [a[e == null ? void 0 : e.size]]: e == null ? void 0 : e.size
      }),
      children: [
        /* @__PURE__ */ f.jsx("div", { className: "hero-overlay" }),
        /* @__PURE__ */ f.jsx(
          mu,
          {
            className: "hero",
            src: e == null ? void 0 : e.url,
            alt: e == null ? void 0 : e.altText,
            "data-testid": "hero-image"
          }
        ),
        t && /* @__PURE__ */ f.jsx("div", { role: "doc-subtitle", "data-testid": "hero-subtitle", children: /* @__PURE__ */ f.jsx(
          "span",
          {
            className: ve({
              [h[t.color]]: t.color,
              [d[t.highlightColor]]: t.highlightColor
            }),
            children: t.text
          }
        ) }),
        n && /* @__PURE__ */ f.jsx("h1", { style: { maxWidth: n.maxWidth || "" }, "data-testid": "hero-title", children: /* @__PURE__ */ f.jsx(
          "span",
          {
            className: ve({
              [h[n.color]]: n.color,
              [d[n.highlightColor]]: n.highlightColor
            }),
            children: n.text
          }
        ) }),
        r && /* @__PURE__ */ f.jsx(
          "div",
          {
            "data-testid": "hero-content",
            className: ve("content", {
              [h[i]]: i
            }),
            children: r.map((m, p) => /* @__PURE__ */ f.jsx("p", { children: m.text }, `content-${p}`))
          }
        )
      ]
    }
  );
}
const na = (e) => {
  const t = e.type || "heading-hero";
  return {
    "heading-hero": () => vu(e),
    "story-hero": () => gu(e),
    undefined: () => (console.error(
      `the type '${t}' is not supported by the 'Hero' component.`
    ), null)
  }[t]();
};
na.propTypes = {
  type: l.oneOf(["heading-hero", "story-hero"]),
  image: hl,
  title: mi,
  subTitle: mi,
  contents: l.arrayOf(mi),
  contentsColor: l.string
};
const yu = ({
  title: e = "Highly ranked",
  description: t = "",
  ctaText: n = "",
  ctaUrl: r = "",
  ctaButtonColor: i = "dark",
  rankings: a = []
}) => /* @__PURE__ */ f.jsx("section", { className: "highly-ranked-section", children: /* @__PURE__ */ f.jsxs("div", { className: "container", children: [
  /* @__PURE__ */ f.jsx("div", { className: "row", children: /* @__PURE__ */ f.jsxs("div", { className: "col-12 col-lg-8", children: [
    e && /* @__PURE__ */ f.jsx("h2", { className: "highly-ranked-title", children: /* @__PURE__ */ f.jsx("span", { className: "highlight-gold", children: e }) }),
    t && /* @__PURE__ */ f.jsx(
      "p",
      {
        className: "highly-ranked-description",
        dangerouslySetInnerHTML: lt(t)
      }
    ),
    n && r && /* @__PURE__ */ f.jsx("div", { className: "highly-ranked-cta", children: /* @__PURE__ */ f.jsx(
      an,
      {
        label: n,
        href: r,
        color: i,
        size: "small",
        classes: []
      }
    ) })
  ] }) }),
  /* @__PURE__ */ f.jsx("div", { className: "row highly-ranked-grid", children: a.map((d, h) => /* @__PURE__ */ f.jsx("div", { className: "col-12 col-lg-6 mb-4", children: /* @__PURE__ */ f.jsxs("div", { className: "highly-ranked-card", children: [
    /* @__PURE__ */ f.jsx("div", { className: "ranking-value-container", children: /* @__PURE__ */ f.jsxs("h3", { className: "ranking-value", children: [
      /* @__PURE__ */ f.jsx(
        "span",
        {
          className: `ranking-value-main${d.headingLevel ? ` ${d.headingLevel}` : " h1"}`,
          children: d.value
        }
      ),
      d.title && /* @__PURE__ */ f.jsx("span", { className: "ranking-value-subsection", children: d.title })
    ] }) }),
    d.description && /* @__PURE__ */ f.jsx("div", { className: "ranking-content", children: /* @__PURE__ */ f.jsx(
      "p",
      {
        className: "ranking-description",
        dangerouslySetInnerHTML: lt(
          d.description
        )
      }
    ) })
  ] }) }, h)) })
] }) }), It = ({
  dataId: e,
  isClickeable: t = !1,
  disabled: n = !1,
  pageLinkIcon: r = !1,
  selectedPage: i = !1,
  onClick: a = () => {
  },
  ellipses: d,
  ariaLabel: h,
  children: m,
  ariaDisabled: p
}) => /* @__PURE__ */ f.jsx(
  "li",
  {
    className: ve("page-item", {
      disabled: n,
      active: i,
      elipses: d
    }),
    children: t ? /* @__PURE__ */ f.jsxs(
      "button",
      {
        type: "button",
        "aria-label": h,
        className: ve("page-link", {
          "page-link-icon": r
        }),
        onClick: a,
        "data-testid": e ? `pagination-${e}` : "page-link",
        "data-id": e,
        "aria-current": i ? "page" : null,
        "aria-disabled": p,
        children: [
          m,
          i && /* @__PURE__ */ f.jsx("span", { className: "visually-hidden", children: "(current)" })
        ]
      }
    ) : /* @__PURE__ */ f.jsx("span", { className: "page-link", "data-testid": "page-link", children: m })
  }
);
It.propTypes = {
  isClickeable: l.bool,
  disabled: l.bool,
  pageLinkIcon: l.bool,
  selectedPage: l.bool,
  dataId: l.string,
  onClick: l.func,
  children: l.node,
  ellipses: l.bool,
  ariaLabel: l.string,
  ariaDisabled: l.bool
};
const xu = {
  event: "select",
  action: "click",
  name: "onclick",
  type: "pagination",
  region: "main content"
}, ra = ({
  type: e,
  background: t,
  currentPage: n = 1,
  totalPages: r = 10,
  onChange: i
}) => {
  const [a, d] = Qe(null);
  at(() => {
    d(n);
  }, [n]);
  const h = (b) => {
    Ts({ ...xu, text: `page ${b}` });
  }, m = (b, S) => {
    const P = {
      first: 1,
      prev: a === 1 ? 1 : a - 1,
      next: a === r ? r : a + 1,
      last: r
    }[S] ?? S;
    d(P), h(P), i == null || i(b, P);
  }, p = () => {
    if (r < 5)
      return /* @__PURE__ */ f.jsx(f.Fragment, { children: Array.from({ length: r }, (N, j) => {
        const D = j + 1;
        return /* @__PURE__ */ f.jsx(
          It,
          {
            ariaLabel: `Page ${D} of ${r}`,
            isClickeable: !0,
            selectedPage: a === D,
            onClick: (V) => m(V, D),
            children: D
          },
          D
        );
      }) });
    const b = 2, S = Eo(
      a === r - 1,
      1,
      a === r ? 2 : 1
    ), E = Eo(
      a === 1,
      2,
      1
    ), P = Mo(
      a - S,
      a,
      r
    ), A = Mo(
      a,
      a + 1 + E,
      r
    ), k = [...P, ...A];
    return /* @__PURE__ */ f.jsxs(f.Fragment, { children: [
      k[0] !== 1 && /* @__PURE__ */ f.jsx(
        It,
        {
          ariaLabel: `Page 1 of ${r}`,
          isClickeable: !0,
          selectedPage: a === 1,
          onClick: (N) => m(N, "first"),
          children: "1"
        }
      ),
      a > r - b && /* @__PURE__ */ f.jsx(
        It,
        {
          isClickeable: !0,
          ariaLabel: `Page 2 of ${r}`,
          selectedPage: a === 2,
          onClick: (N) => m(N, 2),
          children: "2"
        }
      ),
      k[0] > 2 && /* @__PURE__ */ f.jsx(It, { ellipses: !0, children: "..." }),
      k.map((N) => /* @__PURE__ */ f.jsx(
        It,
        {
          ariaLabel: `Page ${N} of ${r}`,
          isClickeable: !0,
          selectedPage: a === N,
          onClick: (j) => m(j, N),
          children: N
        },
        N
      )),
      k[k.length - 1] < r - 1 && /* @__PURE__ */ f.jsx(It, { ellipses: !0, children: "..." }),
      a < b + 1 && /* @__PURE__ */ f.jsx(
        It,
        {
          isClickeable: !0,
          ariaLabel: `Page ${r - 1} of ${r}`,
          selectedPage: a === r - 1,
          onClick: (N) => m(N, r - 1),
          children: r - 1
        }
      ),
      k[k.length - 1] !== r && /* @__PURE__ */ f.jsx(
        It,
        {
          isClickeable: !0,
          ariaLabel: `Page ${r} of ${r}`,
          selectedPage: a === r,
          onClick: (N) => m(N, "last"),
          children: r
        }
      )
    ] });
  };
  return /* @__PURE__ */ f.jsx("nav", { "aria-label": "Pagination", "data-testid": "pagination", children: /* @__PURE__ */ f.jsxs(
    "ul",
    {
      className: ve(
        "pagination",
        "justify-content-center",
        "pt-2",
        "pb-2",
        {
          border: e === "bordered",
          "uds-bg-gray1": t === "gray1",
          "uds-bg-gray": t === "gray2",
          "uds-bg-dark": t === "gray7"
        }
      ),
      children: [
        /* @__PURE__ */ f.jsx(
          It,
          {
            dataId: "prev",
            isClickeable: !0,
            disabled: a === 1,
            pageLinkIcon: !0,
            onClick: (b) => m(b, "prev"),
            ariaDisabled: a === 1,
            ariaLabel: "Previous Page"
          }
        ),
        p(),
        /* @__PURE__ */ f.jsx(
          It,
          {
            dataId: "next",
            isClickeable: !0,
            ariaDisabled: a === r,
            disabled: a === r,
            pageLinkIcon: !0,
            onClick: (b) => m(b, "next"),
            ariaLabel: "Next Page"
          }
        )
      ]
    }
  ) });
};
ra.propTypes = {
  /**
   * Type of pagination
   */
  type: l.oneOf(["default", "bordered"]).isRequired,
  /**
   * Background of pagination
   */
  background: l.oneOf(["white", "gray1", "gray2", "gray7"]).isRequired,
  /**
   * Current page
   */
  currentPage: l.number,
  /**
   * Total number of pages
   */
  totalPages: l.number,
  /**
   * Callback fired when the page is changed
   */
  onChange: l.func.isRequired
};
var bu = /* @__PURE__ */ ((e) => (e.WARNING = "warning", e.INFO = "info", e.SUCCESS = "success", e.ERROR = "error", e))(bu || {});
const wu = ({
  type: e,
  dismissable: t,
  children: n
}) => {
  var p, b, S;
  const { isBootstrap: r, isReact: i } = Cn(), [a, d] = Qe(!0), h = () => d(!1), m = {
    warning: {
      iconTitle: "Warning",
      iconName: "bell",
      alertClass: "warning"
    },
    info: {
      iconTitle: "Information",
      iconName: "info-circle",
      alertClass: "info"
    },
    success: {
      iconTitle: "Success",
      iconName: "check-circle",
      alertClass: "success"
    },
    error: {
      iconTitle: "Error",
      iconName: "exclamation-triangle",
      alertClass: "danger"
    }
  };
  return a && /* @__PURE__ */ f.jsxs(
    "div",
    {
      className: ve("alert", {
        "alert-dismissable": t,
        [`alert-${(p = m[e]) == null ? void 0 : p.alertClass}`]: e
      }),
      role: "alert",
      children: [
        /* @__PURE__ */ f.jsx("div", { className: "alert-icon", children: /* @__PURE__ */ f.jsx(
          "span",
          {
            title: (b = m[e]) == null ? void 0 : b.iconTitle,
            className: `fa fa-icon fa-${(S = m[e]) == null ? void 0 : S.iconName}`
          }
        ) }),
        /* @__PURE__ */ f.jsx("div", { className: "alert-content", children: n }),
        t && /* @__PURE__ */ f.jsx("div", { className: "alert-close", children: /* @__PURE__ */ f.jsx(
          Xi,
          {
            icon: ["fas", "times"],
            onClick: i && h,
            "data-bs-dismiss": r && "alert"
          }
        ) })
      ]
    }
  );
}, Su = Pt.div`
  button {
    padding: 16px 0;
    border: none;
    outline: none;
  }
`, ia = ({ gaData: e, hidePrev: t, hideNext: n, slideNav: r }) => {
  const { isReact: i, isBootstrap: a } = Cn();
  return /* @__PURE__ */ f.jsxs(Su, { children: [
    (!t || a) && /* @__PURE__ */ f.jsx(Ze, { gaData: { ...e, text: "left chevron" }, children: /* @__PURE__ */ f.jsxs(
      "button",
      {
        className: "scroll-control-prev",
        type: "button",
        onClick: i && (() => r(-1)),
        tabIndex: -1,
        children: [
          /* @__PURE__ */ f.jsx("span", { className: "carousel-control-prev-icon", "aria-hidden": "true" }),
          /* @__PURE__ */ f.jsx("span", { className: "visually-hidden", children: "Previous" })
        ]
      }
    ) }),
    (!n || a) && /* @__PURE__ */ f.jsx(Ze, { gaData: { ...e, text: "right chevron" }, children: /* @__PURE__ */ f.jsxs(
      "button",
      {
        className: "scroll-control-next",
        type: "button",
        onClick: i && (() => r(1)),
        tabIndex: -1,
        children: [
          /* @__PURE__ */ f.jsx("span", { className: "carousel-control-next-icon", "aria-hidden": "true" }),
          /* @__PURE__ */ f.jsx("span", { className: "visually-hidden", children: "Next" })
        ]
      }
    ) })
  ] });
};
ia.propTypes = {
  gaData: l.object,
  hidePrev: l.bool,
  hideNext: l.bool,
  slideNav: l.func.isRequired
};
const oa = zi(function(t, n) {
  const {
    id: r,
    selected: i,
    title: a,
    selectTab: d,
    leftKeyPressed: h,
    rightKeyPressed: m,
    icon: p,
    gaData: b
  } = t, { isReact: S, isBootstrap: E } = Cn(), P = cn(null);
  La(n, () => ({
    focus() {
      P.current.focus();
    },
    scrollIntoView() {
      var j, D, V, W, M, Z, le;
      const k = ((j = P.current) == null ? void 0 : j.offsetWidth) / 2 + P.current.offsetLeft, N = ((V = (D = P.current) == null ? void 0 : D.offsetParent) == null ? void 0 : V.scrollLeft) + ((M = (W = P.current) == null ? void 0 : W.offsetParent) == null ? void 0 : M.offsetWidth) / 2;
      (le = (Z = P.current) == null ? void 0 : Z.offsetParent) == null || le.scrollBy({
        left: k - N
      });
    }
  }), []);
  const A = (k) => {
    k.keyCode === 37 ? (k.preventDefault(), h()) : k.keyCode === 39 && (k.preventDefault(), m());
  };
  return /* @__PURE__ */ f.jsx(Ze, { gaData: { ...b, text: a }, children: /* @__PURE__ */ f.jsxs(
    "a",
    {
      ref: P,
      className: `nav-item nav-link ${i ? "active" : ""}`,
      id: r,
      href: `#nav-${r}`,
      role: "tab",
      "aria-controls": `nav-${r}`,
      "aria-selected": i,
      "data-bs-toggle": E && "tab",
      onClick: S && ((k) => d(k, r, a)),
      onKeyDown: S && A,
      tabIndex: i ? "" : "-1",
      children: [
        a,
        " ",
        p && /* @__PURE__ */ f.jsx("i", { className: `${p == null ? void 0 : p[0]} fa-${p == null ? void 0 : p[1]} me-1` })
      ]
    }
  ) });
});
oa.propTypes = {
  gaData: l.object,
  id: l.string.isRequired,
  selected: l.bool.isRequired,
  title: l.string.isRequired,
  selectTab: l.func.isRequired,
  leftKeyPressed: l.func.isRequired,
  rightKeyPressed: l.func.isRequired,
  icon: l.arrayOf(l.string)
};
function ku() {
  const e = cn({}), t = In(
    (n) => (r) => {
      e.current[n] = r;
    },
    []
  );
  return [e, t];
}
const Tu = ({ id: e, bgColor: t, selected: n, children: r }) => {
  const { isBootstrap: i } = Cn();
  return n || i ? /* @__PURE__ */ f.jsx(
    "div",
    {
      className: `tab-pane fade show ${n ? "show active" : ""} ${t === "bg-dark" ? "text-white" : ""}`,
      id: `nav-${e}`,
      role: "tabpanel",
      "aria-labelledby": `nav-${e}-tab`,
      children: r
    }
  ) : null;
};
Tu.propTypes = {
  id: l.string.isRequired,
  bgColor: l.string,
  selected: l.bool,
  children: l.oneOfType([l.array, l.element])
};
const sa = ({
  initialTab: e = "",
  children: t,
  bgColor: n = "",
  onTabChange: r = (i) => {
  }
}) => {
  var Se, ye;
  const i = He.Children.toArray(t), a = cn(!1), [d, h] = Qe(
    e && e !== "null" ? e : ((ye = (Se = i[0]) == null ? void 0 : Se.props) == null ? void 0 : ye.id) || ""
  ), m = cn(null), [p, b] = ku(), [S, E] = Qe(0), [P, A] = Qe(), k = In(() => {
    var J, he;
    A(
      ((J = m.current) == null ? void 0 : J.scrollWidth) - ((he = m.current) == null ? void 0 : he.offsetWidth)
    );
  }, []), N = In(() => {
    var J;
    E((J = m.current) == null ? void 0 : J.scrollLeft);
  }, []), j = In(() => {
    bi(N, 150), wi(N, 150);
  }, [N]), D = In(() => {
    bi(k, 150), wi(k, 150);
  }, [k]);
  if (at(() => {
    const J = m.current;
    return J && (J.addEventListener("scroll", j), N()), () => {
      J && J.removeEventListener("scroll", j);
    };
  }, [P, j, N]), at(() => (window.addEventListener("resize", D), k(), () => {
    window.removeEventListener("resize", D);
  }), [D, k]), at(() => {
    p.current[d] && p.current[d].scrollIntoView();
  }, [d, p]), at(() => {
    a.current && e && e !== "null" && d !== e && h(e);
  }, [e, d]), at(() => {
    a.current = !0;
  }, []), i.length === 0)
    return null;
  const V = (J) => {
    var he;
    r(J), (he = p.current[J]) == null || he.focus(), h(J);
  }, W = {
    event: "select",
    action: "click",
    name: "onclick",
    type: "carousel",
    region: "main content",
    text: ""
  }, M = {
    event: "link",
    action: "click",
    name: "onclick",
    type: "internal link",
    text: ""
  }, Z = i.map((J) => He.cloneElement(J, {
    bgColor: n,
    selected: d === J.props.id
  })), le = (J) => {
    const he = m.current, Ie = he.scrollWidth - he.clientWidth;
    let Be = he.scrollLeft + 200 * J;
    Be = Math.max(0, Math.min(Ie, Be)), he.scrollTo({
      left: Be,
      behavior: "smooth"
    });
  }, je = (J, he, Ie) => {
    J.preventDefault(), V(he);
  }, $e = (J = !0) => {
    const he = i.length, Ie = J ? 1 : -1, dt = i.findIndex((ze) => ze.props.id === d), Be = i[(he + dt + Ie) % he].props.id;
    V(Be);
  };
  let Ue = "uds-tabbed-panels";
  return n === "bg-dark" && (Ue += " uds-tabbed-panels-dark"), /* @__PURE__ */ f.jsxs("div", { className: n, children: [
    /* @__PURE__ */ f.jsxs("nav", { className: Ue, children: [
      /* @__PURE__ */ f.jsx("div", { className: "nav nav-tabs", role: "tablist", ref: m, children: i.map((J, he) => /* @__PURE__ */ f.jsx(
        oa,
        {
          ref: b(J.props.id),
          id: J.props.id,
          title: J.props.title,
          selected: d === J.props.id,
          gaData: M,
          selectTab: je,
          leftKeyPressed: () => $e(!1),
          rightKeyPressed: () => $e(),
          icon: J.props.icon,
          index: he
        },
        J.props.id
      )) }),
      /* @__PURE__ */ f.jsx(
        ia,
        {
          hidePrev: S <= 0,
          hideNext: S >= P,
          gaData: W,
          slideNav: le
        }
      )
    ] }),
    /* @__PURE__ */ f.jsx(
      "div",
      {
        className: "tab-content",
        tabIndex: 0,
        role: "tabpanel",
        id: "nav-tabContent",
        children: Z
      }
    )
  ] });
};
sa.propTypes = {
  initialTab: l.string,
  children: l.arrayOf(l.element).isRequired,
  bgColor: l.string,
  onTabChange: l.func
};
const Ji = ({ imageSource: e, imageAltText: t, quote: n, itemStyle: r = {} }) => {
  var i, a;
  return /* @__PURE__ */ f.jsxs(
    "div",
    {
      className: `uds-blockquote uds-testimonial ${e ? "with-image" : ""} ${Or(r.containerCssClass)}`,
      children: [
        e && /* @__PURE__ */ f.jsx(
          En,
          {
            src: e,
            alt: t,
            dataTestId: "testimonial-image",
            fetchPriority: "high"
          }
        ),
        /* @__PURE__ */ f.jsx("svg", { role: "presentation", viewBox: "0 0 302.87 245.82", children: /* @__PURE__ */ f.jsx("path", { d: "M113.61,245.82H0V164.56q0-49.34,8.69-77.83T40.84,35.58Q64.29,12.95,100.67,0l22.24,46.9q-34,11.33-48.72,31.54T58.63,132.21h55Zm180,0H180V164.56q0-49.74,8.7-78T221,35.58Q244.65,12.95,280.63,0l22.24,46.9q-34,11.33-48.72,31.54t-15.57,53.77h55Z" }) }),
        /* @__PURE__ */ f.jsxs("blockquote", { style: { paddingLeft: 0 }, children: [
          n.title && /* @__PURE__ */ f.jsx("h3", { className: "text-center", "data-testid": "testimonial-title", children: /* @__PURE__ */ f.jsx("span", { className: Or(r.titleCssClass), children: n.title }) }),
          n.content && /* @__PURE__ */ f.jsx(
            "p",
            {
              className: Or(r.contentCssClass),
              "data-testid": "testimonial-content",
              children: n.content
            }
          ),
          (!!((i = n.cite) != null && i.name) || !!((a = n.cite) != null && a.description)) && /* @__PURE__ */ f.jsxs("div", { className: "citation", "data-testid": "testimonial-citation", children: [
            /* @__PURE__ */ f.jsx("cite", { className: "name", children: n.cite.name }),
            n.cite && /* @__PURE__ */ f.jsx("cite", { className: "description", children: n.cite.description })
          ] })
        ] })
      ]
    }
  );
};
Ji.propTypes = {
  quote: l.shape({
    title: l.string,
    content: l.string,
    cite: l.shape({
      name: l.string,
      description: l.string
    })
  }).isRequired,
  imageSource: l.string,
  imageAltText: l.string,
  itemStyle: l.shape({
    containerCssClass: l.arrayOf(l.string),
    titleCssClass: l.arrayOf(l.string),
    contentCssClass: l.arrayOf(l.string)
  })
};
let _u = 0;
const Eu = ({
  title: e,
  content: t,
  triggerElement: n
}) => {
  const [r] = Qe(`tooltip-${_u++}`), i = cn(null);
  return /* @__PURE__ */ f.jsxs("span", { className: "uds-tooltip-container", children: [
    He.cloneElement(n, {
      ref: i,
      "aria-describedby": r,
      tabindex: 0
    }),
    /* @__PURE__ */ f.jsxs("div", { role: "tooltip", className: "uds-tooltip-description", id: r, children: [
      e && /* @__PURE__ */ f.jsx("span", { className: "uds-tooltip-heading", children: e }),
      t
    ] })
  ] });
}, Cu = {
  name: "onclick",
  event: "link",
  action: "click",
  type: "internal link",
  region: "main content",
  text: "play button"
}, Ru = ({
  url: e = "",
  vttUrl: t,
  caption: n,
  title: r = "",
  className: i,
  controls: a = !0
}) => {
  const d = cn(null);
  return /* @__PURE__ */ f.jsxs(
    "div",
    {
      className: ve(`uds-video-container ${i}`, {
        "uds-video-with-caption": n
      }),
      children: [
        /* @__PURE__ */ f.jsx("div", { className: "uds-video-player", children: /* @__PURE__ */ f.jsx(Ze, { gaData: { ...Cu, section: r }, children: /* @__PURE__ */ f.jsxs(
          "video",
          {
            ref: d,
            title: r,
            playsInline: !0,
            controls: a || !0,
            children: [
              /* @__PURE__ */ f.jsx("source", { src: e }),
              /* @__PURE__ */ f.jsx(
                "track",
                {
                  src: t,
                  kind: "captions",
                  srcLang: "en",
                  label: "english_captions"
                }
              )
            ]
          }
        ) }) }),
        n && /* @__PURE__ */ f.jsx("figure", { "data-testid": "video-caption", children: /* @__PURE__ */ f.jsx("figcaption", { children: n }) })
      ]
    }
  );
}, Au = ({ title: e = "", caption: t, url: n = "", className: r }) => /* @__PURE__ */ f.jsxs(
  "div",
  {
    className: ve(`uds-video-container ${r}`, {
      "uds-video-with-caption": t
    }),
    children: [
      /* @__PURE__ */ f.jsx("div", { className: "uds-video-player youtube-video", children: /* @__PURE__ */ f.jsx("iframe", { title: e, src: n }) }),
      t && /* @__PURE__ */ f.jsx("figure", { "data-testid": "video-caption", children: /* @__PURE__ */ f.jsx("figcaption", { children: t }) })
    ]
  }
), aa = (e) => {
  const {
    type: t = "video",
    url: n = "",
    vttUrl: r,
    title: i = "",
    caption: a,
    className: d,
    controls: h = !0
  } = e;
  return t === "youtube" ? Au({ url: n, title: i, caption: a, className: d }) : Ru({
    url: n,
    vttUrl: r,
    title: i,
    caption: a,
    className: d,
    controls: h
  });
};
aa.propTypes = {
  type: l.oneOf(["video", "youtube"]),
  url: l.string,
  vttUrl: l.string,
  title: l.string,
  className: l.string,
  caption: l.string,
  controls: l.bool
};
const Ou = {
  event: "select",
  action: "click",
  name: "onclick",
  region: "main content",
  type: "pagination",
  text: "owl dot"
}, Qi = ({ children: e }) => /* @__PURE__ */ f.jsx(
  "div",
  {
    role: "group",
    className: "glide__bullets",
    "data-glide-el": "controls[nav]",
    "data-testid": "bullets-container",
    onClick: (t) => t.stopPropagation(),
    onKeyDown: (t) => t.stopPropagation(),
    children: e
  }
);
Qi.propTypes = {
  children: l.oneOfType([
    l.element,
    l.arrayOf(l.element)
  ]).isRequired
};
const la = ({ buttonCount: e }) => {
  const t = [];
  for (let n = 0; n < e; n += 1)
    t.push(
      /* @__PURE__ */ f.jsx(Ze, { gaData: Ou, children: /* @__PURE__ */ f.jsx(
        "button",
        {
          type: "button",
          className: "glide__bullet",
          "data-glide-dir": `=${n}`,
          "aria-label": `Slide view ${n + 1}`
        }
      ) }, `bullet-${n}`)
    );
  return /* @__PURE__ */ f.jsx(Qi, { children: t });
};
la.propTypes = {
  buttonCount: l.number.isRequired
};
const ca = ({ imageItems: e, onItemClick: t = () => null }) => {
  const n = (i, a) => {
    const { ariaSelected: d } = i.currentTarget.dataset;
    i.currentTarget.dataset.ariaSelected = String(!d), i.stopPropagation(), t(a);
  }, r = e.map((i, a) => /* @__PURE__ */ f.jsx(
    "button",
    {
      type: "button",
      role: "option",
      className: "bullet-image-container",
      "data-glide-dir": `=${a}`,
      "aria-label": `Slide view ${a + 1}`,
      "aria-selected": "false",
      onClick: (d) => n(d, a),
      onKeyDown: (d) => n(d, a),
      children: /* @__PURE__ */ f.jsx(
        "img",
        {
          src: i,
          alt: `Slide ${a + 1}`,
          className: "glide__bullet bullet-image",
          loading: "lazy",
          decoding: "async",
          fetchpriority: "low"
        }
      )
    },
    `bullet-${a}`
  ));
  return /* @__PURE__ */ f.jsx(Qi, { children: r });
};
ca.propTypes = {
  imageItems: l.arrayOf(l.string).isRequired,
  onItemClick: l.func
};
const eo = ({ onClick: e = () => null }) => /* @__PURE__ */ f.jsx(
  "button",
  {
    type: "button",
    className: "glide__arrow glide__arrow--next",
    "data-glide-dir": ">",
    "aria-label": "Next slide",
    onClick: e,
    children: /* @__PURE__ */ f.jsx("i", { className: "fas fa-chevron-right arrow-icon" })
  }
);
eo.propTypes = {
  onClick: l.func
};
const to = ({ onClick: e = () => null }) => /* @__PURE__ */ f.jsx(
  "button",
  {
    type: "button",
    className: "glide__arrow glide__arrow--prev",
    "data-glide-dir": "<",
    "aria-label": "Previous slide",
    onClick: e,
    children: /* @__PURE__ */ f.jsx("span", { className: "fas fa-chevron-left arrow-icon" })
  }
);
to.propTypes = {
  onClick: l.func
};
const ls = {
  event: "select",
  action: "click",
  name: "onclick",
  region: "main content",
  type: "carousel"
}, no = ({ children: e = null }) => /* @__PURE__ */ f.jsx(
  "div",
  {
    className: "glide__arrows",
    "data-glide-el": "controls",
    "data-testid": "arrows-container",
    children: e
  }
);
no.propTypes = {
  children: l.arrayOf(l.element)
};
const ua = ({ onClick: e = () => null, children: t = null }) => /* @__PURE__ */ f.jsxs(no, { children: [
  /* @__PURE__ */ f.jsx(Ze, { gaData: { ...ls, text: "left chevron" }, children: /* @__PURE__ */ f.jsx(to, { onClick: e }) }),
  t,
  /* @__PURE__ */ f.jsx(Ze, { gaData: { ...ls, text: "right chevron" }, children: /* @__PURE__ */ f.jsx(eo, { onClick: e }) })
] });
ua.propTypes = {
  children: l.element,
  onClick: l.func
};
const da = ({ carouselItems: e }) => {
  const t = e.map((n) => /* @__PURE__ */ f.jsx("li", { className: "glide__slide slider", children: n.item }, n.id.toString()));
  return /* @__PURE__ */ f.jsx("ul", { className: "glide__slides", children: t });
};
da.propTypes = {
  carouselItems: l.arrayOf(l.object)
};
function cs(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function us(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? cs(Object(n), !0).forEach(function(r) {
      Nu(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : cs(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function Lr(e) {
  "@babel/helpers - typeof";
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? Lr = function(t) {
    return typeof t;
  } : Lr = function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Lr(e);
}
function Yr(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function ju(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
  }
}
function Gr(e, t, n) {
  return t && ju(e.prototype, t), e;
}
function Nu(e, t, n) {
  return t in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}
function Iu(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, {
    constructor: {
      value: e,
      writable: !0,
      configurable: !0
    }
  }), t && Pi(e, t);
}
function Dn(e) {
  return Dn = Object.setPrototypeOf ? Object.getPrototypeOf : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, Dn(e);
}
function Pi(e, t) {
  return Pi = Object.setPrototypeOf || function(r, i) {
    return r.__proto__ = i, r;
  }, Pi(e, t);
}
function Pu() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
  if (typeof Proxy == "function") return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function Lu(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function Mu(e, t) {
  if (t && (typeof t == "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return Lu(e);
}
function Du(e) {
  var t = Pu();
  return function() {
    var r = Dn(e), i;
    if (t) {
      var a = Dn(this).constructor;
      i = Reflect.construct(r, arguments, a);
    } else
      i = r.apply(this, arguments);
    return Mu(this, i);
  };
}
function Fu(e, t) {
  for (; !Object.prototype.hasOwnProperty.call(e, t) && (e = Dn(e), e !== null); )
    ;
  return e;
}
function Mr() {
  return typeof Reflect < "u" && Reflect.get ? Mr = Reflect.get : Mr = function(t, n, r) {
    var i = Fu(t, n);
    if (i) {
      var a = Object.getOwnPropertyDescriptor(i, n);
      return a.get ? a.get.call(arguments.length < 3 ? t : r) : a.value;
    }
  }, Mr.apply(this, arguments);
}
var $u = {
  /**
   * Type of the movement.
   *
   * Available types:
   * `slider` - Rewinds slider to the start/end when it reaches the first or last slide.
   * `carousel` - Changes slides without starting over when it reaches the first or last slide.
   *
   * @type {String}
   */
  type: "slider",
  /**
   * Start at specific slide number defined with zero-based index.
   *
   * @type {Number}
   */
  startAt: 0,
  /**
   * A number of slides visible on the single viewport.
   *
   * @type {Number}
   */
  perView: 1,
  /**
   * Focus currently active slide at a specified position in the track.
   *
   * Available inputs:
   * `center` - Current slide will be always focused at the center of a track.
   * `0,1,2,3...` - Current slide will be focused on the specified zero-based index.
   *
   * @type {String|Number}
   */
  focusAt: 0,
  /**
   * A size of the gap added between slides.
   *
   * @type {Number}
   */
  gap: 10,
  /**
   * Change slides after a specified interval. Use `false` for turning off autoplay.
   *
   * @type {Number|Boolean}
   */
  autoplay: !1,
  /**
   * Stop autoplay on mouseover event.
   *
   * @type {Boolean}
   */
  hoverpause: !0,
  /**
   * Allow for changing slides with left and right keyboard arrows.
   *
   * @type {Boolean}
   */
  keyboard: !0,
  /**
   * Stop running `perView` number of slides from the end. Use this
   * option if you don't want to have an empty space after
   * a slider. Works only with `slider` type and a
   * non-centered `focusAt` setting.
   *
   * @type {Boolean}
   */
  bound: !1,
  /**
   * Minimal swipe distance needed to change the slide. Use `false` for turning off a swiping.
   *
   * @type {Number|Boolean}
   */
  swipeThreshold: 80,
  /**
   * Minimal mouse drag distance needed to change the slide. Use `false` for turning off a dragging.
   *
   * @type {Number|Boolean}
   */
  dragThreshold: 120,
  /**
   * A number of slides moved on single swipe.
   *
   * Available types:
   * `` - Moves slider by one slide per swipe
   * `|` - Moves slider between views per swipe (number of slides defined in `perView` options)
   *
   * @type {String}
   */
  perSwipe: "",
  /**
   * Moving distance ratio of the slides on a swiping and dragging.
   *
   * @type {Number}
   */
  touchRatio: 0.5,
  /**
   * Angle required to activate slides moving on swiping or dragging.
   *
   * @type {Number}
   */
  touchAngle: 45,
  /**
   * Duration of the animation in milliseconds.
   *
   * @type {Number}
   */
  animationDuration: 400,
  /**
   * Allows looping the `slider` type. Slider will rewind to the first/last slide when it's at the start/end.
   *
   * @type {Boolean}
   */
  rewind: !0,
  /**
   * Duration of the rewinding animation of the `slider` type in milliseconds.
   *
   * @type {Number}
   */
  rewindDuration: 800,
  /**
   * Easing function for the animation.
   *
   * @type {String}
   */
  animationTimingFunc: "cubic-bezier(.165, .840, .440, 1)",
  /**
   * Wait for the animation to finish until the next user input can be processed
   *
   * @type {boolean}
   */
  waitForTransition: !0,
  /**
   * Throttle costly events at most once per every wait milliseconds.
   *
   * @type {Number}
   */
  throttle: 10,
  /**
   * Moving direction mode.
   *
   * Available inputs:
   * - 'ltr' - left to right movement,
   * - 'rtl' - right to left movement.
   *
   * @type {String}
   */
  direction: "ltr",
  /**
   * The distance value of the next and previous viewports which
   * have to peek in the current view. Accepts number and
   * pixels as a string. Left and right peeking can be
   * set up separately with a directions object.
   *
   * For example:
   * `100` - Peek 100px on the both sides.
   * { before: 100, after: 50 }` - Peek 100px on the left side and 50px on the right side.
   *
   * @type {Number|String|Object}
   */
  peek: 0,
  /**
   * Defines how many clones of current viewport will be generated.
   *
   * @type {Number}
   */
  cloningRatio: 1,
  /**
   * Collection of options applied at specified media breakpoints.
   * For example: display two slides per view under 800px.
   * `{
   *   '800px': {
   *     perView: 2
   *   }
   * }`
   */
  breakpoints: {},
  /**
   * Collection of internally used HTML classes.
   *
   * @todo Refactor `slider` and `carousel` properties to single `type: { slider: '', carousel: '' }` object
   * @type {Object}
   */
  classes: {
    swipeable: "glide--swipeable",
    dragging: "glide--dragging",
    direction: {
      ltr: "glide--ltr",
      rtl: "glide--rtl"
    },
    type: {
      slider: "glide--slider",
      carousel: "glide--carousel"
    },
    slide: {
      clone: "glide__slide--clone",
      active: "glide__slide--active"
    },
    arrow: {
      disabled: "glide__arrow--disabled"
    },
    nav: {
      active: "glide__bullet--active"
    }
  }
};
function Xt(e) {
  console.error("[Glide warn]: ".concat(e));
}
function et(e) {
  return parseInt(e);
}
function Bu(e) {
  return parseFloat(e);
}
function Li(e) {
  return typeof e == "string";
}
function Fn(e) {
  var t = Lr(e);
  return t === "function" || t === "object" && !!e;
}
function Hr(e) {
  return typeof e == "function";
}
function fa(e) {
  return typeof e > "u";
}
function Mi(e) {
  return e.constructor === Array;
}
function zu(e, t, n) {
  var r = {};
  for (var i in t)
    Hr(t[i]) ? r[i] = t[i](e, r, n) : Xt("Extension must be a function");
  for (var a in r)
    Hr(r[a].mount) && r[a].mount();
  return r;
}
function Fe(e, t, n) {
  Object.defineProperty(e, t, n);
}
function Hu(e) {
  return Object.keys(e).sort().reduce(function(t, n) {
    return t[n] = e[n], t[n], t;
  }, {});
}
function Di(e, t) {
  var n = Object.assign({}, e, t);
  if (t.hasOwnProperty("classes")) {
    n.classes = Object.assign({}, e.classes, t.classes);
    var r = ["direction", "type", "slide", "arrow", "nav"];
    r.forEach(function(i) {
      t.classes.hasOwnProperty(i) && (n.classes[i] = us(us({}, e.classes[i]), t.classes[i]));
    });
  }
  return t.hasOwnProperty("breakpoints") && (n.breakpoints = Object.assign({}, e.breakpoints, t.breakpoints)), n;
}
var Vu = /* @__PURE__ */ function() {
  function e() {
    var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    Yr(this, e), this.events = t, this.hop = t.hasOwnProperty;
  }
  return Gr(e, [{
    key: "on",
    value: function(n, r) {
      if (Mi(n)) {
        for (var i = 0; i < n.length; i++)
          this.on(n[i], r);
        return;
      }
      this.hop.call(this.events, n) || (this.events[n] = []);
      var a = this.events[n].push(r) - 1;
      return {
        remove: function() {
          delete this.events[n][a];
        }
      };
    }
    /**
     * Runs registered handlers for specified event.
     *
     * @param {String|Array} event
     * @param {Object=} context
     */
  }, {
    key: "emit",
    value: function(n, r) {
      if (Mi(n)) {
        for (var i = 0; i < n.length; i++)
          this.emit(n[i], r);
        return;
      }
      this.hop.call(this.events, n) && this.events[n].forEach(function(a) {
        a(r || {});
      });
    }
  }]), e;
}(), Wu = /* @__PURE__ */ function() {
  function e(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    Yr(this, e), this._c = {}, this._t = [], this._e = new Vu(), this.disabled = !1, this.selector = t, this.settings = Di($u, n), this.index = this.settings.startAt;
  }
  return Gr(e, [{
    key: "mount",
    value: function() {
      var n = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
      return this._e.emit("mount.before"), Fn(n) ? this._c = zu(this, n, this._e) : Xt("You need to provide a object on `mount()`"), this._e.emit("mount.after"), this;
    }
    /**
     * Collects an instance `translate` transformers.
     *
     * @param  {Array} transformers Collection of transformers.
     * @return {Void}
     */
  }, {
    key: "mutate",
    value: function() {
      var n = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
      return Mi(n) ? this._t = n : Xt("You need to provide a array on `mutate()`"), this;
    }
    /**
     * Updates glide with specified settings.
     *
     * @param {Object} settings
     * @return {Glide}
     */
  }, {
    key: "update",
    value: function() {
      var n = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
      return this.settings = Di(this.settings, n), n.hasOwnProperty("startAt") && (this.index = n.startAt), this._e.emit("update"), this;
    }
    /**
     * Change slide with specified pattern. A pattern must be in the special format:
     * `>` - Move one forward
     * `<` - Move one backward
     * `={i}` - Go to {i} zero-based slide (eq. '=1', will go to second slide)
     * `>>` - Rewinds to end (last slide)
     * `<<` - Rewinds to start (first slide)
     * `|>` - Move one viewport forward
     * `|<` - Move one viewport backward
     *
     * @param {String} pattern
     * @return {Glide}
     */
  }, {
    key: "go",
    value: function(n) {
      return this._c.Run.make(n), this;
    }
    /**
     * Move track by specified distance.
     *
     * @param {String} distance
     * @return {Glide}
     */
  }, {
    key: "move",
    value: function(n) {
      return this._c.Transition.disable(), this._c.Move.make(n), this;
    }
    /**
     * Destroy instance and revert all changes done by this._c.
     *
     * @return {Glide}
     */
  }, {
    key: "destroy",
    value: function() {
      return this._e.emit("destroy"), this;
    }
    /**
     * Start instance autoplaying.
     *
     * @param {Boolean|Number} interval Run autoplaying with passed interval regardless of `autoplay` settings
     * @return {Glide}
     */
  }, {
    key: "play",
    value: function() {
      var n = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !1;
      return n && (this.settings.autoplay = n), this._e.emit("play"), this;
    }
    /**
     * Stop instance autoplaying.
     *
     * @return {Glide}
     */
  }, {
    key: "pause",
    value: function() {
      return this._e.emit("pause"), this;
    }
    /**
     * Sets glide into a idle status.
     *
     * @return {Glide}
     */
  }, {
    key: "disable",
    value: function() {
      return this.disabled = !0, this;
    }
    /**
     * Sets glide into a active status.
     *
     * @return {Glide}
     */
  }, {
    key: "enable",
    value: function() {
      return this.disabled = !1, this;
    }
    /**
     * Adds cuutom event listener with handler.
     *
     * @param  {String|Array} event
     * @param  {Function} handler
     * @return {Glide}
     */
  }, {
    key: "on",
    value: function(n, r) {
      return this._e.on(n, r), this;
    }
    /**
     * Checks if glide is a precised type.
     *
     * @param  {String} name
     * @return {Boolean}
     */
  }, {
    key: "isType",
    value: function(n) {
      return this.settings.type === n;
    }
    /**
     * Gets value of the core options.
     *
     * @return {Object}
     */
  }, {
    key: "settings",
    get: function() {
      return this._o;
    },
    set: function(n) {
      Fn(n) ? this._o = n : Xt("Options must be an `object` instance.");
    }
    /**
     * Gets current index of the slider.
     *
     * @return {Object}
     */
  }, {
    key: "index",
    get: function() {
      return this._i;
    },
    set: function(n) {
      this._i = et(n);
    }
    /**
     * Gets type name of the slider.
     *
     * @return {String}
     */
  }, {
    key: "type",
    get: function() {
      return this.settings.type;
    }
    /**
     * Gets value of the idle status.
     *
     * @return {Boolean}
     */
  }, {
    key: "disabled",
    get: function() {
      return this._d;
    },
    set: function(n) {
      this._d = !!n;
    }
  }]), e;
}();
function Uu(e, t, n) {
  var r = {
    /**
     * Initializes autorunning of the glide.
     *
     * @return {Void}
     */
    mount: function() {
      this._o = !1;
    },
    /**
     * Makes glides running based on the passed moving schema.
     *
     * @param {String} move
     */
    make: function(p) {
      var b = this;
      e.disabled || (!e.settings.waitForTransition || e.disable(), this.move = p, n.emit("run.before", this.move), this.calculate(), n.emit("run", this.move), t.Transition.after(function() {
        b.isStart() && n.emit("run.start", b.move), b.isEnd() && n.emit("run.end", b.move), b.isOffset() && (b._o = !1, n.emit("run.offset", b.move)), n.emit("run.after", b.move), e.enable();
      }));
    },
    /**
     * Calculates current index based on defined move.
     *
     * @return {Number|Undefined}
     */
    calculate: function() {
      var p = this.move, b = this.length, S = p.steps, E = p.direction, P = 1;
      if (E === "=") {
        if (e.settings.bound && et(S) > b) {
          e.index = b;
          return;
        }
        e.index = S;
        return;
      }
      if (E === ">" && S === ">") {
        e.index = b;
        return;
      }
      if (E === "<" && S === "<") {
        e.index = 0;
        return;
      }
      if (E === "|" && (P = e.settings.perView || 1), E === ">" || E === "|" && S === ">") {
        var A = i(P);
        A > b && (this._o = !0), e.index = a(A, P);
        return;
      }
      if (E === "<" || E === "|" && S === "<") {
        var k = d(P);
        k < 0 && (this._o = !0), e.index = h(k, P);
        return;
      }
      Xt("Invalid direction pattern [".concat(E).concat(S, "] has been used"));
    },
    /**
     * Checks if we are on the first slide.
     *
     * @return {Boolean}
     */
    isStart: function() {
      return e.index <= 0;
    },
    /**
     * Checks if we are on the last slide.
     *
     * @return {Boolean}
     */
    isEnd: function() {
      return e.index >= this.length;
    },
    /**
     * Checks if we are making a offset run.
     *
     * @param {String} direction
     * @return {Boolean}
     */
    isOffset: function() {
      var p = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : void 0;
      return p ? this._o ? p === "|>" ? this.move.direction === "|" && this.move.steps === ">" : p === "|<" ? this.move.direction === "|" && this.move.steps === "<" : this.move.direction === p : !1 : this._o;
    },
    /**
     * Checks if bound mode is active
     *
     * @return {Boolean}
     */
    isBound: function() {
      return e.isType("slider") && e.settings.focusAt !== "center" && e.settings.bound;
    }
  };
  function i(m) {
    var p = e.index;
    return e.isType("carousel") ? p + m : p + (m - p % m);
  }
  function a(m, p) {
    var b = r.length;
    return m <= b ? m : e.isType("carousel") ? m - (b + 1) : e.settings.rewind ? r.isBound() && !r.isEnd() ? b : 0 : r.isBound() ? b : Math.floor(b / p) * p;
  }
  function d(m) {
    var p = e.index;
    if (e.isType("carousel"))
      return p - m;
    var b = Math.ceil(p / m);
    return (b - 1) * m;
  }
  function h(m, p) {
    var b = r.length;
    return m >= 0 ? m : e.isType("carousel") ? m + (b + 1) : e.settings.rewind ? r.isBound() && r.isStart() ? b : Math.floor(b / p) * p : 0;
  }
  return Fe(r, "move", {
    /**
     * Gets value of the move schema.
     *
     * @returns {Object}
     */
    get: function() {
      return this._m;
    },
    /**
     * Sets value of the move schema.
     *
     * @returns {Object}
     */
    set: function(p) {
      var b = p.substr(1);
      this._m = {
        direction: p.substr(0, 1),
        steps: b ? et(b) ? et(b) : b : 0
      };
    }
  }), Fe(r, "length", {
    /**
     * Gets value of the running distance based
     * on zero-indexing number of slides.
     *
     * @return {Number}
     */
    get: function() {
      var p = e.settings, b = t.Html.slides.length;
      return this.isBound() ? b - 1 - (et(p.perView) - 1) + et(p.focusAt) : b - 1;
    }
  }), Fe(r, "offset", {
    /**
     * Gets status of the offsetting flag.
     *
     * @return {Boolean}
     */
    get: function() {
      return this._o;
    }
  }), r;
}
function ds() {
  return (/* @__PURE__ */ new Date()).getTime();
}
function Xr(e, t) {
  var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, r, i, a, d, h = 0, m = function() {
    h = n.leading === !1 ? 0 : ds(), r = null, d = e.apply(i, a), r || (i = a = null);
  }, p = function() {
    var S = ds();
    !h && n.leading === !1 && (h = S);
    var E = t - (S - h);
    return i = this, a = arguments, E <= 0 || E > t ? (r && (clearTimeout(r), r = null), h = S, d = e.apply(i, a), r || (i = a = null)) : !r && n.trailing !== !1 && (r = setTimeout(m, E)), d;
  };
  return p.cancel = function() {
    clearTimeout(r), h = 0, r = i = a = null;
  }, p;
}
var Rr = {
  ltr: ["marginLeft", "marginRight"],
  rtl: ["marginRight", "marginLeft"]
};
function qu(e, t, n) {
  var r = {
    /**
     * Applies gaps between slides. First and last
     * slides do not receive it's edge margins.
     *
     * @param {HTMLCollection} slides
     * @return {Void}
     */
    apply: function(a) {
      for (var d = 0, h = a.length; d < h; d++) {
        var m = a[d].style, p = t.Direction.value;
        d !== 0 ? m[Rr[p][0]] = "".concat(this.value / 2, "px") : m[Rr[p][0]] = "", d !== a.length - 1 ? m[Rr[p][1]] = "".concat(this.value / 2, "px") : m[Rr[p][1]] = "";
      }
    },
    /**
     * Removes gaps from the slides.
     *
     * @param {HTMLCollection} slides
     * @returns {Void}
    */
    remove: function(a) {
      for (var d = 0, h = a.length; d < h; d++) {
        var m = a[d].style;
        m.marginLeft = "", m.marginRight = "";
      }
    }
  };
  return Fe(r, "value", {
    /**
     * Gets value of the gap.
     *
     * @returns {Number}
     */
    get: function() {
      return et(e.settings.gap);
    }
  }), Fe(r, "grow", {
    /**
     * Gets additional dimensions value caused by gaps.
     * Used to increase width of the slides wrapper.
     *
     * @returns {Number}
     */
    get: function() {
      return r.value * t.Sizes.length;
    }
  }), Fe(r, "reductor", {
    /**
     * Gets reduction value caused by gaps.
     * Used to subtract width of the slides.
     *
     * @returns {Number}
     */
    get: function() {
      var a = e.settings.perView;
      return r.value * (a - 1) / a;
    }
  }), n.on(["build.after", "update"], Xr(function() {
    r.apply(t.Html.wrapper.children);
  }, 30)), n.on("destroy", function() {
    r.remove(t.Html.wrapper.children);
  }), r;
}
function pa(e) {
  if (e && e.parentNode) {
    for (var t = e.parentNode.firstChild, n = []; t; t = t.nextSibling)
      t.nodeType === 1 && t !== e && n.push(t);
    return n;
  }
  return [];
}
function Fi(e) {
  return Array.prototype.slice.call(e);
}
var Yu = '[data-glide-el="track"]';
function Gu(e, t, n) {
  var r = {
    /**
     * Setup slider HTML nodes.
     *
     * @param {Glide} glide
     */
    mount: function() {
      this.root = e.selector, this.track = this.root.querySelector(Yu), this.collectSlides();
    },
    /**
     * Collect slides
     */
    collectSlides: function() {
      this.slides = Fi(this.wrapper.children).filter(function(a) {
        return !a.classList.contains(e.settings.classes.slide.clone);
      });
    }
  };
  return Fe(r, "root", {
    /**
     * Gets node of the glide main element.
     *
     * @return {Object}
     */
    get: function() {
      return r._r;
    },
    /**
     * Sets node of the glide main element.
     *
     * @return {Object}
     */
    set: function(a) {
      Li(a) && (a = document.querySelector(a)), a !== null ? r._r = a : Xt("Root element must be a existing Html node");
    }
  }), Fe(r, "track", {
    /**
     * Gets node of the glide track with slides.
     *
     * @return {Object}
     */
    get: function() {
      return r._t;
    },
    /**
     * Sets node of the glide track with slides.
     *
     * @return {Object}
     */
    set: function(a) {
      r._t = a;
    }
  }), Fe(r, "wrapper", {
    /**
     * Gets node of the slides wrapper.
     *
     * @return {Object}
     */
    get: function() {
      return r.track.children[0];
    }
  }), n.on("update", function() {
    r.collectSlides();
  }), r;
}
function Xu(e, t, n) {
  var r = {
    /**
     * Setups how much to peek based on settings.
     *
     * @return {Void}
     */
    mount: function() {
      this.value = e.settings.peek;
    }
  };
  return Fe(r, "value", {
    /**
     * Gets value of the peek.
     *
     * @returns {Number|Object}
     */
    get: function() {
      return r._v;
    },
    /**
     * Sets value of the peek.
     *
     * @param {Number|Object} value
     * @return {Void}
     */
    set: function(a) {
      Fn(a) ? (a.before = et(a.before), a.after = et(a.after)) : a = et(a), r._v = a;
    }
  }), Fe(r, "reductor", {
    /**
     * Gets reduction value caused by peek.
     *
     * @returns {Number}
     */
    get: function() {
      var a = r.value, d = e.settings.perView;
      return Fn(a) ? a.before / d + a.after / d : a * 2 / d;
    }
  }), n.on(["resize", "update"], function() {
    r.mount();
  }), r;
}
function Ku(e, t, n) {
  var r = {
    /**
     * Constructs move component.
     *
     * @returns {Void}
     */
    mount: function() {
      this._o = 0;
    },
    /**
     * Calculates a movement value based on passed offset and currently active index.
     *
     * @param  {Number} offset
     * @return {Void}
     */
    make: function() {
      var a = this, d = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
      this.offset = d, n.emit("move", {
        movement: this.value
      }), t.Transition.after(function() {
        n.emit("move.after", {
          movement: a.value
        });
      });
    }
  };
  return Fe(r, "offset", {
    /**
     * Gets an offset value used to modify current translate.
     *
     * @return {Object}
     */
    get: function() {
      return r._o;
    },
    /**
     * Sets an offset value used to modify current translate.
     *
     * @return {Object}
     */
    set: function(a) {
      r._o = fa(a) ? 0 : et(a);
    }
  }), Fe(r, "translate", {
    /**
     * Gets a raw movement value.
     *
     * @return {Number}
     */
    get: function() {
      return t.Sizes.slideWidth * e.index;
    }
  }), Fe(r, "value", {
    /**
     * Gets an actual movement value corrected by offset.
     *
     * @return {Number}
     */
    get: function() {
      var a = this.offset, d = this.translate;
      return t.Direction.is("rtl") ? d + a : d - a;
    }
  }), n.on(["build.before", "run"], function() {
    r.make();
  }), r;
}
function Zu(e, t, n) {
  var r = {
    /**
     * Setups dimensions of slides.
     *
     * @return {Void}
     */
    setupSlides: function() {
      for (var a = "".concat(this.slideWidth, "px"), d = t.Html.slides, h = 0; h < d.length; h++)
        d[h].style.width = a;
    },
    /**
     * Setups dimensions of slides wrapper.
     *
     * @return {Void}
     */
    setupWrapper: function() {
      t.Html.wrapper.style.width = "".concat(this.wrapperSize, "px");
    },
    /**
     * Removes applied styles from HTML elements.
     *
     * @returns {Void}
     */
    remove: function() {
      for (var a = t.Html.slides, d = 0; d < a.length; d++)
        a[d].style.width = "";
      t.Html.wrapper.style.width = "";
    }
  };
  return Fe(r, "length", {
    /**
     * Gets count number of the slides.
     *
     * @return {Number}
     */
    get: function() {
      return t.Html.slides.length;
    }
  }), Fe(r, "width", {
    /**
     * Gets width value of the slider (visible area).
     *
     * @return {Number}
     */
    get: function() {
      return t.Html.track.offsetWidth;
    }
  }), Fe(r, "wrapperSize", {
    /**
     * Gets size of the slides wrapper.
     *
     * @return {Number}
     */
    get: function() {
      return r.slideWidth * r.length + t.Gaps.grow + t.Clones.grow;
    }
  }), Fe(r, "slideWidth", {
    /**
     * Gets width value of a single slide.
     *
     * @return {Number}
     */
    get: function() {
      return r.width / e.settings.perView - t.Peek.reductor - t.Gaps.reductor;
    }
  }), n.on(["build.before", "resize", "update"], function() {
    r.setupSlides(), r.setupWrapper();
  }), n.on("destroy", function() {
    r.remove();
  }), r;
}
function Ju(e, t, n) {
  var r = {
    /**
     * Init glide building. Adds classes, sets
     * dimensions and setups initial state.
     *
     * @return {Void}
     */
    mount: function() {
      n.emit("build.before"), this.typeClass(), this.activeClass(), n.emit("build.after");
    },
    /**
     * Adds `type` class to the glide element.
     *
     * @return {Void}
     */
    typeClass: function() {
      t.Html.root.classList.add(e.settings.classes.type[e.settings.type]);
    },
    /**
     * Sets active class to current slide.
     *
     * @return {Void}
     */
    activeClass: function() {
      var a = e.settings.classes, d = t.Html.slides[e.index];
      d && (d.classList.add(a.slide.active), pa(d).forEach(function(h) {
        h.classList.remove(a.slide.active);
      }));
    },
    /**
     * Removes HTML classes applied at building.
     *
     * @return {Void}
     */
    removeClasses: function() {
      var a = e.settings.classes, d = a.type, h = a.slide;
      t.Html.root.classList.remove(d[e.settings.type]), t.Html.slides.forEach(function(m) {
        m.classList.remove(h.active);
      });
    }
  };
  return n.on(["destroy", "update"], function() {
    r.removeClasses();
  }), n.on(["resize", "update"], function() {
    r.mount();
  }), n.on("move.after", function() {
    r.activeClass();
  }), r;
}
function Qu(e, t, n) {
  var r = {
    /**
     * Create pattern map and collect slides to be cloned.
     */
    mount: function() {
      this.items = [], e.isType("carousel") && (this.items = this.collect());
    },
    /**
     * Collect clones with pattern.
     *
     * @return {[]}
     */
    collect: function() {
      var a = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], d = t.Html.slides, h = e.settings, m = h.perView, p = h.classes, b = h.cloningRatio;
      if (d.length > 0)
        for (var S = +!!e.settings.peek, E = m + S + Math.round(m / 2), P = d.slice(0, E).reverse(), A = d.slice(E * -1), k = 0; k < Math.max(b, Math.floor(m / d.length)); k++) {
          for (var N = 0; N < P.length; N++) {
            var j = P[N].cloneNode(!0);
            j.classList.add(p.slide.clone), a.push(j);
          }
          for (var D = 0; D < A.length; D++) {
            var V = A[D].cloneNode(!0);
            V.classList.add(p.slide.clone), a.unshift(V);
          }
        }
      return a;
    },
    /**
     * Append cloned slides with generated pattern.
     *
     * @return {Void}
     */
    append: function() {
      for (var a = this.items, d = t.Html, h = d.wrapper, m = d.slides, p = Math.floor(a.length / 2), b = a.slice(0, p).reverse(), S = a.slice(p * -1).reverse(), E = "".concat(t.Sizes.slideWidth, "px"), P = 0; P < S.length; P++)
        h.appendChild(S[P]);
      for (var A = 0; A < b.length; A++)
        h.insertBefore(b[A], m[0]);
      for (var k = 0; k < a.length; k++)
        a[k].style.width = E;
    },
    /**
     * Remove all cloned slides.
     *
     * @return {Void}
     */
    remove: function() {
      for (var a = this.items, d = 0; d < a.length; d++)
        t.Html.wrapper.removeChild(a[d]);
    }
  };
  return Fe(r, "grow", {
    /**
     * Gets additional dimensions value caused by clones.
     *
     * @return {Number}
     */
    get: function() {
      return (t.Sizes.slideWidth + t.Gaps.value) * r.items.length;
    }
  }), n.on("update", function() {
    r.remove(), r.mount(), r.append();
  }), n.on("build.before", function() {
    e.isType("carousel") && r.append();
  }), n.on("destroy", function() {
    r.remove();
  }), r;
}
var un = /* @__PURE__ */ function() {
  function e() {
    var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    Yr(this, e), this.listeners = t;
  }
  return Gr(e, [{
    key: "on",
    value: function(n, r, i) {
      var a = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : !1;
      Li(n) && (n = [n]);
      for (var d = 0; d < n.length; d++)
        this.listeners[n[d]] = i, r.addEventListener(n[d], this.listeners[n[d]], a);
    }
    /**
     * Removes event listeners from arrows HTML elements.
     *
     * @param  {String|Array} events
     * @param  {Element|Window|Document} el
     * @param  {Boolean|Object} capture
     * @return {Void}
     */
  }, {
    key: "off",
    value: function(n, r) {
      var i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1;
      Li(n) && (n = [n]);
      for (var a = 0; a < n.length; a++)
        r.removeEventListener(n[a], this.listeners[n[a]], i);
    }
    /**
     * Destroy collected listeners.
     *
     * @returns {Void}
     */
  }, {
    key: "destroy",
    value: function() {
      delete this.listeners;
    }
  }]), e;
}();
function ed(e, t, n) {
  var r = new un(), i = {
    /**
     * Initializes window bindings.
     */
    mount: function() {
      this.bind();
    },
    /**
     * Binds `rezsize` listener to the window.
     * It's a costly event, so we are debouncing it.
     *
     * @return {Void}
     */
    bind: function() {
      r.on("resize", window, Xr(function() {
        n.emit("resize");
      }, e.settings.throttle));
    },
    /**
     * Unbinds listeners from the window.
     *
     * @return {Void}
     */
    unbind: function() {
      r.off("resize", window);
    }
  };
  return n.on("destroy", function() {
    i.unbind(), r.destroy();
  }), i;
}
var td = ["ltr", "rtl"], nd = {
  ">": "<",
  "<": ">",
  "=": "="
};
function rd(e, t, n) {
  var r = {
    /**
     * Setups gap value based on settings.
     *
     * @return {Void}
     */
    mount: function() {
      this.value = e.settings.direction;
    },
    /**
     * Resolves pattern based on direction value
     *
     * @param {String} pattern
     * @returns {String}
     */
    resolve: function(a) {
      var d = a.slice(0, 1);
      return this.is("rtl") ? a.split(d).join(nd[d]) : a;
    },
    /**
     * Checks value of direction mode.
     *
     * @param {String} direction
     * @returns {Boolean}
     */
    is: function(a) {
      return this.value === a;
    },
    /**
     * Applies direction class to the root HTML element.
     *
     * @return {Void}
     */
    addClass: function() {
      t.Html.root.classList.add(e.settings.classes.direction[this.value]);
    },
    /**
     * Removes direction class from the root HTML element.
     *
     * @return {Void}
     */
    removeClass: function() {
      t.Html.root.classList.remove(e.settings.classes.direction[this.value]);
    }
  };
  return Fe(r, "value", {
    /**
     * Gets value of the direction.
     *
     * @returns {Number}
     */
    get: function() {
      return r._v;
    },
    /**
     * Sets value of the direction.
     *
     * @param {String} value
     * @return {Void}
     */
    set: function(a) {
      td.indexOf(a) > -1 ? r._v = a : Xt("Direction value must be `ltr` or `rtl`");
    }
  }), n.on(["destroy", "update"], function() {
    r.removeClass();
  }), n.on("update", function() {
    r.mount();
  }), n.on(["build.before", "update"], function() {
    r.addClass();
  }), r;
}
function id(e, t) {
  return {
    /**
     * Negates the passed translate if glide is in RTL option.
     *
     * @param  {Number} translate
     * @return {Number}
     */
    modify: function(r) {
      return t.Direction.is("rtl") ? -r : r;
    }
  };
}
function od(e, t) {
  return {
    /**
     * Modifies passed translate value with number in the `gap` settings.
     *
     * @param  {Number} translate
     * @return {Number}
     */
    modify: function(r) {
      var i = Math.floor(r / t.Sizes.slideWidth);
      return r + t.Gaps.value * i;
    }
  };
}
function sd(e, t) {
  return {
    /**
     * Adds to the passed translate width of the half of clones.
     *
     * @param  {Number} translate
     * @return {Number}
     */
    modify: function(r) {
      return r + t.Clones.grow / 2;
    }
  };
}
function ad(e, t) {
  return {
    /**
     * Modifies passed translate value with a `peek` setting.
     *
     * @param  {Number} translate
     * @return {Number}
     */
    modify: function(r) {
      if (e.settings.focusAt >= 0) {
        var i = t.Peek.value;
        return Fn(i) ? r - i.before : r - i;
      }
      return r;
    }
  };
}
function ld(e, t) {
  return {
    /**
     * Modifies passed translate value with index in the `focusAt` setting.
     *
     * @param  {Number} translate
     * @return {Number}
     */
    modify: function(r) {
      var i = t.Gaps.value, a = t.Sizes.width, d = e.settings.focusAt, h = t.Sizes.slideWidth;
      return d === "center" ? r - (a / 2 - h / 2) : r - h * d - i * d;
    }
  };
}
function cd(e, t, n) {
  var r = [od, sd, ad, ld].concat(e._t, [id]);
  return {
    /**
     * Piplines translate value with registered transformers.
     *
     * @param  {Number} translate
     * @return {Number}
     */
    mutate: function(a) {
      for (var d = 0; d < r.length; d++) {
        var h = r[d];
        Hr(h) && Hr(h().modify) ? a = h(e, t, n).modify(a) : Xt("Transformer should be a function that returns an object with `modify()` method");
      }
      return a;
    }
  };
}
function ud(e, t, n) {
  var r = {
    /**
     * Sets value of translate on HTML element.
     *
     * @param {Number} value
     * @return {Void}
     */
    set: function(a) {
      var d = cd(e, t).mutate(a), h = "translate3d(".concat(-1 * d, "px, 0px, 0px)");
      t.Html.wrapper.style.mozTransform = h, t.Html.wrapper.style.webkitTransform = h, t.Html.wrapper.style.transform = h;
    },
    /**
     * Removes value of translate from HTML element.
     *
     * @return {Void}
     */
    remove: function() {
      t.Html.wrapper.style.transform = "";
    },
    /**
     * @return {number}
     */
    getStartIndex: function() {
      var a = t.Sizes.length, d = e.index, h = e.settings.perView;
      return t.Run.isOffset(">") || t.Run.isOffset("|>") ? a + (d - h) : (d + h) % a;
    },
    /**
     * @return {number}
     */
    getTravelDistance: function() {
      var a = t.Sizes.slideWidth * e.settings.perView;
      return t.Run.isOffset(">") || t.Run.isOffset("|>") ? a * -1 : a;
    }
  };
  return n.on("move", function(i) {
    if (!e.isType("carousel") || !t.Run.isOffset())
      return r.set(i.movement);
    t.Transition.after(function() {
      n.emit("translate.jump"), r.set(t.Sizes.slideWidth * e.index);
    });
    var a = t.Sizes.slideWidth * t.Translate.getStartIndex();
    return r.set(a - t.Translate.getTravelDistance());
  }), n.on("destroy", function() {
    r.remove();
  }), r;
}
function dd(e, t, n) {
  var r = !1, i = {
    /**
     * Composes string of the CSS transition.
     *
     * @param {String} property
     * @return {String}
     */
    compose: function(d) {
      var h = e.settings;
      return r ? "".concat(d, " 0ms ").concat(h.animationTimingFunc) : "".concat(d, " ").concat(this.duration, "ms ").concat(h.animationTimingFunc);
    },
    /**
     * Sets value of transition on HTML element.
     *
     * @param {String=} property
     * @return {Void}
     */
    set: function() {
      var d = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "transform";
      t.Html.wrapper.style.transition = this.compose(d);
    },
    /**
     * Removes value of transition from HTML element.
     *
     * @return {Void}
     */
    remove: function() {
      t.Html.wrapper.style.transition = "";
    },
    /**
     * Runs callback after animation.
     *
     * @param  {Function} callback
     * @return {Void}
     */
    after: function(d) {
      setTimeout(function() {
        d();
      }, this.duration);
    },
    /**
     * Enable transition.
     *
     * @return {Void}
     */
    enable: function() {
      r = !1, this.set();
    },
    /**
     * Disable transition.
     *
     * @return {Void}
     */
    disable: function() {
      r = !0, this.set();
    }
  };
  return Fe(i, "duration", {
    /**
     * Gets duration of the transition based
     * on currently running animation type.
     *
     * @return {Number}
     */
    get: function() {
      var d = e.settings;
      return e.isType("slider") && t.Run.offset ? d.rewindDuration : d.animationDuration;
    }
  }), n.on("move", function() {
    i.set();
  }), n.on(["build.before", "resize", "translate.jump"], function() {
    i.disable();
  }), n.on("run", function() {
    i.enable();
  }), n.on("destroy", function() {
    i.remove();
  }), i;
}
var ha = !1;
try {
  var fs = Object.defineProperty({}, "passive", {
    get: function() {
      ha = !0;
    }
  });
  window.addEventListener("testPassive", null, fs), window.removeEventListener("testPassive", null, fs);
} catch {
}
var $i = ha, Ar = ["touchstart", "mousedown"], ps = ["touchmove", "mousemove"], hs = ["touchend", "touchcancel", "mouseup", "mouseleave"], ms = ["mousedown", "mousemove", "mouseup", "mouseleave"];
function fd(e, t, n) {
  var r = new un(), i = 0, a = 0, d = 0, h = !1, m = $i ? {
    passive: !0
  } : !1, p = {
    /**
     * Initializes swipe bindings.
     *
     * @return {Void}
     */
    mount: function() {
      this.bindSwipeStart();
    },
    /**
     * Handler for `swipestart` event. Calculates entry points of the user's tap.
     *
     * @param {Object} event
     * @return {Void}
     */
    start: function(S) {
      if (!h && !e.disabled) {
        this.disable();
        var E = this.touches(S);
        i = null, a = et(E.pageX), d = et(E.pageY), this.bindSwipeMove(), this.bindSwipeEnd(), n.emit("swipe.start");
      }
    },
    /**
     * Handler for `swipemove` event. Calculates user's tap angle and distance.
     *
     * @param {Object} event
     */
    move: function(S) {
      if (!e.disabled) {
        var E = e.settings, P = E.touchAngle, A = E.touchRatio, k = E.classes, N = this.touches(S), j = et(N.pageX) - a, D = et(N.pageY) - d, V = Math.abs(j << 2), W = Math.abs(D << 2), M = Math.sqrt(V + W), Z = Math.sqrt(W);
        if (i = Math.asin(Z / M), i * 180 / Math.PI < P)
          S.stopPropagation(), t.Move.make(j * Bu(A)), t.Html.root.classList.add(k.dragging), n.emit("swipe.move");
        else
          return !1;
      }
    },
    /**
     * Handler for `swipeend` event. Finitializes user's tap and decides about glide move.
     *
     * @param {Object} event
     * @return {Void}
     */
    end: function(S) {
      if (!e.disabled) {
        var E = e.settings, P = E.perSwipe, A = E.touchAngle, k = E.classes, N = this.touches(S), j = this.threshold(S), D = N.pageX - a, V = i * 180 / Math.PI;
        this.enable(), D > j && V < A ? t.Run.make(t.Direction.resolve("".concat(P, "<"))) : D < -j && V < A ? t.Run.make(t.Direction.resolve("".concat(P, ">"))) : t.Move.make(), t.Html.root.classList.remove(k.dragging), this.unbindSwipeMove(), this.unbindSwipeEnd(), n.emit("swipe.end");
      }
    },
    /**
     * Binds swipe's starting event.
     *
     * @return {Void}
     */
    bindSwipeStart: function() {
      var S = this, E = e.settings, P = E.swipeThreshold, A = E.dragThreshold;
      P && r.on(Ar[0], t.Html.wrapper, function(k) {
        S.start(k);
      }, m), A && r.on(Ar[1], t.Html.wrapper, function(k) {
        S.start(k);
      }, m);
    },
    /**
     * Unbinds swipe's starting event.
     *
     * @return {Void}
     */
    unbindSwipeStart: function() {
      r.off(Ar[0], t.Html.wrapper, m), r.off(Ar[1], t.Html.wrapper, m);
    },
    /**
     * Binds swipe's moving event.
     *
     * @return {Void}
     */
    bindSwipeMove: function() {
      var S = this;
      r.on(ps, t.Html.wrapper, Xr(function(E) {
        S.move(E);
      }, e.settings.throttle), m);
    },
    /**
     * Unbinds swipe's moving event.
     *
     * @return {Void}
     */
    unbindSwipeMove: function() {
      r.off(ps, t.Html.wrapper, m);
    },
    /**
     * Binds swipe's ending event.
     *
     * @return {Void}
     */
    bindSwipeEnd: function() {
      var S = this;
      r.on(hs, t.Html.wrapper, function(E) {
        S.end(E);
      });
    },
    /**
     * Unbinds swipe's ending event.
     *
     * @return {Void}
     */
    unbindSwipeEnd: function() {
      r.off(hs, t.Html.wrapper);
    },
    /**
     * Normalizes event touches points accorting to different types.
     *
     * @param {Object} event
     */
    touches: function(S) {
      return ms.indexOf(S.type) > -1 ? S : S.touches[0] || S.changedTouches[0];
    },
    /**
     * Gets value of minimum swipe distance settings based on event type.
     *
     * @return {Number}
     */
    threshold: function(S) {
      var E = e.settings;
      return ms.indexOf(S.type) > -1 ? E.dragThreshold : E.swipeThreshold;
    },
    /**
     * Enables swipe event.
     *
     * @return {self}
     */
    enable: function() {
      return h = !1, t.Transition.enable(), this;
    },
    /**
     * Disables swipe event.
     *
     * @return {self}
     */
    disable: function() {
      return h = !0, t.Transition.disable(), this;
    }
  };
  return n.on("build.after", function() {
    t.Html.root.classList.add(e.settings.classes.swipeable);
  }), n.on("destroy", function() {
    p.unbindSwipeStart(), p.unbindSwipeMove(), p.unbindSwipeEnd(), r.destroy();
  }), p;
}
function pd(e, t, n) {
  var r = new un(), i = {
    /**
     * Binds listener to glide wrapper.
     *
     * @return {Void}
     */
    mount: function() {
      this.bind();
    },
    /**
     * Binds `dragstart` event on wrapper to prevent dragging images.
     *
     * @return {Void}
     */
    bind: function() {
      r.on("dragstart", t.Html.wrapper, this.dragstart);
    },
    /**
     * Unbinds `dragstart` event on wrapper.
     *
     * @return {Void}
     */
    unbind: function() {
      r.off("dragstart", t.Html.wrapper);
    },
    /**
     * Event handler. Prevents dragging.
     *
     * @return {Void}
     */
    dragstart: function(d) {
      d.preventDefault();
    }
  };
  return n.on("destroy", function() {
    i.unbind(), r.destroy();
  }), i;
}
function hd(e, t, n) {
  var r = new un(), i = !1, a = !1, d = {
    /**
     * Setups a initial state of anchors component.
     *
     * @returns {Void}
     */
    mount: function() {
      this._a = t.Html.wrapper.querySelectorAll("a"), this.bind();
    },
    /**
     * Binds events to anchors inside a track.
     *
     * @return {Void}
     */
    bind: function() {
      r.on("click", t.Html.wrapper, this.click);
    },
    /**
     * Unbinds events attached to anchors inside a track.
     *
     * @return {Void}
     */
    unbind: function() {
      r.off("click", t.Html.wrapper);
    },
    /**
     * Handler for click event. Prevents clicks when glide is in `prevent` status.
     *
     * @param  {Object} event
     * @return {Void}
     */
    click: function(m) {
      a && (m.stopPropagation(), m.preventDefault());
    },
    /**
     * Detaches anchors click event inside glide.
     *
     * @return {self}
     */
    detach: function() {
      if (a = !0, !i) {
        for (var m = 0; m < this.items.length; m++)
          this.items[m].draggable = !1;
        i = !0;
      }
      return this;
    },
    /**
     * Attaches anchors click events inside glide.
     *
     * @return {self}
     */
    attach: function() {
      if (a = !1, i) {
        for (var m = 0; m < this.items.length; m++)
          this.items[m].draggable = !0;
        i = !1;
      }
      return this;
    }
  };
  return Fe(d, "items", {
    /**
     * Gets collection of the arrows HTML elements.
     *
     * @return {HTMLElement[]}
     */
    get: function() {
      return d._a;
    }
  }), n.on("swipe.move", function() {
    d.detach();
  }), n.on("swipe.end", function() {
    t.Transition.after(function() {
      d.attach();
    });
  }), n.on("destroy", function() {
    d.attach(), d.unbind(), r.destroy();
  }), d;
}
var md = '[data-glide-el="controls[nav]"]', ro = '[data-glide-el^="controls"]', gd = "".concat(ro, ' [data-glide-dir*="<"]'), vd = "".concat(ro, ' [data-glide-dir*=">"]');
function yd(e, t, n) {
  var r = new un(), i = $i ? {
    passive: !0
  } : !1, a = {
    /**
     * Inits arrows. Binds events listeners
     * to the arrows HTML elements.
     *
     * @return {Void}
     */
    mount: function() {
      this._n = t.Html.root.querySelectorAll(md), this._c = t.Html.root.querySelectorAll(ro), this._arrowControls = {
        previous: t.Html.root.querySelectorAll(gd),
        next: t.Html.root.querySelectorAll(vd)
      }, this.addBindings();
    },
    /**
     * Sets active class to current slide.
     *
     * @return {Void}
     */
    setActive: function() {
      for (var h = 0; h < this._n.length; h++)
        this.addClass(this._n[h].children);
    },
    /**
     * Removes active class to current slide.
     *
     * @return {Void}
     */
    removeActive: function() {
      for (var h = 0; h < this._n.length; h++)
        this.removeClass(this._n[h].children);
    },
    /**
     * Toggles active class on items inside navigation.
     *
     * @param  {HTMLElement} controls
     * @return {Void}
     */
    addClass: function(h) {
      var m = e.settings, p = h[e.index];
      p && (p.classList.add(m.classes.nav.active), pa(p).forEach(function(b) {
        b.classList.remove(m.classes.nav.active);
      }));
    },
    /**
     * Removes active class from active control.
     *
     * @param  {HTMLElement} controls
     * @return {Void}
     */
    removeClass: function(h) {
      var m = h[e.index];
      m == null || m.classList.remove(e.settings.classes.nav.active);
    },
    /**
     * Calculates, removes or adds `Glide.settings.classes.disabledArrow` class on the control arrows
     */
    setArrowState: function() {
      if (!e.settings.rewind) {
        var h = a._arrowControls.next, m = a._arrowControls.previous;
        this.resetArrowState(h, m), e.index === 0 && this.disableArrow(m), e.index === t.Run.length && this.disableArrow(h);
      }
    },
    /**
     * Removes `Glide.settings.classes.disabledArrow` from given NodeList elements
     *
     * @param {NodeList[]} lists
     */
    resetArrowState: function() {
      for (var h = e.settings, m = arguments.length, p = new Array(m), b = 0; b < m; b++)
        p[b] = arguments[b];
      p.forEach(function(S) {
        Fi(S).forEach(function(E) {
          E.classList.remove(h.classes.arrow.disabled);
        });
      });
    },
    /**
     * Adds `Glide.settings.classes.disabledArrow` to given NodeList elements
     *
     * @param {NodeList[]} lists
     */
    disableArrow: function() {
      for (var h = e.settings, m = arguments.length, p = new Array(m), b = 0; b < m; b++)
        p[b] = arguments[b];
      p.forEach(function(S) {
        Fi(S).forEach(function(E) {
          E.classList.add(h.classes.arrow.disabled);
        });
      });
    },
    /**
     * Adds handles to the each group of controls.
     *
     * @return {Void}
     */
    addBindings: function() {
      for (var h = 0; h < this._c.length; h++)
        this.bind(this._c[h].children);
    },
    /**
     * Removes handles from the each group of controls.
     *
     * @return {Void}
     */
    removeBindings: function() {
      for (var h = 0; h < this._c.length; h++)
        this.unbind(this._c[h].children);
    },
    /**
     * Binds events to arrows HTML elements.
     *
     * @param {HTMLCollection} elements
     * @return {Void}
     */
    bind: function(h) {
      for (var m = 0; m < h.length; m++)
        r.on("click", h[m], this.click), r.on("touchstart", h[m], this.click, i);
    },
    /**
     * Unbinds events binded to the arrows HTML elements.
     *
     * @param {HTMLCollection} elements
     * @return {Void}
     */
    unbind: function(h) {
      for (var m = 0; m < h.length; m++)
        r.off(["click", "touchstart"], h[m]);
    },
    /**
     * Handles `click` event on the arrows HTML elements.
     * Moves slider in direction given via the
     * `data-glide-dir` attribute.
     *
     * @param {Object} event
     * @return {void}
     */
    click: function(h) {
      !$i && h.type === "touchstart" && h.preventDefault();
      var m = h.currentTarget.getAttribute("data-glide-dir");
      t.Run.make(t.Direction.resolve(m));
    }
  };
  return Fe(a, "items", {
    /**
     * Gets collection of the controls HTML elements.
     *
     * @return {HTMLElement[]}
     */
    get: function() {
      return a._c;
    }
  }), n.on(["mount.after", "move.after"], function() {
    a.setActive();
  }), n.on(["mount.after", "run"], function() {
    a.setArrowState();
  }), n.on("destroy", function() {
    a.removeBindings(), a.removeActive(), r.destroy();
  }), a;
}
function xd(e, t, n) {
  var r = new un(), i = {
    /**
     * Binds keyboard events on component mount.
     *
     * @return {Void}
     */
    mount: function() {
      e.settings.keyboard && this.bind();
    },
    /**
     * Adds keyboard press events.
     *
     * @return {Void}
     */
    bind: function() {
      r.on("keyup", document, this.press);
    },
    /**
     * Removes keyboard press events.
     *
     * @return {Void}
     */
    unbind: function() {
      r.off("keyup", document);
    },
    /**
     * Handles keyboard's arrows press and moving glide foward and backward.
     *
     * @param  {Object} event
     * @return {Void}
     */
    press: function(d) {
      var h = e.settings.perSwipe, m = {
        ArrowRight: ">",
        ArrowLeft: "<"
      };
      ["ArrowRight", "ArrowLeft"].includes(d.code) && t.Run.make(t.Direction.resolve("".concat(h).concat(m[d.code])));
    }
  };
  return n.on(["destroy", "update"], function() {
    i.unbind();
  }), n.on("update", function() {
    i.mount();
  }), n.on("destroy", function() {
    r.destroy();
  }), i;
}
function bd(e, t, n) {
  var r = new un(), i = {
    /**
     * Initializes autoplaying and events.
     *
     * @return {Void}
     */
    mount: function() {
      this.enable(), this.start(), e.settings.hoverpause && this.bind();
    },
    /**
     * Enables autoplaying
     *
     * @returns {Void}
     */
    enable: function() {
      this._e = !0;
    },
    /**
     * Disables autoplaying.
     *
     * @returns {Void}
     */
    disable: function() {
      this._e = !1;
    },
    /**
     * Starts autoplaying in configured interval.
     *
     * @param {Boolean|Number} force Run autoplaying with passed interval regardless of `autoplay` settings
     * @return {Void}
     */
    start: function() {
      var d = this;
      this._e && (this.enable(), e.settings.autoplay && fa(this._i) && (this._i = setInterval(function() {
        d.stop(), t.Run.make(">"), d.start(), n.emit("autoplay");
      }, this.time)));
    },
    /**
     * Stops autorunning of the glide.
     *
     * @return {Void}
     */
    stop: function() {
      this._i = clearInterval(this._i);
    },
    /**
     * Stops autoplaying while mouse is over glide's area.
     *
     * @return {Void}
     */
    bind: function() {
      var d = this;
      r.on("mouseover", t.Html.root, function() {
        d._e && d.stop();
      }), r.on("mouseout", t.Html.root, function() {
        d._e && d.start();
      });
    },
    /**
     * Unbind mouseover events.
     *
     * @returns {Void}
     */
    unbind: function() {
      r.off(["mouseover", "mouseout"], t.Html.root);
    }
  };
  return Fe(i, "time", {
    /**
     * Gets time period value for the autoplay interval. Prioritizes
     * times in `data-glide-autoplay` attrubutes over options.
     *
     * @return {Number}
     */
    get: function() {
      var d = t.Html.slides[e.index].getAttribute("data-glide-autoplay");
      return et(d || e.settings.autoplay);
    }
  }), n.on(["destroy", "update"], function() {
    i.unbind();
  }), n.on(["run.before", "swipe.start", "update"], function() {
    i.stop();
  }), n.on(["pause", "destroy"], function() {
    i.disable(), i.stop();
  }), n.on(["run.after", "swipe.end"], function() {
    i.start();
  }), n.on(["play"], function() {
    i.enable(), i.start();
  }), n.on("update", function() {
    i.mount();
  }), n.on("destroy", function() {
    r.destroy();
  }), i;
}
function gs(e) {
  return Fn(e) ? Hu(e) : (Xt("Breakpoints option must be an object"), {});
}
function wd(e, t, n) {
  var r = new un(), i = e.settings, a = gs(i.breakpoints), d = Object.assign({}, i), h = {
    /**
     * Matches settings for currectly matching media breakpoint.
     *
     * @param {Object} points
     * @returns {Object}
     */
    match: function(p) {
      if (typeof window.matchMedia < "u") {
        for (var b in p)
          if (p.hasOwnProperty(b) && window.matchMedia("(max-width: ".concat(b, "px)")).matches)
            return p[b];
      }
      return d;
    }
  };
  return Object.assign(i, h.match(a)), r.on("resize", window, Xr(function() {
    e.settings = Di(i, h.match(a));
  }, e.settings.throttle)), n.on("update", function() {
    a = gs(a), d = Object.assign({}, i);
  }), n.on("destroy", function() {
    r.off("resize", window);
  }), h;
}
var Sd = {
  // Required
  Html: Gu,
  Translate: ud,
  Transition: dd,
  Direction: rd,
  Peek: Xu,
  Sizes: Zu,
  Gaps: qu,
  Move: Ku,
  Clones: Qu,
  Resize: ed,
  Build: Ju,
  Run: Uu,
  // Optional
  Swipe: fd,
  Images: pd,
  Anchors: hd,
  Controls: yd,
  Keyboard: xd,
  Autoplay: bd,
  Breakpoints: wd
}, kd = /* @__PURE__ */ function(e) {
  Iu(n, e);
  var t = Du(n);
  function n() {
    return Yr(this, n), t.apply(this, arguments);
  }
  return Gr(n, [{
    key: "mount",
    value: function() {
      var i = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
      return Mr(Dn(n.prototype), "mount", this).call(this, Object.assign({}, Sd, i));
    }
  }]), n;
}(Wu);
function Td(e) {
  let t, n, r;
  switch (e) {
    case 3:
      t = 1, n = 2, r = 3;
      break;
    case 2:
      t = 1, n = 2, r = 2;
      break;
    case 1:
    default:
      t = 1, n = 1, r = 1;
  }
  return {
    perViewSm: t,
    perViewMd: n,
    perViewLg: r
  };
}
function _d(e = 1, t, n = !0, r) {
  const { perViewSm: i, perViewMd: a, perViewLg: d } = Td(e), h = n ? 24 : 0, m = n ? { before: 48, after: 48 } : 0, p = n ? { before: 124, after: 124 } : 0;
  return {
    type: "slider",
    // No wrap-around.
    focusAt: 0,
    bound: !0,
    // Only if type slider with focusAt 0
    rewind: !1,
    // Only if type slider
    gap: h,
    // Space between slides... may be impacted by viewport size.
    // `keyboard` Left/Right arrow key support for slides - true is default.
    // Is not fully Accessible, on keydown allcarousels move simultaneously
    // A custome keyboard handler is implemented
    keyboard: !1,
    startAt: 0,
    swipeThreshold: 80,
    // Distance required for swipe to change slide.
    dragThreshold: r ? 120 : !1,
    // Distance for mouse drag to change slide.
    perTouch: 1,
    // Number of slides that can be moved per each swipe/drag.
    perView: d,
    // Can be overwritten at breakpoints
    peek: p,
    // Can be overwritten at breakpoints
    // if isFullWidth = true, then we have only 1 image per view which takes the full width.
    // no need for breakpoints
    breakpoints: t ? null : {
      576: {
        // BS4 sm
        perView: i,
        peek: m
      },
      768: {
        // BS4 md
        perView: a,
        peek: m
      },
      992: {
        // BS4 lg
        perView: d,
        peek: m
      },
      1260: {
        // BS4 xl
        perView: d,
        peek: m
      },
      1400: {
        perView: d,
        peek: p
      },
      1920: {
        perView: d,
        peek: p
      }
    }
  };
}
function Ed(e, t, n) {
  const r = e.querySelector(".glide__arrow--prev"), i = e.querySelector(".glide__arrow--next"), a = e.querySelector(".glide__track"), d = e.querySelector(
    ".image-navigator-images"
  );
  if (!(r || i)) return;
  const h = ["slider-start", "slider-mid", "slider-end"], m = "glide__arrow--disabled";
  a == null || a.classList.remove(...h), d == null || d.classList.remove(...h), t === 0 ? (a == null || a.classList.add("slider-start"), d == null || d.classList.add("slider-start"), r == null || r.classList.add(m), r == null || r.setAttribute("aria-disabled", "true"), i == null || i.classList.remove(m), i == null || i.setAttribute("aria-disabled", "false")) : t >= n - 1 ? (a == null || a.classList.add("slider-end"), d == null || d.classList.add("slider-end"), r == null || r.classList.remove(m), r == null || r.setAttribute("aria-disabled", "false"), i == null || i.classList.add(m), i == null || i.setAttribute("aria-disabled", "true")) : (a == null || a.classList.add("slider-mid"), d == null || d.classList.add("slider-mid"), r == null || r.classList.remove(m), i == null || i.classList.remove(m), r == null || r.setAttribute("aria-disabled", "false"), i == null || i.setAttribute("aria-disabled", "false"));
}
function Cd(e, t, n) {
  const r = e.querySelectorAll(".glide__slide"), i = t, a = Math.min(
    r.length - 1,
    t + n - 1
  );
  r.forEach((d, h) => {
    h < i || h > a ? (d.setAttribute("aria-hidden", "true"), d.setAttribute("tabindex", "-1"), d.setAttribute("inert", "")) : (d.setAttribute("aria-hidden", "false"), d.removeAttribute("tabindex"), d.removeAttribute("inert"));
  });
}
function Rd({
  instanceName: e,
  perView: t,
  buttonCount: n,
  isFullWidth: r = !1,
  onItemClick: i,
  hasPeek: a = !0,
  isDraggable: d
}) {
  const h = _d(t, r, a, d), m = new kd(`#${e}`, h);
  let p = document.querySelector(`#${e}`);
  return p.addEventListener("keyup", (b) => {
    const S = b;
    S.keyCode === 39 ? m.go(">") : S.keyCode === 37 ? m.go("<") : S.keyCode === 13 && m.go(document.activeElement.dataset.glideDir);
  }), m.on("build.before", () => {
    p = document.querySelector(`#${e}`), p && p.classList.add("slider-start");
  }), m.on("move", () => {
    if (p = document.querySelector(`#${e}`), !p) return;
    const b = m.index;
    Cd(p, b, t);
    const S = p.querySelector(".navigation-slider"), E = p.querySelector(".image-navigator-images");
    if (S && E) {
      const P = S.querySelectorAll(
        ".bullet-image-container"
      ), A = S.clientWidth, k = 82, N = P[b], j = E.getBoundingClientRect().x, D = S.getBoundingClientRect().x - j, V = N.getBoundingClientRect().x - j, W = N.getBoundingClientRect().x + N.getBoundingClientRect().width - j;
      if (b === 0 || V <= 0 + k)
        S.style.left = `${D - V + k}px`;
      else if (W >= A - k) {
        const M = W - A;
        S.style.left = `${D - M - k}px`;
      }
    }
    Ed(p, b, n), p.setAttribute("data-current-index", b), i && i(b);
  }), m.mount(), m;
}
function Ad(e, t) {
  let n;
  const r = Math.max(
    document.documentElement.clientWidth || 0,
    window.innerWidth || 0
  );
  return n = e, r >= 992 && (t >= 2 && (n = e - 1), t >= 3 && (n = e - 2)), n;
}
const sr = ({
  perView: e = 1,
  width: t,
  maxWidth: n,
  carouselItems: r,
  cssClass: i = "",
  CustomNavComponent: a,
  role: d,
  ariaLabelledBy: h,
  isFullWidth: m,
  removeSideBackground: p = !1,
  hasNavButtons: b = !0,
  hasPositionIndicators: S = !0,
  imageAutoSize: E = !0,
  onItemClick: P = () => null,
  hasPeek: A = !0,
  isDraggable: k = !0,
  hasShadow: N = !0
}) => {
  const j = `glide-${Math.ceil(Math.random() * 1e4)}`, D = Ad(r.length, e);
  return at(() => {
    Rd({
      instanceName: j,
      perView: e,
      buttonCount: D,
      isFullWidth: m,
      onItemClick: P,
      hasPeek: A,
      isDraggable: k
    });
  }, [
    j,
    e,
    D,
    m,
    P,
    A,
    k
  ]), /* @__PURE__ */ f.jsxs(
    "div",
    {
      role: d,
      "aria-labelledby": h,
      className: `glide ${i}`,
      id: j,
      style: { width: t, maxWidth: n },
      "data-remove-side-background": p,
      "data-image-auto-size": E,
      "data-has-shadow": N,
      children: [
        /* @__PURE__ */ f.jsx("div", { className: "glide__track", "data-glide-el": "track", children: /* @__PURE__ */ f.jsx(da, { carouselItems: r }) }),
        a ? (
          // @ts-ignore
          /* @__PURE__ */ f.jsx(a, { instanceName: j })
        ) : /* @__PURE__ */ f.jsxs(f.Fragment, { children: [
          S && /* @__PURE__ */ f.jsx(la, { buttonCount: D }),
          b && /* @__PURE__ */ f.jsx(ua, {})
        ] })
      ]
    }
  );
};
sr.propTypes = {
  perView: l.number,
  width: l.string,
  maxWidth: l.string,
  carouselItems: l.arrayOf(l.object).isRequired,
  cssClass: l.string,
  CustomNavComponent: l.func,
  role: l.string,
  ariaLabelledBy: l.string,
  onItemClick: l.func,
  isFullWidth: l.bool,
  removeSideBackground: l.bool,
  hasNavButtons: l.bool,
  hasPositionIndicators: l.bool,
  imageAutoSize: l.bool,
  hasPeek: l.bool,
  isDraggable: l.bool,
  hasShadow: l.bool
};
const Od = ({
  id: e,
  imageSource: t,
  imageAltText: n,
  title: r,
  content: i,
  eventLocation: a,
  eventTime: d,
  buttons: h,
  linkLabel: m,
  linkUrl: p,
  tags: b
}, S, E, P) => {
  var A;
  return {
    // @ts-ignore
    id: e,
    item: /* @__PURE__ */ f.jsx(
      Yt,
      {
        type: S,
        horizontal: E,
        image: t,
        imageAltText: n,
        title: r,
        body: i,
        eventFormat: P,
        eventLocation: a,
        eventTime: d,
        buttons: h,
        linkLabel: m,
        linkUrl: p || ((A = h == null ? void 0 : h[0]) == null ? void 0 : A.href),
        tags: b
      }
    )
  };
}, ma = ({
  perView: e = 0,
  cardItems: t = [],
  cardType: n = "default",
  cardEventFormat: r = "stack",
  cardHorizontal: i = !1,
  width: a = void 0,
  maxWidth: d = void 0,
  imageAutoSize: h = !0
}) => {
  const m = parseInt(`${e}`, 10), [p, b] = Qe(m), S = 1024, E = 768;
  at(() => {
    const k = () => {
      const N = window.innerWidth;
      let j;
      switch (m) {
        case 3:
          N > S ? j = 3 : N > E ? j = 2 : j = 1;
          break;
        case 2:
          j = N < E ? 1 : 2;
          break;
        default:
          j = 1;
          break;
      }
      b(j);
    };
    return k(), window.addEventListener("resize", k), () => window.removeEventListener("resize", k);
  }, [m]);
  const P = t.map(
    (k) => Od(k, n, i, r)
  ), A = t.length > p;
  return /* @__PURE__ */ f.jsx(
    sr,
    {
      perView: +p,
      maxWidth: d,
      width: a,
      carouselItems: P,
      cssClass: "aligned-carousel",
      imageAutoSize: h,
      removeSideBackground: t.length <= p,
      hasPositionIndicators: A,
      hasNavButtons: A,
      isDraggable: A,
      hasShadow: !0
    }
  );
};
ma.propTypes = {
  perView: l.string.isRequired,
  cardItems: l.arrayOf(
    l.shape({
      title: l.string.isRequired,
      content: l.string,
      eventLocation: l.string,
      eventTime: l.string,
      image: l.string,
      imageAltText: l.string,
      buttons: Yt.propTypes.buttons,
      linkLabel: l.string,
      linkUrl: l.string,
      tags: Yt.propTypes.tags
    })
  ).isRequired,
  cardType: Yt.propTypes.type,
  cardEventFormat: Yt.propTypes.eventFormat,
  cardHorizontal: Yt.propTypes.horizontal,
  width: l.string,
  maxWidth: l.string,
  imageAutoSize: l.bool
};
const jd = ({ id: e, imageSource: t, imageAltText: n, title: r, content: i }) => ({
  // @ts-ignore
  id: e,
  item: /* @__PURE__ */ f.jsx("div", { className: "uds-img", children: /* @__PURE__ */ f.jsxs("figure", { className: "figure uds-figure", children: [
    /* @__PURE__ */ f.jsx(
      "img",
      {
        src: t,
        className: "uds-img figure-img img-fluid",
        alt: n,
        loading: "lazy",
        decoding: "async"
      }
    ),
    (r || i) && /* @__PURE__ */ f.jsx(
      "figcaption",
      {
        className: "figure-caption uds-figure-caption",
        "data-testid": "image-content-container",
        children: /* @__PURE__ */ f.jsx("div", { className: "uds-caption-text", children: r ? /* @__PURE__ */ f.jsxs(f.Fragment, { children: [
          /* @__PURE__ */ f.jsx("h2", { children: r }),
          /* @__PURE__ */ f.jsx("div", { dangerouslySetInnerHTML: { __html: i } })
        ] }) : /* @__PURE__ */ f.jsx("div", { dangerouslySetInnerHTML: { __html: i } }) })
      }
    )
  ] }) })
}), ga = ({
  perView: e = 0,
  imageItems: t = [],
  width: n = void 0,
  maxWidth: r = void 0,
  imageAutoSize: i = !0
}) => {
  if (!t || t.length === 0)
    return null;
  const a = parseInt(`${e}`, 10), d = t.map(jd) || [], h = t.length > a;
  return /* @__PURE__ */ f.jsx(
    sr,
    {
      perView: +a,
      maxWidth: r,
      width: n,
      cssClass: "image-carousel aligned-carousel",
      carouselItems: d,
      imageAutoSize: i,
      removeSideBackground: t.length <= a,
      hasPositionIndicators: h,
      hasNavButtons: h,
      isDraggable: h,
      hasShadow: !0
    }
  );
};
ga.propTypes = {
  perView: l.number.isRequired,
  imageItems: l.arrayOf(l.object).isRequired,
  width: l.string,
  maxWidth: l.string,
  imageAutoSize: l.bool
};
const Nd = (e, t) => {
  if (!e)
    return 0;
  const n = (e.match(/<br/g) || []).length, r = t / 6;
  return (parseInt(`${e.length / r}`, 10) + n) * 20;
}, Vr = {
  imageItems: l.arrayOf(
    l.shape({
      id: l.number,
      imageSource: l.string,
      thumbnailSource: l.string,
      imageAltText: l.string,
      content: l.oneOfType([l.string, l.element])
    })
  ),
  hasContent: l.bool
}, Id = ({ id: e, imageSource: t, imageAltText: n }) => ({
  // @ts-ignore
  id: e,
  item: /* @__PURE__ */ f.jsx("div", { className: "uds-img", children: /* @__PURE__ */ f.jsx(
    "img",
    {
      src: t,
      className: "uds-img figure-img img-fluid",
      alt: n,
      loading: "lazy",
      decoding: "async"
    }
  ) })
}), va = ({ instanceName: e, imageItems: t, hasContent: n }) => {
  var b, S;
  const r = "data-current-index", [i, a] = Qe(((b = t == null ? void 0 : t[0]) == null ? void 0 : b.title) || ""), [d, h] = Qe(((S = t == null ? void 0 : t[0]) == null ? void 0 : S.content) || ""), m = In(
    (E) => {
      const P = t == null ? void 0 : t[E];
      P && (a(P.title), h(P.content));
    },
    [t]
  );
  if (at(() => {
    if (!t || t.length === 0)
      return;
    const E = document.querySelector(
      ".image-gallery figcaption .uds-caption-text div"
    );
    if (E) {
      const N = parseInt(
        window.getComputedStyle(E, null).getPropertyValue("width").split("px")[0],
        10
      ), j = t.reduce((D, V) => {
        const W = Nd(V.content, N);
        return W > D ? W : D;
      }, 0);
      E.style.height = `${j}px`;
    }
    const P = document.querySelector(`#${e}`);
    if (!P)
      return;
    function A(N) {
      for (const j of N)
        if (j && j.attributeName === r) {
          const D = P.getAttribute(r);
          D !== null && m(+D);
          return;
        }
    }
    const k = new MutationObserver(A);
    return k.observe(P, {
      attributes: !0
    }), () => {
      k.disconnect();
    };
  }, [e, t, m]), !t || t.length === 0)
    return null;
  const p = t.map((E) => E.imageSource);
  return /* @__PURE__ */ f.jsxs("div", { className: "image-gallery-action-area", "data-has-content": n, children: [
    /* @__PURE__ */ f.jsx("div", { className: "image-navigator", children: /* @__PURE__ */ f.jsxs(no, { children: [
      /* @__PURE__ */ f.jsx(to, {}),
      /* @__PURE__ */ f.jsx("div", { className: "image-navigator-images", children: /* @__PURE__ */ f.jsx("div", { className: "navigation-slider", children: /* @__PURE__ */ f.jsx(
        ca,
        {
          imageItems: p,
          onItemClick: (E) => m(E)
        }
      ) }) }),
      /* @__PURE__ */ f.jsx(eo, {})
    ] }) }),
    n && (i || d) ? /* @__PURE__ */ f.jsx(
      "figcaption",
      {
        id: "caption",
        className: "figure-caption uds-figure-caption",
        "data-testid": "image-gallery-content-container",
        children: /* @__PURE__ */ f.jsxs("div", { className: "uds-caption-text", children: [
          i ? /* @__PURE__ */ f.jsx("h2", { children: i }) : null,
          /* @__PURE__ */ f.jsx("div", { dangerouslySetInnerHTML: { __html: d } })
        ] })
      }
    ) : null
  ] });
};
va.propTypes = {
  instanceName: l.string,
  imageItems: Vr.imageItems,
  hasContent: Vr.hasContent
};
const ya = ({
  width: e,
  maxWidth: t,
  imageItems: n = [],
  hasContent: r = !1,
  imageAutoSize: i = !0
}) => {
  const a = n.map(Id), d = n.length > 1;
  return /* @__PURE__ */ f.jsx(
    sr,
    {
      perView: 1,
      maxWidth: t,
      width: e,
      carouselItems: a,
      cssClass: "image-gallery",
      role: "figure",
      ariaLabelledBy: r ? "caption" : null,
      isFullWidth: !0,
      imageAutoSize: i,
      hasPeek: !1,
      CustomNavComponent: ({ instanceName: h }) => /* @__PURE__ */ f.jsx(
        va,
        {
          instanceName: h,
          hasContent: r,
          imageItems: n
        }
      ),
      removeSideBackground: n.length <= 1,
      hasPositionIndicators: d,
      hasNavButtons: d,
      isDraggable: d,
      hasShadow: !0
    }
  );
};
ya.propTypes = {
  imageItems: Vr.imageItems.isRequired,
  hasContent: Vr.hasContent,
  width: l.string,
  maxWidth: l.string,
  imageAutoSize: l.bool
};
const Pd = ({ id: e, imageSource: t, imageAltText: n, quote: r }, i = {}) => ({
  // @ts-ignore
  id: e,
  item: /* @__PURE__ */ f.jsx(
    Ji,
    {
      imageSource: t,
      imageAltText: n,
      quote: r,
      itemStyle: i
    }
  )
}), xa = ({
  width: e,
  maxWidth: t,
  testimonialItems: n = [],
  itemStyle: r = {},
  hasNavButtons: i = !1,
  hasPositionIndicators: a = !1,
  imageAutoSize: d = !0
}) => {
  const h = n.map(
    (m) => Pd(m, r)
  );
  return /* @__PURE__ */ f.jsx(
    sr,
    {
      perView: 1,
      maxWidth: t,
      width: e,
      carouselItems: h,
      isFullWidth: !0,
      removeSideBackground: !0,
      hasNavButtons: i,
      hasPositionIndicators: a,
      imageAutoSize: d,
      hasPeek: !1,
      hasShadow: !1
    }
  );
};
xa.propTypes = {
  testimonialItems: l.arrayOf(
    l.shape({
      title: l.string,
      content: l.string,
      cite: l.shape({
        name: l.string,
        description: l.string
      })
    })
  ).isRequired,
  itemStyle: l.shape({
    containerCssClass: l.arrayOf(l.string),
    titleCssClass: l.arrayOf(l.string),
    contentCssClass: l.arrayOf(l.string)
  }),
  width: l.string,
  maxWidth: l.string,
  imageAutoSize: l.bool,
  hasNavButtons: l.bool,
  hasPositionIndicators: l.bool
};
var $t = /* @__PURE__ */ ((e) => (e.UNORDERED = "unordered", e.ORDERED = "ordered", e.ICON = "icon", e.STEP = "step", e.DISPLAY = "display", e))($t || {}), Dr = /* @__PURE__ */ ((e) => (e.UL = "ul", e.OL = "ol", e))(Dr || {}), _n = /* @__PURE__ */ ((e) => (e.NONE = "none", e.LIGHT = "light", e.MEDIUM = "medium", e.DARK = "dark", e))(_n || {}), Fr = /* @__PURE__ */ ((e) => (e.DEFAULT = "default", e.PRIMARY = "primary", e.SECONDARY = "secondary", e))(Fr || {});
const ba = (e) => {
  switch (e) {
    case Dr.OL:
    case $t.ORDERED:
    case $t.STEP:
      return Dr.OL;
    default:
      return Dr.UL;
  }
}, wa = ({
  listType: e,
  content: t,
  icon: n,
  nestedType: r,
  nestedItems: i
}) => {
  const [a, ...d] = Array.isArray(t) ? t : [t];
  let h = null;
  if (i != null && i.length) {
    const m = r || e, p = ba(m);
    h = /* @__PURE__ */ f.jsx(p, { children: i.map((b, S) => /* @__PURE__ */ f.jsx(wa, { listType: m, ...b }, S)) });
  }
  return /* @__PURE__ */ f.jsxs("li", { children: [
    n && /* @__PURE__ */ f.jsx("span", { className: `fa-li ${n == null ? void 0 : n[0]} fa-${n == null ? void 0 : n[1]}` }),
    a,
    " ",
    d.map((m, p) => [/* @__PURE__ */ f.jsx("br", {}, `br-${p}`), /* @__PURE__ */ f.jsx("span", { children: m }, p)]),
    h
  ] });
}, Ld = ({
  listType: e = $t.UNORDERED,
  backgroundColor: t = _n.NONE,
  listItemStyleColor: n = Fr.DEFAULT,
  items: r
}) => {
  const i = ba(e);
  let a = "maroon", d = "maroon";
  t === _n.DARK && (a = "gold", d = "gold"), e === $t.STEP && (a = "uds-steplist-maroon", d = "uds-steplist-gold", t === _n.DARK && (a = "uds-steplist-gold"));
  const h = ve({
    "uds-list": e === $t.UNORDERED || e === $t.ORDERED,
    "uds-list fa-ul": e === $t.ICON,
    "uds-list uds-steplist": e === $t.STEP,
    "uds-list uds-display-list": e === $t.DISPLAY,
    "light-smokemode": t === _n.LIGHT,
    smokemode: t === _n.MEDIUM,
    darkmode: t === _n.DARK,
    [`${a}`]: n === Fr.PRIMARY,
    // Intentional space ` ${secondaryColor}` for when primary and secondary colors are the same
    [` ${d}`]: n === Fr.SECONDARY
  });
  return /* @__PURE__ */ f.jsx(i, { className: h || null, children: r.map((m, p) => /* @__PURE__ */ f.jsx(wa, { listType: e, ...m }, p)) });
}, Md = {
  none: "",
  gold: "text-gold",
  white: "text-white"
}, Dd = {
  name: "onclick",
  event: "link",
  action: "click",
  type: "internal link",
  region: "main content"
}, Fd = ({
  gridLinkItems: e,
  numColumns: t,
  textColor: n,
  children: r
}) => /* @__PURE__ */ f.jsxs(f.Fragment, { children: [
  /* @__PURE__ */ f.jsx(
    "div",
    {
      className: [
        "uds-grid-links",
        t,
        Md[n]
      ].join(" "),
      children: e && e.map((i) => /* @__PURE__ */ f.jsx(
        Ze,
        {
          gaData: {
            ...Dd,
            text: i.label,
            section: `grid links ${i.label}`
          },
          children: /* @__PURE__ */ f.jsxs("a", { href: i.href, children: [
            /* @__PURE__ */ f.jsx("span", { className: `fa fa-fw ${i.icon}` }),
            i.label
          ] })
        },
        i.label + i.href
      ))
    }
  ),
  /* @__PURE__ */ f.jsx("div", { children: r })
] });
var io, vs = Ma;
io = vs.createRoot, vs.hydrateRoot;
const $d = (e, t, n) => {
  io(n).render(He.createElement(e, t));
}, Kr = ({ typeCarousel: e, targetSelector: t, props: n }) => {
  const i = {
    card: ma,
    testimonial: xa,
    image: ga,
    "image-gallery": ya
  }[e];
  i && $d(i, n, document.querySelector(t));
}, Vd = ({ targetSelector: e, props: t }) => Kr({
  typeCarousel: "card",
  targetSelector: e,
  props: t
}), Wd = ({ targetSelector: e, props: t }) => {
  Kr({
    typeCarousel: "testimonial",
    targetSelector: e,
    props: t
  });
}, Ud = ({ targetSelector: e, props: t }) => {
  Kr({ typeCarousel: "image", targetSelector: e, props: t });
}, qd = ({ targetSelector: e, props: t }) => {
  Kr({
    typeCarousel: "image-gallery",
    targetSelector: e,
    props: t
  });
}, We = (e, t, n) => {
  io(n).render(He.createElement(e, t));
}, Yd = ({ targetSelector: e, props: t }) => We(Os, t, document.querySelector(e)), Gd = ({ targetSelector: e, props: t }) => We(Ws, t, document.querySelector(e)), Xd = ({ targetSelector: e, props: t }) => We(Ys, t, document.querySelector(e)), Kd = ({ targetSelector: e, props: t }) => We(an, t, document.querySelector(e)), Zd = ({ targetSelector: e, props: t }) => We(Xi, t, document.querySelector(e)), Jd = ({ targetSelector: e, props: t }) => We(Ki, t, document.querySelector(e)), Qd = ({ targetSelector: e, props: t }) => We(Yt, t, document.querySelector(e)), ef = ({ targetSelector: e, props: t }) => We(Js, t, document.querySelector(e)), tf = ({ targetSelector: e, props: t }) => We(Qs, t, document.querySelector(e)), nf = ({ targetSelector: e, props: t }) => We(Fd, t, document.querySelector(e)), rf = ({ targetSelector: e, props: t }) => We(na, t, document.querySelector(e)), of = ({ targetSelector: e, props: t }) => We(En, t, document.querySelector(e)), sf = ({ targetSelector: e, props: t }) => We(ra, t, document.querySelector(e)), af = ({ targetSelector: e, props: t }) => We(Zi, t, document.querySelector(e)), lf = ({ targetSelector: e, props: t }) => We(sa, t, document.querySelector(e)), cf = ({ targetSelector: e, props: t }) => We(Ji, t, document.querySelector(e)), uf = ({ targetSelector: e, props: t }) => We(aa, t, document.querySelector(e)), df = ({ targetSelector: e, props: t }) => We(wu, t, document.querySelector(e)), ff = ({ targetSelector: e, props: t }) => We(iu, t, document.querySelector(e)), pf = ({ targetSelector: e, props: t }) => We(Eu, t, document.querySelector(e)), hf = ({ targetSelector: e, props: t }) => We(Ld, t, document.querySelector(e)), mf = ({ targetSelector: e, props: t }) => We(yu, t, document.querySelector(e));
export {
  Os as Accordion,
  Ws as AnchorMenu,
  Ys as Article,
  an as Button,
  Xi as ButtonIconOnly,
  Ki as ButtonTag,
  Yt as Card,
  Js as CardArrangement,
  ma as CardCarousel,
  Qs as ContentSpotlight,
  iu as Divider,
  ru as DividerType,
  hu as FeedBody,
  cu as FeedContainerProvider,
  lu as FeedContext,
  pu as FeedHeader,
  Fd as GridLinks,
  na as Hero,
  yu as HighlyRanked,
  En as Image,
  ga as ImageCarousel,
  ya as ImageGalleryCarousel,
  Ld as List,
  ia as NavControls,
  ra as Pagination,
  Zi as RankingCard,
  wu as SystemAlert,
  bu as SystemAlertType,
  Tu as Tab,
  oa as TabHeader,
  sa as TabbedPanels,
  Ji as Testimonial,
  xa as TestimonialCarousel,
  Eu as Tooltip,
  aa as Video,
  Hd as feedCardButtonShape,
  du as feedComponentShape,
  ta as feedCtaButtonShape,
  uu as feedDataSourceShape,
  ea as feedHeaderShape,
  Yd as initAccordion,
  Gd as initAnchorMenu,
  Xd as initArticle,
  Kd as initButton,
  Zd as initButtonIconOnly,
  Jd as initButtonTag,
  Qd as initCard,
  ef as initCardArrangement,
  Vd as initCardCarousel,
  tf as initContentSpotlight,
  ff as initDivider,
  nf as initGridLinks,
  rf as initHero,
  mf as initHighlyRanked,
  of as initImage,
  Ud as initImageCarousel,
  qd as initImageGalleryCarousel,
  hf as initList,
  sf as initPagination,
  af as initRankingCard,
  df as initSystemAlert,
  lf as initTabbedPanels,
  cf as initTestimonial,
  Wd as initTestimonialCarousel,
  pf as initTooltip,
  uf as initVideo
};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
/*! @license DOMPurify 3.3.2 | (c) Cure53 and other contributors | Released under the Apache license 2.0 and Mozilla Public License 2.0 | github.com/cure53/DOMPurify/blob/3.3.2/LICENSE */
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
/**
 * @license React
 * react-dom-server-legacy.browser.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
/**
 * @license React
 * react-dom-server.browser.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
/**
 * @license React
 * react-is.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
/*!
 * Glide.js v3.6.2
 * (c) 2013-2024 Jędrzej Chałubek (https://github.com/jedrzejchalubek/)
 * Released under the MIT License.
 */

(function() {
                var css = `@charset "UTF-8";.glide{position:relative;width:100%;box-sizing:border-box}.glide *{box-sizing:inherit}.glide__track{overflow:hidden}.glide__slides{position:relative;width:100%;list-style:none;backface-visibility:hidden;transform-style:preserve-3d;touch-action:pan-Y;overflow:hidden;margin:0;padding:0;white-space:nowrap;display:flex;flex-wrap:nowrap;will-change:transform}.glide__slides--dragging{-webkit-user-select:none;user-select:none}.glide__slide{width:100%;height:100%;flex-shrink:0;white-space:normal;-webkit-user-select:none;user-select:none;-webkit-touch-callout:none;-webkit-tap-highlight-color:transparent}.glide__slide a{-webkit-user-select:none;user-select:none;-webkit-user-drag:none;-moz-user-select:none;-ms-user-select:none}.glide__arrows,.glide__bullets{-webkit-touch-callout:none;-webkit-user-select:none;user-select:none}.glide--rtl{direction:rtl}@media only screen and (min-width: 1260px){.container .aligned-carousel{margin-left:-124px!important}}.glide{display:flex;flex-direction:column;gap:32px;position:relative}[data-image-auto-size=true] .glide__slides .glide__slide{height:auto;position:relative;display:inline-flex;justify-content:center}[data-image-auto-size=true] .glide__slides .glide__slide>div.uds-img{display:flex;width:100%;max-width:100%}[data-image-auto-size=true] .glide__slides .glide__slide>div.uds-img img{flex-grow:1;object-fit:cover}[data-image-auto-size=true] .glide__slides .glide__slide>div.uds-img img.uds-img{max-width:100%}[data-image-auto-size=true] .glide__slides .glide__slide>div.uds-img figure.uds-figure{display:flex;justify-content:space-between;flex-direction:column}.glide .glide__track{position:relative}.glide .glide__track .glide__slides{margin-bottom:0;touch-action:auto}.glide .glide__track .glide__slides .glide__slide .card{width:100%}@media only screen and (min-width: 576px){.glide[data-has-shadow=true] .glide__track.slider-start:after{background:linear-gradient(to left,#19191933,48px,#fff0 96px);content:" ";height:100%;position:absolute;pointer-events:none;width:100%;top:0}.glide[data-has-shadow=true] .glide__track.slider-mid:after{background:linear-gradient(to right,#19191933,48px,#fff0 96px),linear-gradient(to left,#19191933,48px,#fff0 96px);content:" ";height:100%;position:absolute;pointer-events:none;width:100%;top:0}.glide[data-has-shadow=true] .glide__track.slider-end:after{background:linear-gradient(to right,#19191933,48px,#fff0 96px);content:" ";height:100%;position:absolute;pointer-events:none;width:100%;top:0}}.glide__arrows{z-index:2;align-self:center}.glide__arrows .glide__arrow{color:#191919;width:4rem;height:4rem;margin:0 .5rem;background-color:#e8e8e8;border:1px solid #d0d0d0;border-radius:50%;font-size:1.3rem;text-shadow:0 .25em .5em rgba(0,0,0,.1);opacity:1;cursor:pointer;transition:opacity .15s ease,border .3s ease-in-out;line-height:1}.glide__arrows .glide__arrow.glide__arrow--disabled{color:#e8e8e8;background-color:#fafafa;border:1px solid #e8e8e8;opacity:1}.glide__arrows .glide__arrow:focus{outline:none}.glide__arrows .glide__arrow:hover{border-color:#fff}.glide__arrows .glide__arrow--left{left:2em}.glide__arrows .glide__arrow--right{right:2em}.glide__arrows .glide__arrow--disabled{opacity:.33}.glide__bullets{z-index:2;list-style:none;max-width:100%;display:flex;justify-content:center}.glide__bullet{transition:all .3s ease-in-out;background-color:#d0d0d0;width:1rem;height:1rem;padding:0;border-radius:50%;border:2px solid transparent;cursor:pointer;line-height:0;margin:.375rem}.glide__bullet:focus{outline:none}.glide__bullet:hover,.glide__bullet:focus{border:1px solid #d0d0d0;background-color:#191919}.glide__bullet--active{background-color:#191919}.glide.aligned-carousel{width:1448px;margin:auto}.glide.image-gallery{gap:0;overflow:hidden}.glide.image-gallery .glide__track{border:1px solid #d0d0d0}.glide.image-gallery .glide__track:after{content:none}.glide.image-gallery .glide__track .glide__slides{margin-bottom:0;height:100%}.glide.image-gallery .glide__track .glide__slides li.glide__slide{display:list-item}.glide.image-gallery .glide__track .glide__slides .glide__slide>div.uds-img{height:100%}.glide.image-gallery .glide__track .glide__slides .glide__slide>div.uds-img img{object-fit:cover;border:none}.glide.image-gallery .image-gallery-action-area{border:1px solid #d0d0d0;border-top:0}.glide.image-gallery .image-gallery-action-area[data-has-content=true] .image-navigator{border-bottom:1px solid #d0d0d0}.glide.image-gallery .image-gallery-action-area[data-has-content=true] .uds-caption-text{padding:1rem 0;display:inline-block}.glide.image-gallery .image-gallery-action-area[data-has-content=true] .uds-caption-text>div{height:auto!important}.glide.image-gallery figcaption{padding:0 .75rem;font-size:.75rem}.glide.image-gallery figcaption h2{font-size:1.5rem;line-height:1.75rem;letter-spacing:-.0525rem}.glide.image-gallery .image-navigator{position:relative}.glide.image-gallery .image-navigator .image-navigator-images{min-height:64px;padding-top:1rem;padding-bottom:1rem;width:100%;margin:auto;overflow:hidden}.glide.image-gallery .image-navigator .image-navigator-images.slider-start:after{background:linear-gradient(to left,#19191933,48px,#fff0 96px);content:" ";height:100%;position:absolute;pointer-events:none;width:100%;top:0}.glide.image-gallery .image-navigator .image-navigator-images.slider-mid:after{background:linear-gradient(to right,#19191933,48px,#fff0 96px),linear-gradient(to left,#19191933,48px,#fff0 96px);content:" ";height:100%;position:absolute;pointer-events:none;width:100%;top:0}.glide.image-gallery .image-navigator .image-navigator-images.slider-end:after{background:linear-gradient(to right,#19191933,48px,#fff0 96px);content:" ";height:100%;position:absolute;pointer-events:none;width:100%;top:0}.glide.image-gallery .image-navigator .image-navigator-images .navigation-slider{position:relative;left:0}.glide.image-gallery .image-navigator .image-navigator-images .navigation-slider .glide__bullets{position:relative}.glide.image-gallery .image-navigator .image-navigator-images .navigation-slider .glide__bullets .bullet-image-container{position:relative;margin:0 .5rem;height:48px;border:0;padding:0}.glide.image-gallery .image-navigator .image-navigator-images .navigation-slider .glide__bullets .bullet-image-container:first-child{margin-left:16rem}.glide.image-gallery .image-navigator .image-navigator-images .navigation-slider .glide__bullets .bullet-image-container .bullet-image{flex-basis:auto;width:88px;height:100%;border-radius:0;border:0;z-index:2;object-fit:cover;margin:0}.glide.image-gallery .image-navigator .image-navigator-images .navigation-slider .glide__bullets .bullet-image-container:focus{box-shadow:0 0 0 2px #fff,0 0 0 4px #191919!important}.glide.image-gallery .image-navigator .image-navigator-images .navigation-slider .glide__bullets .glide__bullet--active{background-color:transparent;border:5px solid #ffc627}.glide.image-gallery .image-navigator .glide__arrows{width:100%;display:flex;justify-content:space-between;align-items:center}.glide.image-gallery .image-navigator .glide__arrows .glide__arrow{width:2.5rem;height:2.5rem;display:flex;align-items:center;justify-content:center;z-index:3;position:absolute;background-color:#fff}.glide.image-gallery .image-navigator .glide__arrows .glide__arrow:hover{border-color:#d0d0d0}.glide.image-gallery .image-navigator .glide__arrows .glide__arrow .arrow-icon{font-size:1rem}.glide.image-gallery .image-navigator .glide__arrows .glide__arrow.glide__arrow--prev{left:0}.glide.image-gallery .image-navigator .glide__arrows .glide__arrow.glide__arrow--next{right:0}@media only screen and (max-width: 576px){.glide{gap:21px}.glide:not(.glide.image-gallery) .glide__bullets{display:none}.glide.image-gallery{width:100%;margin:auto!important}.glide.image-gallery .image-navigator .image-navigator-images .glide__arrows .glide__arrow{display:none}}@media only screen and (max-width: 1260px){.glide.aligned-carousel{width:100%}}.glide--swipeable{cursor:grab;cursor:-moz-grab;cursor:-webkit-grab}.glide--dragging{cursor:grabbing;cursor:-moz-grabbing;cursor:-webkit-grabbing}.glide[data-remove-side-background=true]:after,.glide[data-remove-side-background=true]:before{content:none}.glide button:focus,.glide a:focus,.glide input:focus,.glide textarea:focus,.glide select:focus{outline:none!important;box-shadow:0 0 0 2px #fff,0 0 0 4px #191919!important}.glide.image-gallery,.glide.image-carousel{margin:auto}.glide.image-gallery[role=figure],.glide.image-gallery figure.uds-figure,.glide.image-carousel[role=figure],.glide.image-carousel figure.uds-figure{margin:0}.glide.image-gallery[role=figure] figcaption *,.glide.image-gallery[role=figure] .uds-caption-text,.glide.image-gallery figure.uds-figure figcaption *,.glide.image-gallery figure.uds-figure .uds-caption-text,.glide.image-carousel[role=figure] figcaption *,.glide.image-carousel[role=figure] .uds-caption-text,.glide.image-carousel figure.uds-figure figcaption *,.glide.image-carousel figure.uds-figure .uds-caption-text{color:#191919;max-width:100%}
`;
                var style = document.createElement('style');
                style.type = 'text/css';
                if (style.styleSheet) {
                  style.styleSheet.cssText = css;
                } else {
                  style.appendChild(document.createTextNode(css));
                }
                document.head.appendChild(style);
              })();